<template>
  <div class="tab-pane active" id="estimates-table" role="tabpanel">
    <div v-if="isMobile" class="nav-chevron-block">
      <div :class="{ 'active': tabsArrowLeftVisible }"><i class='bx bx-chevron-left'></i></div>
      <div :class="{ 'active': tabsArrowRigthVisible }"><i class='bx bx-chevron-right'></i></div>
    </div>
    <div class="tabs-component tabs-component-2" :class="{'is-mobile': isMobile}" @scroll="isArrowActive">
      <!-- <div class="navbar navbar-light bg-grey navbar-bottom-line b-a mb-2"> -->
      <ul class="nav nav-tabs nav-tabs-2 float-sm-left">
        <li @click.prevent="selectCard('RR')" class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'RR'}">RR</a>
        </li>
        <li @click.prevent="selectCard('Repair')" class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Repair'}">Repair</a>
        </li>
        <li @click.prevent="selectCard('Paint')" class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Paint'}">Paint</a>
        </li>
        <li @click.prevent="selectCard('Part')" class="tabs-component-tab nav-item"
            :class="{'with-ps-logo': isReceivedUpdateFromRS}">
          <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Part'}">Parts</a>
          <div v-if="isReceivedUpdateFromRS" class="part-ps-logo"></div>
        </li>
        <li @click.prevent="selectCard('Materials')" class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link"
             :class="{'active': selectedCard == 'Materials'}">Materials</a>
        </li>
        <li @click.prevent="selectCard('Sublet')" class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Sublet'}">Sublet</a>
        </li>
        <li @click.prevent="selectCard('Other')" class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Other'}">Other</a>
        </li>
        <li @click.prevent="selectCard('PDR')" class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'PDR'}">PDR</a>
        </li>
        <li v-if="isViewRunDamageAssmnt && isAiResInEstimate"
            @click.prevent="selectCard('Assessment')"
            class="tabs-component-tab nav-item">
          <a href="" class="tabs-component-tab-a nav-link" style="margin-right: 30px"
             :class="{'active': selectedCard == 'Assessment'}">Assessment</a>
        </li>
        <!-- <li class="tabs-component-tab nav-item search-parts" :class="{'px-0 py-0': true, 'magic-search-box': magicSearchEnabled}">
                     <input v-model="magicSearchTerm" v-on:focus="magicSearchEnabled = true" v-on:blur="magicSearchEnabled = false" type="text" class="b-a-0"
                            style="height: 2.5rem;width: 5.5rem;padding: 0.5rem;font-weight:normal"
                            :placeholder="magicSearchEnabled ? 'Search in ' + selectedCard : 'Search'">
                     <i class="ti-search text-primary" style="position: absolute;top: 0.65rem;right: 0.5em;"></i>
                 </li>
                 -->
        <!--                                                    <li class="tabs-component-tab nav-item">-->
        <!--                                                        <div class="btn-group cards-view-button" role="group">-->
        <!--                                                            <button type="button" class="btn btn-primary active">Table</button>-->
        <!--                                                            <button type="button" class="btn">Board</button>-->
        <!--                                                        </div>-->
        <!--                                                    </li>-->
        <div class="d-flex">
          <div v-if="!isMobile && false" class="tab-header view-header-buttons">
            <div class="btn-group cards-view-button" role="group">
              <button @click="isActiveButterflyBody=false" type="button" class="btn "
                      :class="{'btn-primary':!isActiveButterflyBody||!isActiveButterfly, 'active':!isActiveButterflyBody||!isActiveButterfly }">
                Standard
              </button>
              <button @click="isActiveButterflyBody=true" type="button" class="btn"
                      :class="{'btn-primary':isActiveButterflyBody&& isActiveButterfly, 'active':isActiveButterflyBody&&isActiveButterfly }"
                      :disabled="!isActiveButterfly">Body
              </button>
            </div>
          </div>

          <div v-if="estimate.partssearch && estimate.partssearch.rfqId && !isMobile">
            <button type="button" :class="{active: isShowOrders}" @click="switchOrdersVisibility"
                    class="tab-header-orders btn">
              ORDERS
            </button>
          </div>
        </div>
      </ul>

      <div v-if="isInsuranceRepairYes && !isMobile && !isBlockByAuda" class="right-col"
           style="display: inline-block; float: right">
        <div class="d-flex block-position-wrap">
          <div v-if="isFromIag" class="form-group row d-flex">
            <label style="padding-left: 15px !important; min-width: 74px !important; text-align: right !important;"
                   class="col-sm-3 col-form-label">Auth</label>
            <div class="col-sm-9 pr-0 date-picker-max-width-100px">
              <input v-model="estimate.auth" class="form-control" disabled readonly/>
            </div>
          </div>
          <div v-if="isFromIag" class="form-group row d-flex">
            <label style="padding-left: 15px !important; min-width: 74px !important; text-align: right !important;"
                   class="col-sm-3 col-form-label">Date Auth</label>
            <div class="col-sm-9 pr-0 date-picker-max-width-100px">
              <date-picker v-model="estimate.authorityDate"
                           place-holder-text="dd/mm/yy"
                           @onChange="saveAuthDate"
                           :isDisabled="isFromIag"
              ></date-picker>
            </div>
          </div>
          <div class="form-group row d-flex">
            <label style="min-width: 50px !important; text-align: right !important;"
                   class="col-sm-3 col-form-label">PAV</label>
            <div class="col-sm-9 pr-0">
                            <span class="form-control form-control-mobile-position"
                                  style="width: 110px; min-width: 110px; display: inline; line-height: 32px;">{{
                                insurance.pav|formatMoney
                              }}</span>
            </div>
          </div>
          <div class="form-group row d-flex">
            <label style="padding-left: 15px !important; min-width: 66px !important; text-align: right !important;"
                   class="col-sm-3 col-form-label">Subtotal</label>
            <div class="col-sm-9 pr-0">
                            <span class="form-control form-control-mobile-position"
                                  style="width: 110px; min-width: 110px; display: inline; line-height: 32px;">{{
                                calculatedSubtotal|formatMoney
                              }}</span>
            </div>
          </div>
          <div class="form-group row d-flex pl-1" style="align-items: center; height: 32px;">
            <label style="min-width: 74px; text-align: right;" class="col-sm-2 col-form-label">ADJ Subtotal</label>
            <div class="col-sm-9 pr-0 d-flex">
                <span
                    :style="{color: calculatedAdjSubtotal > calculatedSubtotal ? '#2BAE66FF': 'red'}"
                    class="form-control form-control-mobile-position  "
                    style="min-width: 90px; display: inline; line-height: 16px;height: 32px;">
                  <template v-if="calculatedAdjSubtotal>0 && calculatedAdjSubtotal != calculatedSubtotal">{{
                      calculatedAdjSubtotal|formatMoney
                    }}</template>
                  <template v-else>&nbsp;</template>
                </span>
              <span
                  :style="{color: calculatedAdjSubtotal > calculatedSubtotal ? '#2BAE66FF': 'red'}"
                  class="form-control form-control-mobile-position"
                  style="min-width: 70px; display: inline; line-height: 16px; margin-left: 5px;height: 32px;">
                <template v-if="calculatedAdjSubtotal>0 && calculatedAdjSubtotal != calculatedSubtotal">{{
                    calculatedAdjSubtotalPercent
                  }}%</template>
                <template v-else>&nbsp;</template>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- </div> -->
    </div>

    <div class="row mt-1" :class="{'no-gutter': isMobile}" v-if="!isShowOrders && selectedCard !== 'Assessment'">
      <div v-if="!isMobileOnly() || selectedCard === 'PDR'" :class="selectedCard === 'PDR' ? 'col-md-2' : 'col-md-4'"
           style="padding-right: 0px;">
        <div class="row">
          <div v-if="selectedCard !== 'PDR'" class="col-md-6" style="padding-left: 0px;padding-right: 0px;">

            <div class="box">
              <ul class="nav nav-4 vh-height-65" :class="{'mx-1': isMobile }">
                <li :class="{'nav-item': true, 'magic-search-box': magicSearchEnabled}"
                    style="border: 1px solid black; border-radius: 6px 1px 1px">
                  <div>
                    <input v-model="magicSearchCardPart" type="text" class="nav-link search-input"
                           style="height: 3rem;font-weight:normal; border:none !important;"
                           :placeholder="'Search'">

                  </div>
                </li>
                <li v-for="cp in cardParts" :class="{'nav-item': true, 'active': selectedCardPart == cp}">
                  <a class="nav-link" @click.prevent="selectCardPart(cp)" @dblclick.prevent="addCardPart(cp)" href="#">{{
                      cp
                    }}
                    <div class="float-xs-right"><i class="fa fa-angle-right"></i></div>
                  </a></li>
              </ul>
            </div>
          </div>
          <div :class="selectedCard === 'PDR' ? 'col-md-12' : 'col-md-6'"
               style="padding-left: 0px!important;    padding-right: 0px!important;">
            <div class="box card-sub-parts-column" v-show="!isMobile">
              <ul class="nav nav-4 vh-height-65" :class="{'mx-1': isMobile }">
                <li :class="{'nav-item': false, 'magic-search-box': magicSearchEnabled}"
                    style="border: 1px solid black; border-radius: 6px 6px 1px 1px">
                  <div>
                    <input v-model="magicSearchSubCardPart" type="text" class="nav-link search-input"
                           style="height: 3rem;font-weight:normal; border:none !important;"
                           :placeholder="'Search'">

                  </div>
                </li>
                <li v-if="selectedCard === 'PDR'" class="border-top-groups">
                                                                <span class="nav-link new-estimate-item clickable"
                                                                      @click.prevent="selectCardSubPart({type:'Panel'})"><i
                                                                    class="ti-plus"></i>New Panel
                                                                </span>
                </li>
                <li v-if="selectedCard === 'PDR'" class="border-top-groups"
                    :class="{'border-bottom-groups': !cardSubParts.length && !(!currentGroupCategory.length && selectedCard === 'RR' && selectedCardPart && !isShowInsertNameGRP)}">
                                                                <span class="nav-link new-estimate-item clickable"
                                                                      @click.prevent="selectCardSubPart({type:'Item'})"><i
                                                                    class="ti-plus"></i>New Item
                                                                </span>
                </li>
                <li v-if="selectedCard === 'Materials'" class="border-top-groups"
                    :class="{'border-bottom-groups': !cardSubParts.length && !(!currentGroupCategory.length && selectedCard === 'RR' && selectedCardPart && !isShowInsertNameGRP)}">
                                                                <span class="nav-link new-estimate-item clickable"
                                                                      @click.prevent="selectCardSubPart({isNewItem: false})"><i
                                                                    class="ti-plus"></i>New Item
                                                                </span>
                </li>
                <li v-else-if="selectedCard !== 'PDR'" class="border-top-groups"
                    :class="{'border-bottom-groups': !cardSubParts.length && !(!currentGroupCategory.length && selectedCard === 'RR' && selectedCardPart && !isShowInsertNameGRP)}">
                                                                <span class="nav-link new-estimate-item clickable"
                                                                      @click.prevent="selectCardSubPart({isNewItem: true})"><i
                                                                    class="ti-plus"></i>New Item
                                                                </span>
                </li>
                <li v-if="selectedCard !== 'Materials' && isGroupsAvailable && selectedCardPart && !isShowInsertNameGRP"
                    :class="{'border-bottom-groups': !cardSubParts.length && !currentGroupCategory.length, 'border-top-groups': selectedCard != 'PDR'}">
                  <a class="nav-link new-estimate-item" @click.prevent="isShowInsertNameGRP = true" href="#">
                    <i class="ti-plus"></i>New Group
                  </a>
                </li>
                <li v-if="selectedCard !== 'Materials' && isGroupsAvailable && selectedCardPart && isShowInsertNameGRP"
                    class="d-flex" :class="{'border-top-groups': selectedCard !== 'PDR'}">
                  <input v-model="nameOfGroup"
                         @keyup.enter="addNewGroup(nameOfGroup)"
                         @change="addNewGroup(nameOfGroup)"
                         class="new-estimate-group-item"
                         type="text"
                         placeholder="Insert Name">
                  <span style="padding-top: 13px; padding-right: 5px; color:#000000; min-width: 41px; font-weight: 700">- GRP</span>
                </li>
                <draggable
                    v-if="selectedCard !== 'Materials' && isGroupsAvailable"
                    v-model="groupsDraggable"
                    class="dragArea c1"
                    handle=".handle"
                    :options="{
                                    animation: 150,
                                    scroll: true,
                                    scrollSensitivity: 60,
                                    scrollSpeed: 15,
                                    bubbleScroll: true,
                                    forceFallback: true,
                                  }"
                    :group="{ name: 'items', pull: 'clone', put: false }"
                    :clone="cloneItem"
                    :delayOnTouchOnly="true"
                    @start="onDragStart"
                    filter=".disabled-draggable-groups"
                    :disabled="!isStatusActive || isBlockByAuda"
                    @end="onDragEnd"
                >
                  <li v-for="item in currentGroupCategory" class="handle" :id="'group-' + item.group.id"
                      :class="{'disabled-draggable-groups': isAllGroupItemsAlreadyAdded(item)}"
                      v-if="selectedCardPart && currentGroupCategory">
                    <ul>
                      <li :ref="selectedCard + '-' + item.group.name + '-' + item.group.id"
                          @contextmenu.prevent="openMenuGroup($event, item)"
                          :class="{'border-bottom-groups': item.group.isShowItems}"
                          class="estimate-group-item d-flex">
                        <input
                            :class="{'selected-group': item.group.isShowItems, 'gray-background': selectedCardSubPartForContext.part.id === item.group.id && selectedCardSubPartForContext.part.name === item.group.name}"
                            @change="updateGroupName(item.group)" class="estimate-group-item-input"
                            v-model="item.group.name" :ref="item.group.name" type="text">
                        <span
                            :class="{'gray-background': selectedCardSubPartForContext.part.id === item.group.id && selectedCardSubPartForContext.part.name === item.group.name}"
                            style="padding-top: 13px; padding-right: 5px; color:#000000; min-width: 41px; font-weight: 700">- GRP</span>
                      </li>

                      <draggable
                          v-model="item.items"
                          class="dragArea c2 drag-group-items"
                          handle=".handle"

                          :group="{ name: 'items', pull: 'clone', put: false }"
                          :clone="cloneItem"
                          :delayOnTouchOnly="false"
                          :touch-start-threshold="5"
                          :delay="100"
                          :options="{
                                    animation: 150,
                                    scroll: true,
                                    scrollSensitivity: 60,
                                    scrollSpeed: 15,
                                    bubbleScroll: true,
                                    forceFallback: true
                                  }"
                          @start="onDragStart"
                          :disabled="!isStatusActive"
                          @end="onDragEnd"
                          filter=".ignore-item"
                          @change="changeGroupItemsOrder($event, item.group, item.items)"
                      >
                        <li v-if="item.group.isShowItems"
                            v-for="subItem in item.items"
                            :id="'group-item-' + subItem.id"
                            @click.prevent="selectGroupItem(subItem)"
                            @contextmenu.prevent="openMenuGroupItem($event, item.items, subItem)"
                            :class="{'border-top-groups': item.items.indexOf(subItem) != 0, 'gray-background': selectedCardSubPartItemForContext.id === subItem.id && selectedCardSubPartItemForContext.name === subItem.name, 'ignore-item': isAlreadyAddedGroupItem(subItem)}"
                            class="estimate-group-sub-item d-flex handle">
                          <input
                              :class="{'gray-background': selectedCardSubPartItemForContext.id === subItem.id && selectedCardSubPartItemForContext.name === subItem.name}"
                              @change="updateGroupItemName(subItem)" class="estimate-group-subitem-input"
                              v-model="subItem.name" :ref="subItem.name" type="text">
                          <div
                              :class="{'gray-background': selectedCardSubPartItemForContext.id === subItem.id && selectedCardSubPartItemForContext.name === subItem.name}"
                              class="" style="padding-right: 5px"><i class="fa fa-angle-right"></i></div>
                        </li>
                      </draggable>
                    </ul>
                  </li>
                </draggable>

                <template v-if="isActiveButterflyBody && selectedCardPart != 'Custom' && !isEstimateMethodologyZurich">
                  <draggable
                      v-model="butterflyCardSubPartsCombined"
                      class="dragArea c3"
                      handle=".handle"
                      ghost-class="ghost-items-2"

                      :options="{
                                    animation: 150,
                                    scroll: true,
                                    scrollSensitivity: 60,
                                    scrollSpeed: 15,
                                    bubbleScroll: true,
                                    forceFallback: true,
                                  }"
                      :group="{ name: 'items', pull: 'clone', put: false }"
                      :clone="cloneItem"
                      :touch-start-threshold="10"
                      :delay="75"
                      :delayOnTouchOnly="false"
                      @start="onDragStart"
                      :disabled="!isStatusActive ||isBlockByAuda"
                      @end="onDragEnd"
                  >
                    <li v-for="(cs, index) in cardSubParts"
                        :class="{'border-top-groups': true, 'border-bottom-groups': index === cardSubParts.length - 1, 'active': selectedCardSubPart == cs}"
                        @contextmenu.prevent="openMenuCustom($event, cs)"
                        class="handle"
                    >
                      <rs-ripple>
                        <a class="nav-link" @click.prevent="selectCardSubPart(cs)" href="#">{{ cs.prt }}
                          <span v-if="getHourForCategory(cs)>0"
                                style="font-size:10px; font-weight: bold; color:#000000;">({{
                              getHourForCategory(cs)
                            }})</span>
                          <div class="float-xs-right"><i class="fa fa-angle-right"></i></div>
                        </a>
                      </rs-ripple>
                    </li>
                  </draggable>
                </template>
                <template v-else>
                  <draggable
                      v-model="cardSubParts"
                      class="dragArea c4"
                      handle=".handle"
                      ghost-class="ghost-items-2"

                      :group="{ name: 'items', pull: 'clone', put: false }"
                      :clone="cloneItem"
                      :delayOnTouchOnly="true"
                      :options="{
                                    animation: 150,
                                    scroll: true,
                                    scrollSensitivity: 60,
                                    scrollSpeed: 15,
                                    bubbleScroll: true,
                                    forceFallback: true
                                  }"
                      @start="onDragStart"
                      :disabled="!isStatusActive"
                      @end="onDragEnd"
                  >
                    <li v-for="(cs, index) in cardSubParts"
                        v-bind:key="selectedCard+'-'+selectedCardPart+'-'+cs.id"
                        class="handle"
                        :class="{'border-top-groups': true, 'border-bottom-groups': index === cardSubParts.length - 1, 'active': selectedCardSubPart == cs}"
                        @contextmenu.prevent="openMenuCustom($event, cs)">
                      <rs-ripple>
                        <a class="nav-link" @click.prevent="selectCardSubPart(cs)" href="#">{{ cs.prt }}
                          <span v-if="getHourForCategory(cs)>0"
                                style="font-size:10px; font-weight: bold; color:#000000;">({{
                              getHourForCategory(cs)
                            }})</span>
                          <div class="float-xs-right"><i class="fa fa-angle-right"></i></div>
                        </a>
                      </rs-ripple>
                    </li>
                  </draggable>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div :class="selectedCard === 'PDR' ? 'col-md-10' : 'col-md-8 rs-scroll'" id="estimate-item-list"
           class="estimate-item-list-height">
        <!-- <div class="box bg-grey"> -->
        <!-- <p v-if="availableCards.length">No records selected. Please click on items available in two panes on the left side.</p> -->
        <vue-context ref="rightClickMenuForRR" @close='closeContext' @open='openContext' :close-on-click="false"
                     style="width: 205px !important; height: auto">
          <ul slot-scope="item">
            <li v-if="!isAuthorised" @click="onRightClickByRR($event.target, {type:2, index:item.data.index})">Insert
              Row
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && !estimate.isAuthorised && !item.data.part.isAuthorized && (_isEmpty(item.data.part.adj_approve_status) || item.data.part.adj_approve_status == 'none')"
                @click="onRightClickByRR($event.target, {type:3, index:item.data.index})">Delete Row
            </li>
            <li v-if="!isAuthorised && item && item.data && isCanOnReport(item.data.part)"
                @click="onReport(item.data.index, 'RR')">On Report
            </li>
            <li v-if="item && item.data && isCanRemoveOnReport(item.data.part)"
                @click="onReportRemove(item.data.index, 'RR')">Remove On Report
            </li>
            <li v-if="item && item.data && isCanAddToSupp(item.data.part)"
                @click="addToSupplement(item.data.index, 'RR')">Add to Supplement
            </li>
            <li v-if="isCustomListsAvailable"
                @click="onRightClickByRR($event.target, {type:21, index:item.data.index})">
              <span
                  v-if="item.data && item.data.part && item.data.part.name && cardSubPartsCombinedCustom && cardSubPartsCombinedCustom.includes(item.data.part.name)">Update in </span>
              <span v-else>Add to </span>
              Custom list
            </li>
            <li v-if="!isAuthorised && !isEstimateMethodologyCustom"
                @click="onRightClickByRR($event.target, {type:34, index:item.data.index})" style="height: auto">Add R&R
              Weld Panel Allowance
            </li>
            <li class="hasSubContext">Highlight Row <i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="onRightClickByRR($event.target, {type:31,  index:item.data.index, color:'ffff00'})">
                  Highlight Yellow
                </li>
                <li @click="onRightClickByRR($event.target, {type:31,  index:item.data.index, color:'00b050'})">
                  Highlight Green
                </li>
                <li @click="onRightClickByRR($event.target, {type:31,  index:item.data.index, color:'f069ed'})">
                  Highlight Purple
                </li>
              </ul>
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.row_highlight && item.data.part.row_highlight != null"
                @click="onRightClickByRR($event.target, {type:32,  index:item.data.index})">Un-Higlight
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('RR', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('RR', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <!--            <li @click="onRightClickByRR($event.target, {type:5, index:item.data.index})">Add to Paint</li>-->
            <li v-if="!isAuthorised && (isActiveButterflyMainCategory && getBodyId >0) && selectedCardPart"
                style="height: auto;"
                @click="onRightClickByRR($event.target, {type:22, index:item.data.index})">Add to Category
              list<br/>{{ selectedCardPart }}
            </li>
            <li v-if="!isAuthorised && isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                @click="onRightClickByRR($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
              Add to {{ selectedCardPart }} list
            </li>
            <template v-if="!isAuthorised && isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  v-if="item && item.data && item.data.part && !isGroupIncludesName(groupItem, item.data.part)"
                  @click="addToCategoryGroup($event.target, { index:item.data.index, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForRR'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;  left:203px !important;"
                   class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentManualItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Internal Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('RR', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;  left:203px !important;"
                   class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualComment"
                                                                placeholder="Edit Internal Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('RR', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('RR', item.data.index, false, 'r')">Remove Internal Comment
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="add-comment-rr">Add
              Estimate Comment <i style="transform: translate(100%, -4px) !important;"
                                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;  left:203px !important;"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}"
                   class="context-level subContext estimate-item-comment">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('RR', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                id="edit-comment-rr"
                class="hasSubContext">Edit Estimate Comment <i style="transform: translate(100%, -4px) !important;"
                                                               class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important; left:203px !important;"
                   class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('RR', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                style="height: auto;"
                @click="addEditOrRemoveEstimateItemComment('RR', item.data.index, false, 'r')">Remove Estimate Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForRepair" @close='closeContext' @open='openContext' :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="!isAuthorised" @click="onRightClickByRepair($event.target, {type:2, index:item.data.index})">
              Insert Row
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && !estimate.isAuthorised && !item.data.part.isAuthorized && (_isEmpty(item.data.part.adj_approve_status) || item.data.part.adj_approve_status == 'none')"
                @click="onRightClickByRepair($event.target, {type:3, index:item.data.index})">Delete Row
            </li>
            <li v-if="!isAuthorised && item && item.data && isCanOnReport(item.data.part)"
                @click="onReport(item.data.index, 'Repair')">On Report
            </li>
            <li v-if="item && item.data && isCanRemoveOnReport(item.data.part)"
                @click="onReportRemove(item.data.index, 'Repair')">Remove On Report
            </li>
            <li v-if="item && item.data && isCanAddToSupp(item.data.part)"
                @click="addToSupplement(item.data.index, 'Repair')">Add to Supplement
            </li>
            <li v-if="!isAuthorised" @click="onRightClickByRepair($event.target, {type:5, index:item.data.index})">Add
              to Paint
            </li>
            <li v-if="isCustomListsAvailable"
                @click="onRightClickByRepair($event.target, {type:21, index:item.data.index})">
              <span
                  v-if="item.data && item.data.part && item.data.part.name && cardSubPartsCombinedCustom && cardSubPartsCombinedCustom.includes(item.data.part.name)">Update in </span>
              <span v-else>Add to </span>
              Custom list
            </li>
            <li v-if="!isAuthorised && (isActiveButterflyMainCategory && getBodyId >0) && selectedCardPart"
                @click="onRightClickByRepair($event.target, {type:22, index:item.data.index})">Add to
              Category
              list<br/>{{ selectedCardPart }}
            </li>
            <li v-if="!isAuthorised && isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                @click="onRightClickByRepair($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
              Add to {{ selectedCardPart }} list
            </li>
            <li>Highlight Row <i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="onRightClickByRepair($event.target, {type:31,  index:item.data.index, color:'ffff00'})">
                  Highlight Yellow
                </li>
                <li @click="onRightClickByRepair($event.target, {type:31,  index:item.data.index, color:'00b050'})">
                  Highlight Green
                </li>
                <li @click="onRightClickByRepair($event.target, {type:31,  index:item.data.index, color:'f069ed'})">
                  Highlight Purple
                </li>
              </ul>
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.row_highlight && item.data.part.row_highlight != null"
                @click="onRightClickByRepair($event.target, {type:32,  index:item.data.index})">Un-Higlight
            </li>
            <template v-if="isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data.index, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForRepair'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Repair', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Repair', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Repair', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Repair', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li @click="addEditOrRemoveInternalItemComment('Repair', item.data.index, false, 'r')"
                v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment">
              Remove Internal Comment
            </li>

            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="add-comment-repairer">Add
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Repair', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                id="edit-comment-repairer"
                class="hasSubContext">Edit
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Repair', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                @click="addEditOrRemoveEstimateItemComment('Repair', item.data.index, false, 'r')">Remove Estimate
              Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForPaint" @close='closeContext' @open='openContext' :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="!isAuthorised" @click="onRightClickByPaint($event.target, {type:2, index:item.data.index})">Insert
              Row
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && !estimate.isAuthorised && !item.data.part.isAuthorized && (_isEmpty(item.data.part.adj_approve_status) || item.data.part.adj_approve_status == 'none')"
                @click="onRightClickByPaint($event.target, {type:3, index:item.data.index})">Delete Row
            </li>
            <li v-if="!isAuthorised && item && item.data && isCanOnReport(item.data.part)"
                @click="onReport(item.data.index, 'Paint')">On Report
            </li>
            <li v-if="item && item.data && isCanRemoveOnReport(item.data.part)"
                @click="onReportRemove(item.data.index, 'Paint')">Remove On Report
            </li>
            <li v-if="item && item.data && isCanAddToSupp(item.data.part)"
                @click="addToSupplement(item.data.index, 'Paint')">Add to Supplement
            </li>
            <li v-if="!isAuthorised && !isEstimateMethodologyCustom"
                @click="onRightClickByPaint($event.target, {type:10, index:item.data.index})">Add Allowance 10%
            </li>
            <li v-if="!isAuthorised && !isEstimateMethodologyCustom"
                @click="onRightClickByPaint($event.target, {type:11, index:item.data.index})">Add Allowance 25%
            </li>
            <li v-if="!isAuthorised && !isEstimateMethodologyCustom && item.data && item.data.part && item.data.part.paint_type === 'M3PLUS'"
                @click="onRightClickByPaint($event.target, {type:34, index:item.data.index})">Add M3+ Allowance 32%
            </li>
            <!--            <li v-if="!isEstimateMethodologyCustom"-->
            <!--                @click="onRightClickByPaint($event.target, {type:33, index:item.data.index})">Add Matt Allowance 10%-->
            <!--            </li>-->
            <li v-if="!isAuthorised && !isEstimateMethodologyCustom"
                @click="onRightClickByPaint($event.target, {type:35, index:item.data.index})">Add Single Panel Allowance
            </li>
            <li v-if="!isAuthorised && !isEstimateMethodologyCustom"
                @click="onRightClickByPaint($event.target, {type:12, index:item.data.index})">Blend
            </li>
            <li v-if="isCustomListsAvailable"
                @click="onRightClickByPaint($event.target, {type:21, index:item.data.index})">
              <span
                  v-if="item.data && item.data.part && item.data.part.name && cardSubPartsCombinedCustom && cardSubPartsCombinedCustom.includes(item.data.part.name)">Update in </span>
              <span v-else>Add to </span>
              Custom list
            </li>
            <li v-if="!isAuthorised && (isActiveButterflyMainCategory && getBodyId >0) && selectedCardPart"
                @click="onRightClickByPaint($event.target, {type:22, index:item.data.index})">Add to
              Category
              list<br/>{{ selectedCardPart }}
            </li>
            <li v-if="!isAuthorised && isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                @click="onRightClickByPaint($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
              Add to {{ selectedCardPart }} list
            </li>
            <li>Highlight Row <i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="onRightClickByPaint($event.target, {type:31,  index:item.data.index, color:'ffff00'})">
                  Highlight Yellow
                </li>
                <li @click="onRightClickByPaint($event.target, {type:31,  index:item.data.index, color:'00b050'})">
                  Highlight Green
                </li>
                <li @click="onRightClickByPaint($event.target, {type:31,  index:item.data.index, color:'f069ed'})">
                  Highlight Purple
                </li>
              </ul>
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.row_highlight && item.data.part.row_highlight != null"
                @click="onRightClickByPaint($event.target, {type:32,  index:item.data.index})">
              Un-Higlight
            </li>
            <template v-if="isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data.index, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForPaint'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Paint', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Paint', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Paint', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Paint', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('Paint', item.data.index, false, 'r')">Remove Internal
              Comment
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="add-comment-paint">Add
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Paint', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="edit-comment-paint">Edit
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Paint', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                @click="addEditOrRemoveEstimateItemComment('Paint', item.data.index, false, 'r')">Remove Estimate
              Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForPart" @close='closeContext' @open='openContext' :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="!isAuthorised" @click="onRightClickByPart($event.target, {type:2, index:item.data.index})">Insert
              Row
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && !estimate.isAuthorised && !item.data.part.isAuthorized && (_isEmpty(item.data.part.adj_approve_status) || item.data.part.adj_approve_status == 'none')"
                @click="onRightClickByPart($event.target, {type:3, index:item.data.index})">Delete Row
            </li>
            <li v-if="!isAuthorised && item && item.data && isCanOnReport(item.data.part)"
                @click="onReport(item.data.index, 'Part')">On Report
            </li>
            <li v-if="item && item.data && isCanRemoveOnReport(item.data.part)"
                @click="onReportRemove(item.data.index, 'Part')">Remove On Report
            </li>
            <li v-if="item && item.data && isCanAddToSupp(item.data.part)"
                @click="addToSupplement(item.data.index, 'Part')">Add to Supplement
            </li>
            <li>Highlight Row <i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="onRightClickByPart($event.target, {type:31,  index:item.data.index, color:'ffff00'})">
                  Highlight Yellow
                </li>
                <li @click="onRightClickByPart($event.target, {type:31,  index:item.data.index, color:'00b050'})">
                  Highlight Green
                </li>
                <li @click="onRightClickByPart($event.target, {type:31,  index:item.data.index, color:'f069ed'})">
                  Highlight Purple
                </li>
              </ul>
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.row_highlight && item.data.part.row_highlight != null"
                @click="onRightClickByPart($event.target, {type:32,  index:item.data.index})">
              Un-Higlight
            </li>
            <template v-if="isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data.index, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForPart'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Part', item.data.index, false)">From Job File</li>
              </ul>
            </li>

            <li v-if="!isAuthorised && isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                @click="onRightClickByPart($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
              Add to {{ selectedCardPart }} list
            </li>

            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Part', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Part', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Part', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('Part', item.data.index, false, 'r')">Remove Internal Comment
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="add-comment-part">Add
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Part', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="edit-comment-part">Edit
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Part', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                @click="addEditOrRemoveEstimateItemComment('Part', item.data.index, false, 'r')">Remove Estimate Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForMaterials" @close='closeContext' @open='openContext' :close-on-click="false">
          <ul slot-scope="item">
            <template
                v-if="estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].type === 'calculation'">

              <li v-if="!isAuthorised && !isShowPaintSetupCalculation"
                  @click="onRightClickByMaterials($event.target, {type:1, index:item.data})">
                Add Paint Setup
              </li>

              <li v-if="!isAuthorised && !isShowEnvironmentLevyCalculation"
                  @click="onRightClickByMaterials($event.target, {type:2, index:item.data})">
                Add Environment Levy
              </li>

              <li v-if="!isAuthorised && isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                  @click="onRightClickByMaterials($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
                Add to {{ selectedCardPart }} list
              </li>

              <li v-if="!isAuthorised && isShowPaintSetupCalculation && estimateParts['Materials'][item.data].subtype === 'PaintSetupTime'"
                  @click="onRightClickByMaterials($event.target, {type:3, index:item.data})">
                Delete Line Item
              </li>
              <li v-if="!isAuthorised && isShowEnvironmentLevyCalculation && estimateParts['Materials'][item.data].subtype === 'EnvironmentLevy'"
                  @click="onRightClickByMaterials($event.target, {type:4, index:item.data})">
                Delete Line Item
              </li>
              <li v-if="!isAuthorised && estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].comments && !estimateParts['Materials'][item.data].comments.manualComment"
                  class="hasSubContext">Add Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].isNeedChangePosition}">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                  <div class="">
                    <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                      50 characters</p>
                    <i @click="addEditOrRemoveInternalItemComment('Materials', item.data, false, 'a')"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="!isAuthorised && estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].comments && estimateParts['Materials'][item.data].comments.manualComment"
                  class="hasSubContext">Edit Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].isNeedChangePosition}">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="estimateParts['Materials'][item.data].comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                  <div class="">
                    <p :class="{'error-text': estimateParts['Materials'][item.data].comments.manualComment.length > 50}"
                       class="comment-limit-text">
                      Limit of 50 characters</p>
                    <i @click="addEditOrRemoveInternalItemComment('Materials', item.data, false, 'e')"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="!isAuthorised && estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].comments && estimateParts['Materials'][item.data].comments.manualComment"
                  @click="addEditOrRemoveInternalItemComment('Materials', item.data, false, 'r')">Remove Internal
                Comment
              </li>
              <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                  class="hasSubContext" id="add-estimate-material">Add
                Estimate Comment <i
                    class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                  <div class="">
                    <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit
                      of 50 characters</p>
                    <i @click="addEditOrRemoveEstimateItemComment('Materials', item.data.index, false, 'a')"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                  class="hasSubContext" id="edit-estimate-material">Edit
                Estimate Comment <i
                    class="icon-right bx bx-chevron-right"></i>
                <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                     :class="{'comment-fixed-position': estimateParts['Materials'][item.data] && estimateParts['Materials'][item.data].isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                  <div class="">
                    <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                       class="comment-limit-text">Limit of 50
                      characters</p>
                    <i @click="addEditOrRemoveEstimateItemComment('Materials', item.data.index, false, 'e')"
                       class='bx bx-save save-comment-icon'></i>
                  </div>
                </div>
              </li>
              <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                  @click="addEditOrRemoveEstimateItemComment('Materials', item.data.index, false, 'r')">Remove Estimate
                Comment
              </li>
            </template>
            <template v-if="false && isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForMaterials'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
            <template v-if="false && isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForMaterials'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForMaterialsZurich" @close='closeContext' @open='openContext'
                     :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                @click="onRightClickByMaterialsZurich($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
              Add to {{ selectedCardPart }} list
            </li>
            <template v-if="false && isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data.index, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForMaterialsZurich'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForSublet" @close='closeContext' @open='openContext' :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="!isAuthorised" @click="onRightClickBySublet($event.target, {type:2, index:item.data.index})">
              Insert Row
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && !estimate.isAuthorised && !item.data.part.isAuthorized && (_isEmpty(item.data.part.adj_approve_status) || item.data.part.adj_approve_status == 'none')"
                @click="onRightClickBySublet($event.target, {type:3, index:item.data.index})">Delete Row
            </li>
            <li v-if="!isAuthorised && item && item.data && isCanOnReport(item.data.part)"
                @click="onReport(item.data.index, 'Sublet')">On Report
            </li>
            <li v-if="item && item.data && isCanRemoveOnReport(item.data.part)"
                @click="onReportRemove(item.data.index, 'Sublet')">Remove On Report
            </li>
            <li v-if="item && item.data && isCanAddToSupp(item.data.part)"
                @click="addToSupplement(item.data.index, 'Sublet')">Add to Supplement
            </li>
            <li>Highlight Row <i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="onRightClickBySublet($event.target, {type:31,  index:item.data.index, color:'ffff00'})">
                  Highlight Yellow
                </li>
                <li @click="onRightClickBySublet($event.target, {type:31,  index:item.data.index, color:'00b050'})">
                  Highlight Green
                </li>
                <li @click="onRightClickBySublet($event.target, {type:31,  index:item.data.index, color:'f069ed'})">
                  Highlight Purple
                </li>
              </ul>
            </li>

            <li v-if="!isAuthorised && isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                @click="onRightClickBySublet($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
              Add to {{ selectedCardPart }} list
            </li>

            <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.row_highlight && item.data.part.row_highlight != null"
                @click="onRightClickBySublet($event.target, {type:32,  index:item.data.index})">
              Un-Higlight
            </li>
            <template v-if="isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data.index, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForSublet'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Sublet', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Sublet', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Sublet', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Sublet', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('Sublet', item.data.index, false, 'r')">Remove Internal
              Comment
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="add-comment-sublet">Add
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Sublet', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="edit-comment-sublet">Edit
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Sublet', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                @click="addEditOrRemoveEstimateItemComment('Sublet', item.data.index, false, 'r')">Remove Estimate
              Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForOther" @close='closeContext' @open='openContext' :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="!isAuthorised" @click="onRightClickByOther($event.target, {type:2, index:item.data.index})">Insert
              Row
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && !estimate.isAuthorised && !item.data.part.isAuthorized && (_isEmpty(item.data.part.adj_approve_status) || item.data.part.adj_approve_status == 'none')"
                @click="onRightClickByOther($event.target, {type:3, index:item.data.index})">Delete Row
            </li>
            <li v-if="!isAuthorised && item && item.data && isCanOnReport(item.data.part)"
                @click="onReport(item.data.index, 'Other')">On Report
            </li>
            <li v-if="item && item.data && isCanRemoveOnReport(item.data.part)"
                @click="onReportRemove(item.data.index, 'Other')">Remove On Report
            </li>
            <li v-if="item && item.data && isCanAddToSupp(item.data.part)"
                @click="addToSupplement(item.data.index, 'Other')">Add to Supplement
            </li>
            <li v-if="isCustomListsAvailable"
                @click="onRightClickByOther($event.target, {type:21, index:item.data.index})">
              <span
                  v-if="item.data && item.data.part && item.data.part.name && cardSubPartsCombinedCustom && cardSubPartsCombinedCustom.includes(item.data.part.name)">Update in </span>
              <span v-else>Add to </span>
              Custom list
            </li>
            <li>Highlight Row <i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="onRightClickByOther($event.target, {type:31,  index:item.data.index, color:'ffff00'})">
                  Highlight Yellow
                </li>
                <li @click="onRightClickByOther($event.target, {type:31,  index:item.data.index, color:'00b050'})">
                  Highlight Green
                </li>
                <li @click="onRightClickByOther($event.target, {type:31,  index:item.data.index, color:'f069ed'})">
                  Highlight Purple
                </li>
              </ul>
            </li>
            <li v-if="!isAuthorised && item && item.data && item.data.part && item.data.part.row_highlight && item.data.part.row_highlight != null"
                @click="onRightClickByOther($event.target, {type:32,  index:item.data.index})">
              Un-Higlight
            </li>
            <template v-if="isCustomListsAvailable">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data.index, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForOther'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>

            <li v-if="!isAuthorised && isEstimateMethodologyZurich && selectedCardPart != ''" style="height: auto;"
                @click="onRightClickByOther($event.target, {type:23, index:item.data.index, mainCategory: selectedCardPart})">
              Add to {{ selectedCardPart }} list
            </li>

            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Other', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Other', item.data.index, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Other', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Other', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('Other', item.data.index, false, 'r')">Remove Internal
              Comment
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="add-comment-other">Add
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Other', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="edit-comment-other">Edit
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Other', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                @click="addEditOrRemoveEstimateItemComment('Other', item.data.index, false, 'r')">Remove Estimate
              Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForOtherCustom" :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && item.data && item.data.c"
                @click="onRightClickByOtherCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-else-if="!isEstimateMethodologyZurich && item.data && item.data.cb"
                @click="onRightClickByOtherCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-else-if="!isEstimateMethodologyZurich"
                @click="onRightClickByOtherCustom($event.target, {type:3, data:item.data})">Remove from Custom
              list
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Other', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Other', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Other', item.data.index, true, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Other', item.data.index, true, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('Other', item.data.index, true, 'r')">Remove Internal Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForRRCustom" :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && item.data && item.data.c"
                @click="onRightClickByRRCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-else-if="!isEstimateMethodologyZurich && item.data && item.data.cb"
                @click="onRightClickByRRCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-else-if="!isEstimateMethodologyZurich"
                @click="onRightClickByRRCustom($event.target, {type:3, data:item.data})">Remove from Custom
              list
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('RR', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('RR', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('RR', item.data.index, true, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('RR', item.data.index, true, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('RR', item.data.index, true, 'r')">Remove Internal Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForRepairCustom" :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && item.data && item.data.c"
                @click="onRightClickByRepairCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-else-if="!isEstimateMethodologyZurich && item.data && item.data.cb"
                @click="onRightClickByRepairCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-else-if="!isEstimateMethodologyZurich"
                @click="onRightClickByRepairCustom($event.target, {type:3, data:item.data})">Remove from Custom
              list
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Repair', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Repair', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Repair', item.data.index, true, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Repair', item.data.index, true, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('Repair', item.data.index, true, 'r')">Remove Internal
              Comment
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForPaintCustom" :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && item.data && item.data.c"
                @click="onRightClickByPaintCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-if="!isEstimateMethodologyZurich && item.data && item.data.cb"
                @click="onRightClickByPaintCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
            <li v-else-if="!isEstimateMethodologyZurich"
                @click="onRightClickByPaintCustom($event.target, {type:3, data:item.data})">Remove from Custom
              list
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && item.data.part.is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Paint', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && item && item.data && item.data.part && !item.data.part.is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('Paint', item.data.index, true)">From Job File</li>
              </ul>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualComment"
                class="hasSubContext">Add
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  v-model="currentManualItemComment"
                                                                  ref="commentEditTextarea"
                                                                  placeholder="Add Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Paint', item.data.index, true, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                class="hasSubContext">Edit
              Internal Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment">
                                                              <textarea
                                                                  ref="commentEditTextarea"
                                                                  v-model="item.data.part.comments.manualComment"
                                                                  placeholder="Edit Internal Comment...">
                                                              </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('Paint', item.data.index, true, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('Paint', item.data.index, true, 'r')">Remove Internal Comment
            </li>
          </ul>
        </vue-context>

        <vue-context ref="rightClickMenuForPartCustom" :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && item.data && item.data.c"
                @click="onRightClickByPartCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
          </ul>
        </vue-context>

        <vue-context ref="rightClickMenuForMaterialsCustom" :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && item.data && item.data.c"
                @click="onRightClickByMaterialsCustom($event.target, {type:3, data:item.data})">Remove from Category
              list
            </li>
          </ul>
        </vue-context>

        <vue-context ref="rightClickMenuForSubletCustom" :close-on-click="false">
          <ul slot-scope="item">
            <li v-if="isEstimateMethodologyZurich && item.data && item.data.c"
                @click="onRightClickBySubletCustom($event.target, {type:3, data:item.data})">Remove from Category list
            </li>
          </ul>
        </vue-context>

        <vue-context ref="rightClickMenuForRemoveButterflyCustom" v-if="isCustomListsAvailable">
          <ul slot-scope="item">
            <li v-if="item.data && item.data.cb"
                @click="onRightClickByRemoveButterflyCustom($event.target, {type:3, data:item.data})">Remove from
              Category
              list
            </li>
            <li v-else @click="onRightClickByRemoveButterflyCustom($event.target, {type:3, data:item.data})">Remove from
              Custom list
            </li>

          </ul>
        </vue-context>

        <vue-context ref="rightClickMenuForGroup"
                     @close="closeMenuGroup"
                     :close-on-click="false">
          <ul slot-scope="item" v-if="item && item.data && item.data.group">
            <li @click="onRightClickByGroup($event.target, {type:1, item:item.data.group})"
                v-if="!item.data.group.isShowItems">View Group Items
            </li>
            <li @click="onRightClickByGroup($event.target, {type:5, item:item.data.group})"
                v-if="item.data.group.isShowItems">Hide Group Items
            </li>
            <li v-if="!isAllGroupItemsAlreadyAdded(item.data)"
                @click="onRightClickByGroup($event.target, {type:2, item:item.data.group})">Apply Group Items
            </li>
            <li @click="onRightClickByGroup($event.target, {type:3, item:item.data.group})">Rename Group</li>
            <li @click="onRightClickByGroup($event.target, {type:4, item:item.data.group})">Remove from Category Group
            </li>
            <li class="hasSubContext">Properties
              <ul v-if="item.data.group" class="context-level subContext"
                  style="width:207px !important; padding: 10px !important">
                <strong style="font-size: 13px !important; margin-bottom: 10px"> Group Applied to All </strong>
                <div style="padding-bottom: 10px">
                  <label class="form-check-inline checkbox" style="width: 100%; margin-top: 5px">
                    <input @change="onChangeGroupCheckboxes(item.data.group)"
                           v-model="item.data.group.applyTo.nonscheduled"
                           class="form-check-input" type="checkbox">
                    <span class="icon"><i style="transform: translateY(0px);" class='bx bx-check'></i></span><span
                      class="text" style="width: 178px !important;">Non-Scheduled lists</span>
                  </label>
                </div>
                <div style="padding-bottom: 10px">
                  <label class="form-check-inline checkbox" style="width: 100%">
                    <input @change="onChangeGroupCheckboxes(item.data.group)" v-model="item.data.group.applyTo.ltar"
                           class="form-check-input" type="checkbox">
                    <span class="icon"><i style="transform: translateY(0px);" class='bx bx-check'></i></span><span
                      class="text" style="width: 170px !important;">LTAR scheduled lists</span>
                  </label>
                </div>
                <div style="padding-bottom: 10px">
                  <label class="form-check-inline checkbox" style="width: 100%">
                    <input @change="onChangeGroupCheckboxes(item.data.group)" v-model="item.data.group.applyTo.ntar"
                           class="form-check-input" type="checkbox">
                    <span class="icon"><i style="transform: translateY(0px);" class='bx bx-check'></i></span><span
                      class="text" style="width: 170px !important;">NTAR scheduled lists</span>
                  </label>
                </div>
                <div style="padding-bottom: 10px">
                  <label class="form-check-inline checkbox" style="width: 100%">
                    <input @change="onChangeGroupCheckboxes(item.data.group)" v-model="item.data.group.applyTo.rs"
                           class="form-check-input"
                           type="checkbox">
                    <span class="icon"><i style="transform: translateY(0px);" class='bx bx-check'></i></span><span
                      class="text" style="width: 178px !important;">RS scheduled lists</span>
                  </label>
                </div>
                <div style="padding-bottom: 10px">
                  <label class="form-check-inline checkbox" style="width: 100%">
                    <input @change="onChangeGroupCheckboxes(item.data.group)" v-model="item.data.group.applyTo.zurich"
                           class="form-check-input"
                           type="checkbox">
                    <span class="icon"><i style="transform: translateY(0px);" class='bx bx-check'></i></span><span
                      class="text" style="width: 178px !important;">ZURICH scheduled lists</span>
                  </label>
                </div>
                <strong style="font-size: 13px !important; margin-bottom: 10px">Group Applied to only</strong>
                <div style="padding-bottom: 10px; margin-top: 5px">
                  <label v-if="item.data.group.make && item.data.group.model" class="form-check-inline radio"
                         style="width: 100%">
                    <input @click="clearGroupItemMakeAndModel(item.data.group)"
                           v-model="isActiveOptionVehicleMakeOrModel"
                           :value="true" class="form-check-input" type="radio">
                    <span class="icon"><i style="transform: translateY(0px);" class='bx bx-check'></i></span><span
                      class="text" style="width: 178px !important;">Vehicle Make/Model</span>
                  </label>
                  <label v-else class="form-check-inline radio" style="width: 100%">
                    <input @click="addMakeAndModelToGroupItem(item.data.group)"
                           v-model="isNotActiveOptionVehicleMakeOrModel"
                           :value="true" class="form-check-input" type="radio">
                    <span class="icon"><i style="transform: translateY(0px);" class='bx bx-check'></i></span><span
                      class="text" style="width: 178px !important;">Vehicle Make/Model</span>
                  </label>
                </div>
              </ul>
            </li>
          </ul>
        </vue-context>
        <vue-context ref="rightClickMenuForGroupItem" @close='closeMenuGroupItem'>
          <ul slot-scope="item">
            <li @click="onRightClickByGroupItem($event.target, {type:1, items:item.data.item, subItem: item.data.subItem})">
              Remove Group Item
            </li>
            <li @click="onRightClickByGroupItem($event.target, {type:2, items:item.data.item, subItem: item.data.subItem})">
              Rename Group Item
            </li>
          </ul>
        </vue-context>

        <!--For Remove Levy -->
        <vue-context ref="rightClickMenuForRemoveLevy">
          <ul slot-scope="item">
            <li @click="onRightClickRemoveLevy($event.target, {index:item.data})">Delete</li>
          </ul>
        </vue-context>

        <!--For Showing Materials-->
        <vue-context ref="rightClickMenuForAddLevy">
          <ul slot-scope="item">
            <li @click="onRightClickAddLevy()">Add ENVIRONMENT LEVY</li>
          </ul>
        </vue-context>

        <!--For PDR -->
        <vue-context ref="rightClickMenuForPDR"
                     @close='closeContext' @open='openContext'
                     :close-on-click="false">
          <ul slot-scope="item" class="pdr-menu">
            <template
                v-if="isCustomListsAvailable && estimateParts[selectedCard] && estimateParts[selectedCard][item.data]">
              <li style="height: auto" v-for="groupItem in currentGroupCategory"
                  @click="addToCategoryGroup($event.target, { index:item.data, group: groupItem.group, groupItem: groupItem, ref: 'rightClickMenuForPDR'})">
                Add to Category Group - {{ groupItem.group.name }} - GRP
              </li>
            </template>
            <li v-if="!isAuthorised && estimateParts && estimateParts[selectedCard] && isCanOnReport(estimateParts[selectedCard][item.data])"
                @click="onReport(item.data, 'PDR')">On Report
            </li>
            <li v-if="estimateParts && estimateParts[selectedCard] && isCanRemoveOnReport(estimateParts[selectedCard][item.data])"
                @click="onReportRemove(estimateParts[selectedCard][item.data], 'PDR')">Remove On Report
            </li>
            <li v-if="item && item.data && isCanAddToSupp(item.data.part)"
                @click="addToSupplement(item.data.index, 'RR')">Add to Supplement
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && estimateParts[selectedCard][item.data] && estimateParts[selectedCard][item.data].is_show_in_jobcard"
                class="hasSubContext">Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('PDR', item.data, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="(isShopManagerUser || isProductionManagerUser || isCustomerUser || isEstimatorUser) && estimateParts[selectedCard][item.data] && !estimateParts[selectedCard][item.data].is_show_in_jobcard"
                class="hasSubContext">Un-Hide<i class="icon-right bx bx-chevron-right"></i>
              <ul class="context-level subContext" style="width:172px;">
                <li @click="showOrHideEstimateItemFromJobCard('PDR', item.data, false)">From Job File</li>
              </ul>
            </li>
            <li v-if="estimateParts[selectedCard][item.data] && estimateParts[selectedCard][item.data].comments && !estimateParts[selectedCard][item.data].comments.manualComment"
                class="hasSubContext">Add Internal Comment <i
                class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                                  <textarea
                                                                      v-model="currentManualItemComment"
                                                                      ref="commentEditTextarea"
                                                                      placeholder="Add Internal Comment...">
                                                                  </textarea>
                <div class="">
                  <p :class="{'error-text': currentManualItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('PDR', item.data, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="estimateParts[selectedCard][item.data] && estimateParts[selectedCard][item.data].comments && estimateParts[selectedCard][item.data].comments.manualComment"
                class="hasSubContext">Edit Internal Comment <i
                class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                                  <textarea
                                                                      ref="commentEditTextarea"
                                                                      v-model="estimateParts[selectedCard][item.data].comments.manualComment"
                                                                      placeholder="Edit Internal Comment...">
                                                                  </textarea>
                <div class="">
                  <p :class="{'error-text':estimateParts[selectedCard][item.data].comments.manualComment.length > 50}"
                     class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveInternalItemComment('PDR', item.data, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="estimateParts[selectedCard][item.data] && estimateParts[selectedCard][item.data].comments && estimateParts[selectedCard][item.data].comments.manualComment"
                @click="addEditOrRemoveInternalItemComment('PDR', item.data, false, 'r')">Remove Internal Comment
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && !item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="add-comment-pdr">Add
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                v-model="currentEstimateItemComment"
                                                                ref="commentEditTextarea"
                                                                placeholder="Add Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': currentEstimateItemComment.length > 50}" class="comment-limit-text">Limit of
                    50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Repair', item.data.index, false, 'a')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment"
                class="hasSubContext" id="edit-comment-pdr">Edit
              Estimate Comment <i
                  class="icon-right bx bx-chevron-right"></i>
              <div style="width: 160px !important;" class="context-level subContext estimate-item-comment"
                   :class="{'comment-fixed-position': item && item.data && item.data.part && item.data.part.isNeedChangePosition}">
                                                            <textarea
                                                                ref="commentEditTextarea"
                                                                v-model="item.data.part.comments.manualPdfComment"
                                                                placeholder="Edit Estimate Comment...">
                                                            </textarea>
                <div class="">
                  <p :class="{'error-text': item.data.part.comments.manualPdfComment.length > 50}"
                     class="comment-limit-text">Limit of 50 characters</p>
                  <i @click="addEditOrRemoveEstimateItemComment('Repair', item.data.index, false, 'e')"
                     class='bx bx-save save-comment-icon'></i>
                </div>
              </div>
            </li>
            <li v-if="item && item.data && item.data.part && item.data.part.comments && item.data.part.comments.manualPdfComment && !isOnReport(item.data.part)"
                @click="addEditOrRemoveEstimateItemComment('Repair', item.data.index, false, 'r')">Remove Estimate
              Comment
            </li>
          </ul>
        </vue-context>
        <div v-for="(card, index) in availableCards"
             class="autorise-estimate-table"
             :class="{'display-none': card != selectedCard}" :key="index">
          <div class="card-header bg-navyblue" style="display: flex;"
               :class="{'part-table-min-width': card == 'Part', 'pdr-table-min-width': card == 'PDR', 'paint-table-min-width': card == 'Paint', 'others-table-min-width': card == 'RR' || card == 'Repair' || card == 'Materials' || card == 'Sublet' || card == 'Other'}"
          >
            <strong>{{ card }}
              <template v-if="card === 'Part' && partsProfitSummary.hasValue">
                <div class="row pl-1" style="align-items: center; height: 32px;display:inline-flex;">
                  <label style="min-width: 74px; text-align: right;" class="col-sm-2 col-form-label">Parts
                    Profit</label>
                  <div class="col-sm-9 pr-0 d-flex">
                  <span
                      class="form-control form-control-mobile-position"
                      style="min-width: 90px; display: inline; line-height: 16px;height: 32px;">
                    <template>
                      {{ partsProfitSummary.profit | formatMoney }} - {{ partsProfitSummary.percent.toFixed(0) }}%
                    </template>
                  </span>
                  </div>
                </div>
              </template>
              <template v-if="card === 'Part' && isReceivedUpdateFromRS">
                <button @click="viewPricing"
                        class="btn btn-primary btn-part-pricing">View Pricing
                  <div class="btn-part-pricing-ps-logo"></div>
                </button>
              </template>
            </strong>

            <div v-if="isShopManagerUser || isProductionManagerUser || isEstimatorUser" class="card-header__right">
              <button v-if="card === 'PDR' && isVisibleToPDRTech" @click="togglePDRVisible"
                      class="button button--light">
                <span>Visible to PDR Tech</span>
                <span><a @click.prevent="" href="">
                                                                    <i class='bx bx-fw bx-show pdr-visible-icon disabled'></i>
                                                                </a></span>
              </button>
              <button v-else-if="card === 'PDR' && !isVisibleToPDRTech" @click="togglePDRVisible"
                      class="button button--light">
                <span>Hidden from PDR Tech</span>
                <span><a @click.prevent="" href="">
                                                                    <i class='bx bx-fw bx-show pdr-visible-icon'></i>
                                                                </a></span>
              </button>
            </div>

            <div v-if="isInsuranceRepairYes && !isBlockByAuda" class="d-flex"
                 style="justify-content: end; flex-wrap: wrap; margin-left: auto;">
              <div class="d-flex">
                <label style="min-width: 115px; text-align: right; margin-right: 10px" class="col-sm-4 col-form-label">{{
                    card
                  }}
                  - Subtotal</label>
                <span style="max-width: 100px; height: 32px"
                      class="form-control">{{ calculatedTotal|formatMoney }}</span>

                <!--                                <number-formatter ref="total"-->
                <!--                                                  v-model="calculatedTotal"-->
                <!--                                                  type="text"-->
                <!--                                                  class="form-control"-->
                <!--                                                  id="total"-->
                <!--                                                  placeholder="Total"-->
                <!--                                                  :isTotalManual="true"-->
                <!--                                                  format="$0,0.00"-->
                <!--                                                  style="max-width: 100px;"-->
                <!--                                                  readonly="true">-->
                <!--                                </number-formatter>-->
              </div>
              <div class="d-flex" style="margin-left: 10px;">
                <label style="width: auto; text-align: right; margin-right: 10px" class="col-sm-4 col-form-label">ADJ Subtotal</label>
                <div class="d-flex" style="min-width: 140px;">
                                    <span v-if="calculatedAdjTotal !== calculatedTotal && calculatedTotal != 0"
                                          class="form-control"
                                          :style="{color: calculatedAdjTotal > calculatedTotal ? '#2BAE66FF': 'red'}"
                                          style="line-height: 16px; height: 32px !important;">
                                      {{ calculatedAdjTotal|formatMoney }}
                                    </span>
                  <span v-else class="form-control white-text"
                        style="color: red; display: inline; line-height: 16px; height: 32px !important;  margin-left: 5px"></span>

                  <span v-if="calculatedAdjTotal !== calculatedTotal && calculatedTotal !=0" class="form-control"
                        :style="{color: calculatedAdjTotal > calculatedTotal ? '#2BAE66FF': 'red'}"
                        style="line-height: 16px; height: 32px !important;  margin-left: 5px">
                                      {{ calculatedAdjTotalPercent }}%
                                    </span>
                  <span v-else :class="{'white-text': calculatedAdjTotal === calculatedTotal}"
                        class="form-control white-text"
                        style="color: red; line-height: 16px; height: 32px !important;  margin-left: 5px">
                                    </span>
                </div>
              </div>
            </div>


          </div>
          <div class="card-block rs-scroll rs-scroll--x rs-scroll--y px-0 py-0 bg-white estimate-items-wrapper"
               style="overflow: auto; touch-action: pan-x pan-y; -webkit-overflow-scrolling: touch;"
               :class="{'part-table-min-width': card == 'Part', 'pdr-table-min-width': card == 'PDR', 'paint-table-min-width': card == 'Paint', 'others-table-min-width': card == 'RR' || card == 'Repair' || card == 'Materials' || card == 'Sublet' || card == 'Other'}"
          >
            <div class="mb-1 estimate-items" id="table-1"
                 :class="{ 'width-rr': card === 'RR' || card === 'Repair' || card === 'Materials' || card === 'Sublet', 'width-paint': card === 'Paint', 'width-parts': card === 'Part', 'width-other': card === 'Other', 'width-pdr': card === 'PDR'}"
            >
              <div>
                <div class="estimate-items-title">
                  <div style="padding-left: 15px;" class="estimate-items-name-all"
                       :class="{'estimate-items-name-part': card == 'Part'}">Name
                  </div>
                  <div v-if="card === 'Part'"
                       class="text-center numeric estimate-items-title-content estimate-items-part-num">Part Number
                  </div>
                  <div v-if="card === 'Part'"
                       class="text-center numeric estimate-items-title-content estimate-items-part-num">Type
                  </div>
                  <div v-if="card === 'Part' " class="text-center numeric estimate-items-title-content">M/up (%)</div>
                  <div v-if="card === 'PDR'"
                       class="text-center numeric estimate-items-title-content estimate-items-pdr">Material
                  </div>
                  <div v-if="card === 'PDR'"
                       class="text-center numeric estimate-items-title-content estimate-items-pdr ">Action
                  </div>
                  <div v-if="card === 'Part' || card === 'PDR'"
                       class="text-center numeric numeric-qty estimate-items-title-content"
                       :style="`width: ${card === 'PDR' ? 65 : 50 }px !important;`">Qty
                  </div>
                  <div v-if="card === 'Paint'"
                       class="text-center  numeric estimate-items-title-content estimate-items-paint-materials">Paint
                    Material
                  </div>
                  <div v-if="card === 'Sublet'" class="estimate-items-title-content" style="width: 125px !important;">
                    Repairer
                  </div>
                  <div
                      v-if="!(isEstimateMethodologyDollars
                      && (card == 'RR' || card == 'Repair' || card == 'Paint'))
                      && card !== 'Part'
                      && card !== 'Sublet'
                      && card !== 'Other'
                      && card !== 'PDR'"
                      class="text-center estimate-items-title-content estimate-items-hrs">Hrs
                    <span
                        v-if="card == 'RR' || card == 'Repair' || card == 'Paint'"><br/>Total: {{
                        getTotal('hrs', card)
                      }}</span>
                  </div>
                  <div v-if="card === 'Sublet'" class="text-center numeric estimate-items-title-content">M/up (%)</div>
                  <div
                      v-if="!(isEstimateMethodologyDollars
                      && (card == 'RR' || card == 'Repair' || card == 'Paint'))
                      && card !== 'Part'
                      && card !== 'Sublet'
                      && card !== 'Other'
                      && card !== 'PDR'
                      && isInsuranceRepairYes"
                      class="text-center estimate-items-title-content  estimate-items-adj">
                    ADJ
                    <span
                        v-if="card == 'RR' || card == 'Repair' || card == 'Paint'"><br/>Total: {{
                        getTotal('adj_hrs', card)
                      }}</span>
                  </div>
                  <!--                  <div-->
                  <!--                      v-if="!isEstimateMethodologyDollars-->
                  <!--                      && card === 'PDR'-->
                  <!--                      && isInsuranceRepairYes"-->
                  <!--                      class="text-center estimate-items-title-content  estimate-items-adj">-->
                  <!--                    ADJ Qty-->
                  <!--                  </div>-->
                  <div v-if="card === 'Part'" class="text-center estimate-items-title-content estimate-items-rate">Buy
                  </div>
                  <div
                      v-if="!(isEstimateMethodologyDollars && (card == 'RR' || card == 'Repair' || card == 'Paint')) && card !== 'Other' && card !== 'Materials' && card !== 'PDR'"
                      class="text-center numeric estimate-items-title-content estimate-items-rate">{{
                      card ==
                      'Part' ? 'List' : 'Rate'
                    }}
                  </div>
                  <div v-if="card === 'PDR'" class="text-center numeric estimate-items-title-content"
                       style="width: 95px">Price
                  </div>
                  <div class="text-center numeric estimate-items-title-content estimate-items-total">Total</div>
                  <div v-if="isInsuranceRepairYes" class="text-center numeric estimate-items-content-adj">ADJ</div>
                  <div class="estimate-items-content-btn-remove" style="width: 80px !important;"></div>
                </div>
              </div>
              <draggable v-model="estimateParts[card]"
                         :move="moveDraggebleElement"
                         class="dragArea c5"
                         tag="div"
                         @start="onDragEstimateItemStart"
                         @end="onDragEstimateItemEnd"
                         @change="onItemMoveChange"
                         :options="{
                                    animation: 150,
                                    scroll: true,
                                    scrollSensitivity: 150,
                                    scrollSpeed: 15,
                                    bubbleScroll: true,
                                    forceFallback: true,
                                    filter: '.numeric, .no-drag, .no-drag *',
                                    preventOnFilter: false
                                  }"
                         handle=".handle"

                         :disabled="isMobile || !isStatusActive || isDisabledDraggable || estimate.isAuthorised"
                         :group="{
                                   name: 'items',
                                   put: true // not allow(false) or allow(true) items to be put into this list
                                  }"
                         ghost-class="ghost-items"
                         :class="{
                           'disabled-draggable': isMobile || !isStatusActive || estimate.isAuthorised || isDisabledDraggable,
                           'empty-draggable': !_isEmpty(currentGroupCategory) && _isEmpty(estimateParts[card]) && !isMobile
                         }"
                         @add="onDragAdd"
                         style="margin: 0 5px"
              >
                <div v-for="(part, index) in (estimateParts[card] || [])" :key="card + '-' + part.id">
                  <div :key="card + '-' + (part && part.id ? part.id : index)">
                    <estimate-item :ref="part && part.id ? (card + '-' + part.id) : null"
                                   v-show="part && part.id && (!part.isNotCreated || part.isNotCreated === false) && !part?.ai_load"
                                   :card="card"
                                   v-bind="part"
                                   :item="part"
                                   :item2="estimateParts[card][index]"
                                   :properties="properties"
                                   @update:item="val => {$set(estimateParts[card], index, val)}"
                                   :index="'partid-' + (index + 1)"
                                   :estimateMethodology="estimateMethodology"
                                   :isInsuranceRepairYes="isInsuranceRepairYes"
                                   :isEstimateMethodologyDollars="isEstimateMethodologyDollars"
                                   :isMovedElement="computedIsMovedDraggableElement"
                                   :isAuthorizedItemList="estimate.isAuthorised"
                                   :isNegativeValueCanBeRed="isNegativeValueCanBeRed"
                                   v-bind:isOverrided="estimateParts[card]?.[index]?.isOverrided"
                                   @remove="removeEstimatePart(card,index)"
                                   @dragenter="itemOnMouseenter"
                                   @dragover="itemOnMouseover"
                                   @dragleave="itemOnMouseleave"
                                   @updateDrag="updateDrag"
                                   @onChange="autoUpdateItemsList(card,index)"
                                   @onKeyPress="onKeyPress"
                                   @onKeyPressEnter="onEnterKeyPress(part.id)"
                                   @onKeyPressLeft="onLeftKeyPress(index, part.id, ...arguments)"
                                   @onKeyPressRight="onRightKeyPress(index, part.id, ...arguments)"
                                   @onKeyPressUp="onUpKeyPress(part.id, ...arguments)"
                                   @onKeyPressDown="onDownKeyPress(part.id, ...arguments)"
                                   @onFocus="onItemFocus(part.id, index)"
                                   @onBlur="onItemBlur(part.id, index)"
                                   @openRightMenuForPaint="openMenuPaint($event, index, part)"
                                   @openRightMenuForRR="openMenuRR($event, index, part)"
                                   @openRightMenuForRepair="openMenuRepair($event, index, part)"
                                   @openRightMenuForPart="openMenuPart($event, index, part)"
                                   @openRightMenuForMaterials="openMenuMaterials($event, index, part)"
                                   @openRightMenuForSublet="openMenuSublet($event, index, part)"
                                   @openRightMenuForOther="openMenuOther($event, index, part)"
                                   @openRightMenuForRemoveLevy="openMenuForRemoveLevy($event, index, part)"
                                   @openRightMenuForPDR="openMenuPDR($event, index, part)"
                                   :showPDRPrice="isVisibleToPDRTech"
                                   :showEnviromentLevy='isShowEnvironmentLevyCalculation'
                                   :showPaintSetupTime='isShowPaintSetupCalculation'
                                   :isEnableManualAdj="isEnableManualAdj || isBlockByAuda"
                    >
                    </estimate-item>
                    <progress-bar v-show="part?.ai_load"
                                  :completed="part?.completed"
                                  :class="'estimate-items-part-max-width estimate-items-name-all'"
                                  style="height: 55px;">
                    </progress-bar>
                  </div>
                </div>
              </draggable>
              <div v-if="isMobile && selectedCard === 'Materials'">
                <button @click.prevent="selectCardSubPart({isNewItem: false,isAddToEnd:true})"
                        class="btn tab-header-orders"
                        style="min-width: 105px">
                  + New Item
                </button>
              </div>
              <div v-else-if="isMobile && selectedCard !== 'PDR'">
                <button @click.prevent="selectCardSubPart({isNewItem: true,isAddToEnd:true})"
                        class="btn tab-header-orders"
                        style="min-width: 105px">
                  + New Item
                </button>
                <button v-if="card === 'Part' && isViewIconSearchPartsAi"
                        @click.prevent="onClickCameraPart"
                        class="btn tab-header-orders"
                        style="min-width: 105px;padding: 5px 0 0 0;">
                  <i @click="onClickCameraPart" class='bx bxs-camera'
                     style="font-size: 29px;color:#5E79FF"></i>
                </button>

                <input
                    ref="fileUploadInput"
                    type="file"
                    accept="image/*"
                    style="display: none;"
                    @change="onFileSelected"
                />
                <button v-if="false && card === 'Part' && isViewIconSearchPartsAi"
                        @click.prevent="onClickUploadPart"
                        class="btn tab-header-orders"
                        style="min-width: 105px;padding: 5px 0 0 0;">
                  <i class='bx bxs-camera' style="font-size: 29px;color:#5E79FF"></i>
                </button>
              </div>
              <div v-if="isMobile && selectedCard === 'PDR'">
                <button @click.prevent="selectCardSubPart({type:'Item',isAddToEnd:true})"
                        class="btn tab-header-orders"
                        style="min-width: 105px">
                  + New Item
                </button>

              </div>
              <div v-if="isMobile && selectedCard === 'PDR'">
                <button @click.prevent="selectCardSubPart({type:'Panel', isAddToEnd:true})"
                        class="btn tab-header-orders"
                        style="min-width: 105px">
                  + New Panel
                </button>
              </div>
              <div v-if="false && isMobile && selectedCard !== 'PDR'" style="position: relative; width: 125px">
                <button @click="customMenuIsMobile = !customMenuIsMobile"
                        class="btn tab-header-orders"
                        style="min-width: 105px">
                  Custom
                </button>
                <div v-if="false && customMenuIsMobile"
                     class="mobile-custom-menu">
                  <div class="mobile-custom-menu-item"></div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- </div> -->
      </div>
    </div>
    <damage-assessment v-if="selectedCard == 'Assessment' && !isBlockByAuda"
                       :insurers="insurers"
                       :images="images"
                       :estimateId="estimateId"
                       :assessmentAi="aiResInEstimate"
                       :form-data="formDataForDA"
                       :defaultValues="defaultValues"
                       @rerun-assessment="$emit('rerun-assessment')"
                       @del-assessment="$emit('del-assessment',estimateId )"
                       @add-parts='addPartsIntoEstimate'
                       @update-vehicle="$emit('update-vehicle')"
                       @reload-estimate="$emit('reload-estimate')"

    ></damage-assessment>
    <the-orders
        v-if="isShowOrders && !isBlockByAuda"
        :card="card"
        :suppliers="orderSuppliers"
        :orders="orders"
        :manualOrders="manualOrders"
        @addManual="v => manualOrders.push(v)"
        @addPart="addManualPart"
        @removePrt="removePrt"
        @removeOrder="removeOrder"
        @autoSaveMessageUpdate="v => $emit('autoSaveMessageUpdate', v)"
        :estimateId="estimateId"
        :parts="estimateParts['Part']"
        @closeOrders="isShowOrders = false"
        @updateOrders="loadOrders"
    ></the-orders>

    <modal-wizard class="delete-supp-modal" ref="deleteConfirmModal" finishButtonText="Delete Line"
                  @on-complete="removeEstimatePart(currentPartForRemoving.card, currentPartForRemoving.index, true)">
      <modal-wizard-tab title="Delete Line">
        <div style="margin-bottom: 15px; margin-top:5px">
          Are you sure you want to delete this Line?
        </div>
      </modal-wizard-tab>
    </modal-wizard>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobile, isMobileOnly } from '../../../deviceDetect/index'
import draggable from 'vuedraggable'
import { VueContext } from 'vue-context'
import dragDropItems from '../../../mixins/drag-drop-items'
import RsRipple from '../../rs-ripple.vue'
import accounting from 'accounting'
import NumberFormatter from '../../utility/number-formatter'
import EstimateItem from '../../utility/estimate-item'
import _ from 'lodash'
import Axios from 'axios'
import datePicker from '@/components/utility/date-picker.vue'
import { appConfig } from '../../../config'
import numeral from 'numeral'
import TheOrders from './the-orders'
import sorterMethodologyParts from '../../utility/sorterMethodologyParts'
import dayjs from 'dayjs'
import DamageAssessment from '@/components/estimates/estimate-edit/damage-assessment.vue'
import progressBar from '@/components/utility/progress-bar/progress-bar.vue'

export default {
  name: 'item-list',
  mixins: [
    dragDropItems,
    sorterMethodologyParts
  ],
  props: {
    forcedSelectCard: {
      type: [String, null],
      default: null,
    },
    insurers: {
      type: Array,
      default: () => {
        return []
      }
    },
    ordersUpdater: {
      type: Number,
      default: 0,
    },
    manualOrdersUpdater: {
      type: Number,
      default: 0,
    },
    estimateRatesUpdater: {
      type: Number,
      default () {
        return 0
      }
    },
    defaultValues: {
      type: Object,
      default: () => ({})
    },
    properties: {
      type: Object,
      default () {
        return {
          isAutoSave: true,
          isFromIag: true,
          isFromEio: true,
          isBlockByAuda: false,
        }
      }
    },
    isFromIag: {
      type: Boolean,
      default: false,
    },
    isCanShowSchemeParts: {
      type: Boolean,
      default: false,
    },
    isDisabledRates: {
      type: Boolean,
      default: false,
    },
    isAutoSave: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    currentTab: {
      type: String,
      default: 'RR'
    },
    selectedSchemeParts: {
      type: Array,
      default () {
        return []
      }
    },
    timesForItemPart: {
      type: Object,
      default () {
        return {}
      }
    },
    vehicleBody: '',
    rates: {
      type: Object,
      default () {
        return {
          paint_material: 'not_set',
          paint: 0,
          repair: 0,
          rr: 0,
          rs_paint_percentage: 20,
          rs_rr_percentage: 20,
        }
      }
    },
    estimate: {
      type: Object,
      default () {
        return {
          isShowPaintSetupCalculation: true,
          isShowEnvironmentLevyCalculation: true,
          amount: 0,
          gstAmount: 0,
        }
      }
    },
    images: {
      type: Array,
      default () {
        return {}
      }
    },
    estimateId: 0,
    isShowPaintSetupCalculation: {
      type: Boolean,
      default: true,
    },
    isShowEnvironmentLevyCalculation: {
      type: Boolean,
      default: true,
    },
    isSentToIntegrationSystem: {
      type: Boolean,
      default: false,
    },
    isInsuranceRepairYes: {
      type: Boolean,
      default: false,
    },
    isEstimateForButterfly: {
      type: Boolean,
      default: false,
    },
    isRSEstimateMethodology: {
      type: Boolean,
      default: false,
    },
    isEstimateMethodologyZurich: {
      type: Boolean,
      default: false,
    },
    isEstimateMethodologyCustom: {
      type: Boolean,
      default: false,
    },
    isEstimateMethodologyLTARNTAR: {
      type: Boolean,
      default: false,
    },
    isViewRunDamageAssmnt: {
      type: Boolean,
      default: false
    },
    isVisibleToPDRTech2: {
      type: Boolean,
      default: false,
    },
    insurance: {
      type: Object,
      default () {
        return {
          pav: '',
        }
      }
    },
    estimateMethodology: {
      type: String,
      default: 'Custom',
    },
    estimateParts: [],
    removeEstimateParts: [],
    isBusinessTypeBikeRepairer: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      lastFocusedItemIndex: null,
      blurResetTimeout: null,
      customMenuIsMobile: false,
      tabsArrowLeftVisible: false,
      tabsArrowRigthVisible: true,
      orders: {},
      manualOrders: [],
      orderSuppliers: {},
      currentPartForRemoving: null,
      groupsDraggable: [],
      isMobile,
      isDisabledDraggable: false, isActiveOptionVehicleMakeOrModel: true, isShowOrders: false,
      isNotActiveOptionVehicleMakeOrModel: false,
      isShowInsertNameGRP: false,
      nameOfGroup: '',
      groups: [],
      selectedEstimateItem: {
        part: {},
        type: '',
      },
      isMovedElement: false,
      selectedCard: this._cloneDeep(this.currentTab),
      selectedCardPart: 'FRONT BAR',
      selectedCardSubPart: '',
      selectedCardSubPartForContext: {
        part: {},
      },
      selectedCardSubPartItemForContext: {},
      magicSearchEnabled: false,
      magicSearchTerm: '',
      magicSearchCardPart: '',
      magicSearchSubCardPart: '',
      isActiveButterflyBody: true,
      currentManualItemComment: '',
      currentEstimateItemComment: '',
      isVisibleToPDRTech: this.isVisibleToPDRTech2,
      NtarLtarAllowances: [ //the order of elements is important. The older ones by date should be higher
        { dateStart: '07/07/2025', value: 10.10 },
        { dateStart: '01/07/2024', value: 9.70 },
        { type: 'default', value: 9.00 },
      ]
    }
  },
  computed: {
    ...mapGetters({
      isTechnicalUser: 'isTechnicalUser',
      isCustomerUser: 'isCustomerUser',
      isEstimatorUser: 'isEstimatorUser',
      isPDRTechnicianUser: 'isPDRTechnicianUser',
      isShopManagerUser: 'isShopManagerUser',
      isProductionManagerUser: 'isProductionManagerUser',
      butterflyCategories: 'butterflyCategories',
      butterflyMatrix: 'butterflyMatrix',
      butterflyCustomMatrix: 'butterflyCustomMatrix',
      butterflySubcategories: 'butterflySubcategories',
      butterflyBodies: 'butterflyBodies',
      butterflyMatrixOrder: 'butterflyMatrixOrder',
      userInfo: 'userInfo',
      vendorInfo: 'vendorInfo',
      isStatusActive: 'isStatusActive',
      vendorId: 'vendorId',
      partCategories: 'partCategories',
    }),
    aiSettings () {
      return this.vendorInfo?.ai?.active ? this.vendorInfo.ai?.copilot : null
    },
    isViewIconSearchPartsAi () {
      return this.aiSettings?.partsInfo?.active && isMobileOnly && (!this.estimate.isAuthorised && !this.estimate.isBlockByAuda)
    },
    formDataForDA () {
      return {
        rates: this.rates,
        isTotalLoss: this.card.isTotalLoss,
        insurance: this.insurance,
        insurance_repair: this.card.insurance_repair,
        properties: this.properties,
      }
    },
    isBlockByAuda () {
      return (this.properties?.isBlockByAuda === true)
    },
    computedRRWeldPanelAllowance () {
      const dateCreatedFormating = dayjs(this.estimate.dateCreated, 'DD/MM/YYYY')
      let objectAllowance = _.find(this.NtarLtarAllowances, (item) => {
        if (item.dateStart) {
          let date = dayjs(item.dateStart, 'DD/MM/YYYY')
          return dateCreatedFormating.isSame(date) || dateCreatedFormating.isAfter(date)
        }
      })
      if (!objectAllowance) {
        objectAllowance = _.find(this.NtarLtarAllowances, (item) => {
          return item.type && item.type === 'default'
        })
      }
      return objectAllowance.value

    },
    aiResInEstimate () {
      if (this.estimate?.AI) {
        return {
          ...this.estimate?.AI,
          adjRates: this.estimate?.adjRates
        }
      }
      return {}
    },
    isAiResInEstimate () {
      return !!this.estimate?.AI
    },
    isEstimateMethodologyDollars () {
      return (this.estimateMethodology == 'dollars')
    },
    isReceivedUpdateFromRS () {
      return (this.estimate?.partssearch?.listPricesReceived || this.estimate?.partssearch?.orderedPricesReceived)
    },
    partsProfitSummary () {
      const parts = _.get(this.estimate, 'parts.Part', [])

      const totals = parts.reduce(
          (acc, part) => {

            let finallyCost
            const partQty = Number(part.qty ?? 0)
            const hasAdjPrice = part.adj_price !== null && part.adj_price !== undefined && part.adj_price !== ''
            const totalValue = Number(part.total ?? 0)
            const adjTotalValue = hasAdjPrice ? Number(part.adj_price) : null

            const costValue = Number(part.cost ?? 0)
            const mupValue = Number(part.mup ?? 0)
            const rateValue = Number(part.rate ?? 0)
            if (totalValue < 0) {
              return acc
            }
            const totalForCalc = hasAdjPrice ? adjTotalValue : totalValue
            if (totalForCalc <= 0) {
              return acc
            }
            const validTotal = Number.isFinite(totalForCalc) && totalForCalc !== 0
            const validCost = Number.isFinite(costValue) && costValue !== 0
            const validMup = Number.isFinite(mupValue) && mupValue !== 0
            const validQty = Number.isFinite(partQty) && partQty !== 0
            const validRate = Number.isFinite(rateValue) && rateValue !== 0
            if (validQty && validCost) {
              finallyCost = costValue * partQty
            } else {
              finallyCost = costValue
            }
            if (validTotal) {
              acc.total += totalForCalc
            }
            if (validCost) {
              acc.cost += finallyCost
            }
            const allFalse = [validCost, validTotal, validRate].every((value) => value === false)
            const allTrue = [validCost, validTotal, validRate].every((value) => value === true)
            if (!allFalse && !allTrue) {
              acc.hasCompleteValues = false
            }
            return acc
          },
          { total: 0, cost: 0, hasCompleteValues: true }
      )
      if (totals.total === 0 && totals.cost === 0 && parts.length === 0) {
        totals.hasCompleteValues = false
      }
      const profit = totals.total - totals.cost
      const percent = totals.total ? (profit / totals.total) * 100 : 0
      if (profit === 0 && percent === 0) {
        totals.hasCompleteValues = false
      }
      return {
        hasValue: totals.hasCompleteValues,
        profit,
        percent
      }
    },
    isAuthorised () {
      return !!(this.estimate.isAuthorised)
    },
    isNegativeValueCanBeRed () {
      return ((this.properties.isFromIag === true || this.properties.isFromEio) && this.estimate.type === 'supplement')
    },
    isCustomListsAvailable () {
      return !!this.vendorInfo.customListsAvailable
    },
    isGroupsAvailable () {
      return !!this.vendorInfo?.features?.features?.estimateCustomListsAndGroups || this.vendorInfo?.customGroupsAvailable
    },
    currentGroupCategory () {
      if (this.groups?.[this.selectedCard]?.[this.selectedCardPart]) {
        return _.uniqBy(this.groups[this.selectedCard][this.selectedCardPart], 'group.id')
      }
      return []

    },
    computedIsMovedDraggableElement () {
      return this.isMovedElement
    },
    selectedCardPartsCount: function () {
      return this.estimateParts[this.selectedCard].length
    },
    isEnableManualAdj () {
      return Boolean(this.isSentToIntegrationSystem === false)
    },
    cards: function () {
      // if (this.isEstimateMethodologyCustom) {
      //   return this.$store.state.partCategories
      // }
      // if (this.isEstimateMethodologyDollars) {
      //   return this.$store.state.partCategories
      // }
      if (!this.isEstimateMethodologyCustom && !this.isEstimateMethodologyDollars) {
        try {
          if (this.selectedCardPart != 'Custom') {
            //  this.selectedCardPart = ''   //#hotfix by #568
          }
          // if (this.selectedCardPart == '' || this.selectedCardPart == 'FRONT BAR'){

          //}
          // if (this.selectedCard != 'Other' && this.selectedCardPart != 'Custom') {
          //this.selectedCardPart = 'Front';
          //}
          return this.timesForItemPart
        } catch (erro) {
          // console.log(erro);
          //if (this.selectedCard != 'Other' && this.selectedCardPart != 'Custom') {
          //}
          return this.$store.state.partCategories

        }
      } else {
        // if (this.selectedCardPart == '' || this.selectedCardPart == 'Front'){
        //}
        // if (this.selectedCard != 'Other' && this.selectedCardPart != 'Custom') {
        // this.selectedCardPart = 'FRONT BAR';
        // }
        return this.$store.state.partCategories
      }
    },
    cardParts: function (card) {
      try {
        if (this.magicSearchCardPart == '') {
          //return _.keys(this.cards[this.selectedCard]);
          this.cardPartsCombined
        }
        var st = this.magicSearchCardPart//.toUpperCase()

        return _.filter(this.cardPartsCombined, function (i) {
          return i.match(new RegExp(st, 'i'))
        })
      } catch (erro) {
        return []
      }
    },
    butterflyCardPartsCombined () {

      //let obj = {
      //};
      let body = this.getBodyId
      let cats = _.keys(this.butterflyMatrix[body])
      let arr = []
      let vm = this
      if (this.isCustomListsAvailable || this.isGroupsAvailable) {
        arr.push('Custom')
      }
      _.forEach(cats, function (i) {
        let matrix = vm.butterflyMatrix[body][i]
        let isNeedAdd = false
        let s = _.flatten(_.values(vm.cards[vm.selectedCard]))
        _.forEach(s, function (vv) {
          _.forEach(vv, function (ii) {
            if (_.includes(matrix, Number(ii.id))) {
              isNeedAdd = true
              //break;
            }
          })
        })
        if (isNeedAdd) {
          arr.push(_.toUpper(vm.butterflyCategories[i]))
        }
      })
      //obj.cats = cats;
      //obj.arr = arr;
      //console.log('obj', obj);
      return arr
    },
    cardPartsCombined: function () {
      let arr = []
      try {
        if (this.isActiveButterflyBody && this.isActiveButterfly) {
          arr = this.butterflyCardPartsCombined
        } else {
          arr = _.flatten(_.keys(this.cards[this.selectedCard]))
        }
      } catch (error) {
        arr = []
      }

      return this.sortParts(arr, this.estimateMethodology, this.selectedSchemeParts)
    },
    cardSubParts: {
      get () {
        return _.sortBy(this.cardSubPartsAll, ['sort'])
      },
      set (v) {
        console.log(v, 'v', this.isEstimateMethodologyZurich)
        if (this.isEstimateMethodologyZurich) {
          this.sortZurichSubcategories(v)
        }
      }
    },
    cardSubPartsAll: function () {
      try {
        if (this.magicSearchSubCardPart == '') {
          //return this.cards[this.selectedCard][this.selectedCardPart];
          return this.cardSubPartsCombined
        }

        var st = this.magicSearchSubCardPart//.toUpperCase()
        return _.filter(this.cardSubPartsCombined, function (i) {
          return i.prt.match(new RegExp(st, 'i'))
        })
      } catch (error) {
        return []
      }
    },
    getButterflyMainCategoryId () {
      let vm = this
      let key = -1
      key = _.findKey(this.butterflyCategories, function (i) {
        return _.toUpper(i) == _.toUpper(vm.selectedCardPart)
      })
      return (key >= 0) ? Number(key) : -1
    },
    butterflyCardSubPartsCombined: {
      get () {
        if (!this.isActiveButterflyBody || !this.isActiveButterfly) {
          return []
        }
        if (this.selectedCardPart == 'Custom') {
          return _.flatten(_.values(this.cards[this.selectedCard]['Custom']))
        }
        let body = this.getBodyId
               console.log('butterflyCardSubPartsCombined.body', body)
        let vm = this
        console.log('this.selectedCardPart', this.selectedCardPart);
        let key = _.findKey(this.butterflyCategories, function (i) {
          return _.toUpper(i) == _.toUpper(vm.selectedCardPart)
        })
           console.log('butterflyCardSubPartsCombined.key', key)
        // console.log('bkey', key);
        if (this.butterflyMatrix &&
            this.butterflyMatrix[body] &&
            this.butterflyMatrix[body][this.selectedCard]) {
          let matrix = this.butterflyMatrix[body][key]
        }
        let matrix = this.butterflyMatrix[body][key]
        let matrixOrder = []
        if (this.butterflyMatrixOrder &&
            this.butterflyMatrixOrder[body] &&
            this.butterflyMatrixOrder[body][this.selectedCard] &&
            this.butterflyMatrixOrder[body][this.selectedCard][key]) {
          matrixOrder = this.butterflyMatrixOrder[body][this.selectedCard][key]
        }
         console.log('butterflyCardSubPartsCombined.matrix', matrix)
        // console.log('bmatrix', matrix);
        let arr = []
        let s = _.flatten(_.values(_.pickBy(this.cards[this.selectedCard], (el, key) => {
          return key != 'Custom'
        })))
         console.log('butterflyCardSubPartsCombined.s', s)
        _.forEach(s, function (v) {
          _.forEach(v, function (i) {
            if (_.includes(matrix, Number(i.id)) && !i.rate) {
              let findOrder = _.find(matrixOrder, function (o) {
                return (Number(o.id) == Number(i.id) && o.cb == 0)
              })
              //            console.log('I', i)
              //          console.log('I.prt', i.prt)
              i.sort = 0
              if (findOrder) {
                i.sort = findOrder.sort
                //          console.log('I.findOrder', findOrder)
              }
              if (!vm.isEstimateMethodologyCustom && vm.selectedCard == 'Paint') {
                if (vm.rates.paint_material == 'S1') {
                  i.hrs = i.S1
                } else if (vm.rates.paint_material == 'S2') {
                  i.hrs = i.S2
                } else if (vm.rates.paint_material == 'M1') {
                  i.hrs = i.M1
                } else if (vm.rates.paint_material == 'M2') {
                  i.hrs = i.M2
                } else if (vm.rates.paint_material == 'M3') {
                  i.hrs = i.M3
                } else if (vm.rates.paint_material == 'M3PLUS') {
                  i.hrs = i.M3PLUS
                }
              }
              arr.push(i)
            }
            //   arr.push(i);
          })
        })
        console.log('butterflyCardSubPartsCombined.ResultArr', arr)
        this.backdoorButterflyCustomMatrix += 1
        if (this.butterflyCustomMatrix && this.butterflyCustomMatrix[body] && this.butterflyCustomMatrix[body][this.selectedCard] && this.butterflyCustomMatrix[body][this.selectedCard][key] && this.butterflyCustomMatrix[body][this.selectedCard][key].length > 0) {
          let customMatrix = this.butterflyCustomMatrix[body][this.selectedCard][key]
          _.forEach(customMatrix, function (i) {
            let findOrder = _.find(matrixOrder, function (o) {
              return (Number(o.id) == Number(i.id) && o.cb == 1)
            })
            i.sort = -1
            if (findOrder) {
              i.sort = findOrder.sort
            }
            if (!vm.isEstimateMethodologyCustom && vm.selectedCard == 'Paint') {
              if (vm.rates.paint_material == 'S1') {
                i.hrs = i.S1
              } else if (vm.rates.paint_material == 'S2') {
                i.hrs = i.S2
              } else if (vm.rates.paint_material == 'M1') {
                i.hrs = i.M1
              } else if (vm.rates.paint_material == 'M2') {
                i.hrs = i.M2
              } else if (vm.rates.paint_material == 'M3') {
                i.hrs = i.M3
              } else if (vm.rates.paint_material == 'M3PLUS') {
                i.hrs = i.M3PLUS
              }
            }
            arr.push(i)
          })
        }
        let sortArr = _.sortBy(arr, ['sort'])
        // console.log('s', s);

        return sortArr
      },
      set (val) {
        this.sortButterflySubcategories(val)
      }
    },
    cardSubPartsCombined: function () {
      try {
        if (this.isActiveButterflyBody && this.isActiveButterfly) {
          return this.butterflyCardSubPartsCombined
        }
        if (['PDR'].includes(this.selectedCard)) {
          return []
        }
        return _.flatten(_.values(this.cards[this.selectedCard][this.selectedCardPart]))

      } catch (error) {
        console.log('cardSubPartsCombined', error)
        return []
      }
    },
    cardSubPartsCombinedCustom: function () {
      try {
        if (this.isActiveButterflyBody && this.isActiveButterfly) {
          return _.map(this.butterflyCardSubPartsCombined, (r) => {return r.prt})
        }
        return _.map(_.flatten(_.values(this.cards[this.selectedCard]['Custom'])), (r) => {return r.prt})
      } catch (error) {
        console.log('cardSubPartsCombined', error)
        return []
      }
    },
    availableCards: function () {
      try {
        return _.keys(this.estimateParts)
      } catch (erro) {
        return []
      }
    },
    calculatedAdjTotalPercent () {
      if (this.calculatedTotal == 0) {
        return 0
      }
      if (this.calculatedAdjTotal > this.calculatedTotal) {
        let result = accounting.toFixed(-(1 - this.calculatedAdjTotal / this.calculatedTotal) * 100, 2)
        if (result > 0) {
          return '+' + result
        } else {
          return '+' + (-1 * result)
        }
      }
      let result = accounting.toFixed((1 - this.calculatedAdjTotal / this.calculatedTotal) * 100, 2)
      if (result > 0) {
        return '-' + result
      } else {
        return result
      }
    },
    getBodyId () {
      let body = this.vehicleBody
      let key = _.findKey(this.butterflyBodies, function (i) {
        return _.toLower(i) === _.toLower(body)
      })
      return Number(key)
    },
    isBodyForButterfly () {
      return Boolean(this.isEstimateForButterfly && this.getBodyId > 0)
    },
    isActiveButterfly () {
      this.estimateRatesUpdater
      return !!(!this.isEstimateMethodologyCustom
          && !this.isEstimateMethodologyZurich
          && !this.isEstimateMethodologyDollars
          && this.isBodyForButterfly
          && this.rates
          && Number(this.rates.paint) > 0
          && this.rates.paint_material != 'not_set'
          && Number(this.rates.repair) > 0
          && Number(this.rates.rr) > 0)
    },
    isActiveButterflyMainCategory () {
      if (!this.isActiveButterfly) {
        return false
      }
      if (!this.isActiveButterflyBody) {
        return false
      }
      let a1 = this.butterflyCardPartsCombined
      let a2 = this.selectedCardPart
      if (_.findIndex(a1, function (i) {
        return _.toUpper(i) == _.toUpper(a2)
      }) != -1) {
        return true
      }

      return false
    },
    calculatedTotal () {
      let a = 0
      for (let i = 0; i < this.estimateParts[this.selectedCard].length; i++) {
        let item = this.estimateParts[this.selectedCard][i]

        if (!item) {
          continue
        }

        switch (this.selectedCard) {
          case 'Paint':
          case 'Repair':
          case 'RR':
            if (item.isSupplementDeletion) {
              break
            }
            if (this.isEstimateMethodologyDollars) {
              a += this.pT(item.rate)
              break
            }
            if (item.total_manual != null) {
              a += this.pT(item.total_manual)
              break
            }
            a += this.pT(item.total)
            break
          case 'Material':
          case 'Materials':
            if (item) {
              if (item.type === 'calculation' && item.original_total) {
                a += this.pT(item.original_total)
              } else if (item.type === 'calculation' && item.rs_rate) {
                a += this.pT(item.rs_rate)
              } else {
                a += this.pT(item.rate)
              }
            }
            break
          case 'Sublet':
            if (item.isSupplementDeletion) {
              break
            }
            a += this.pT(item.rate * (1 + item.mup / 100))
            break

          case 'Part':
            if (item.isSupplementDeletion) {
              break
            }
            a += this.pT(item.rate * item.qty * (1 + item.mup / 100))
            break

          case 'PDR':
            if (item.isSupplementDeletion) {
              break
            }
            a += this.pT(item.price * item.qty)
            break
          case 'Other':
            // console.log('Проверка на isSupplementDeletion', item)
            if (item.isSupplementDeletion) {
              break
            }
            a += this.pT(item.rate)
            break
        }

      }
      return a
    },
    calculatedAdjTotal () {
      const parts = this.estimateParts?.[this.selectedCard]
      if (!Array.isArray(parts)) {
        return 0
      }
      let a = 0
      for (let i = 0; i < parts.length; i++) {
        const item = parts[i]
        if (!item) {
          continue
        }
        if (item?.adj_approve_status === 'reported' || item?.adj_approve_status === 'denied') {
          continue
        }
        switch (this.selectedCard) {
          case 'Paint':
          case 'Repair':
          case 'RR':
            if (item.isSupplementDeletion) {
              break
            }
            if (this.isEstimateMethodologyDollars) {
              a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
              break
            }
            if (item.adj_rate !== null && item.adj_rate !== undefined && item.adj_rate !== '') {
              a += this.pT(item.adj_rate)
              break
            }
            if (item.adj_hrs != null) {
              a += this.pT(this.pT(item.adj_hrs) * this.pT(item.rate))
              break
            }
            if (item.total_manual != null) {
              a += this.pT(item.total_manual)
              break
            }
            a += this.pT(item.total)
            break
          case 'Part':
            if (item.isSupplementDeletion) {
              break
            }
            if (item.adj_rate != null) {
              a += this.pT(item.adj_rate)
            } else {
              a += this.pT(item.total)
            }
            break
          case 'Material':
          case 'Materials':
            let isUseCalcValue = false
            if ((this.properties.isFromEio || this.properties.isFromIag) && item.type == 'calculation') {
              let r = 0
              if (item.adj_rate && item.original_total && item.adj_rate == item.original_total) {
                r = 0
              } else if (item.adj_rate) {
                r = item.adj_rate
              } else if (item.original_total) {
                r = item.original_total
              }
              if (r) {
                isUseCalcValue = true
                a += this.pT(r)
              }
            }

            if (!isUseCalcValue) {
              let adj_rate = item.adj_rate
              if (this.properties?.isFromOrm && item.type === 'calculation' && item.adj_rate != null) {
                adj_rate = accounting.toFixed(item.adj_rate, 2)
              } else {
                if (item.subtype !== 'EnvironmentLevy') {
                  let hrs = null
                  if (item.type === 'manual') {
                    hrs = item.hrs
                  } else {
                    if (item.original_hrs && item.original_hrs !== null) {
                      hrs = item.original_hrs
                    } else if (item.rs_hrs && item.rs_hrs !== null) {
                      hrs = item.rs_hrs
                    } else {
                      hrs = item.hrs
                    }
                  }

                  let rate = item.material_rate

                  if (item.adj_hrs == null) {
                    adj_rate = null
                  } else if (item.adj_hrs == 0) {
                    adj_rate = 0
                  } else if (hrs != '' && hrs != null && hrs > 0) {
                    adj_rate = accounting.toFixed(rate * item.adj_hrs, 2)
                  } else {
                    adj_rate = 0
                  }
                }
                if (item.subtype == 'PaintSetupTime' && item.adj_hrs == null && item.adj_rate !== null) {
                  adj_rate = item.adj_rate
                }
              }
              if (adj_rate !== null && adj_rate !== undefined && adj_rate !== '' && !isNaN(parseFloat(adj_rate))) {
                a += this.pT(adj_rate)
              } else if (item.original_total !== null && item.original_total !== undefined && item.original_total !== '' && !isNaN(parseFloat(item.original_total))) {
                console.log('original_total', this.pT(item.original_total))
                a += this.pT(item.original_total)
              } else if (item.rs_rate !== null && item.rs_rate !== undefined && item.rs_rate !== '' && !isNaN(parseFloat(item.rs_rate))) {
                console.log('rs_rate', this.pT(item.rs_rate))
                a += this.pT(item.rs_rate)
              } else if (!isNaN(parseFloat(item.rate))) {
                console.log('rate', this.pT(item.rate))
                a += this.pT(item.rate)
              } else {
                console.log('NON')
              }
            }
            break
          case 'PDR':
            if (item.isSupplementDeletion) {
              break
            }
            if (item.adj_price !== null && item.adj_price !== undefined && item.adj_price !== '') {
              a += this.pT(item.adj_price)
            } else {
              a += this.pT(this.pT(item.price) * this.pT(item.qty))
            }
            break
          case 'Other':
            if (item.isSupplementDeletion) {
              break
            }
            a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
            break
          case 'Sublet':
            if (item.isSupplementDeletion) {
              break
            }
            a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.total)
            break
        }
      }
      return a
    },
    calculatedSubtotal () {
      let a = 0
      for (let type in this.estimateParts) {
        let items = this.estimateParts[type]
        for (let item of items) {
          if (item) {
            switch (type) {
              case 'Paint':
              case 'Repair':
              case 'RR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (this.isEstimateMethodologyDollars) {
                  a += this.pT(item.rate)
                  break
                }
                if (item.total_manual != null) {
                  a += this.pT(item.total_manual)
                  break
                }
                a += this.pT(item.total)
                break
              case 'Part':
                if (item.isSupplementDeletion) {
                  break
                }
                a += this.pT(item.total)
                break
              case 'Material':
              case 'Materials':
                if (item.type === 'calculation' && item.original_total) {
                  a += this.pT(item.original_total)
                } else if (item.type === 'calculation' && item.rs_rate) {
                  a += this.pT(item.rs_rate)
                } else {
                  a += this.pT(item.rate)
                }
                break
              case 'Sublet':
                if (item.isSupplementDeletion) {
                  break
                }
                a += this.pT(item.total)
                break
              case 'PDR':
                if (item.isSupplementDeletion) {
                  break
                }
                a += this.pT(item.price * item.qty)
                break
              case 'Other':
                if (item.isSupplementDeletion) {
                  break
                }
                a += this.pT(item.rate)
                break
            }
          }
        }
      }
      return a
    },
    calculatedAdjSubtotal () {
      let a = 0
      for (let type in this.estimateParts) {
        let items = this.estimateParts[type]
        for (let item of items) {
          if (item) {
            if (item.adj_approve_status == 'reported' || item?.adj_approve_status == 'denied') {
              continue
            }
            switch (type) {
              case 'Paint':
              case 'Repair':
              case 'RR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (this.isEstimateMethodologyDollars) {
                  a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
                  break
                }
                if (item.adj_rate != null) {
                  a += this.pT(item.adj_rate)
                  break
                }
                if (item.adj_hrs != null) {
                  let h = item.adj_hrs
                  a += this.pT(this.pT(h) * this.pT(item.rate))
                  break
                }
                if (item.total_manual != null) {
                  a += this.pT(item.total_manual)
                  break
                }
                a += this.pT(item.total)
                break
              case 'Part':
                if (item.isSupplementDeletion) {
                  break
                }
                if (item.adj_rate != null) {
                  a += this.pT(item.adj_rate)
                } else {
                  a += this.pT(item.total)
                }
                break
              case 'Material':
              case 'Materials':
                let isUseCalcValue = false
                if ((this.properties.isFromEio || this.properties.isFromIag) && item.type == 'calculation') {
                  let r = 0
                  if (item.adj_rate && item.original_total && item.adj_rate == item.original_total) {
                    r = 0
                  } else if (item.adj_rate) {
                    r = item.adj_rate
                  } else if (item.original_total) {
                    r = item.original_total
                  }
                  if (r) {
                    isUseCalcValue = true
                    a += this.pT(r)
                  }
                }

                if (!isUseCalcValue) {
                  let adj_rate = item.adj_rate
                  if (this.properties?.isFromOrm && item.type === 'calculation' && item.adj_rate != null){
                  adj_rate = accounting.toFixed(item.adj_rate, 2)
                }else {
                  if (item.subtype !== 'EnvironmentLevy') {
                    let hrs = null
                    if (item.type === 'manual') {
                      hrs = item.hrs
                    } else {
                      if (item.original_hrs && item.original_hrs !== null) {
                        hrs = item.original_hrs
                      } else if (item.rs_hrs && item.rs_hrs !== null) {
                        hrs = item.rs_hrs
                      } else {
                        hrs = item.hrs
                      }
                    }
                    let rate = item.material_rate

                    if (item.adj_hrs == null) {
                      adj_rate = null
                    } else if (item.adj_hrs == 0) {
                      adj_rate = 0
                    } else if (hrs != '' && hrs != null && hrs > 0) {
                      adj_rate = accounting.toFixed(rate * item.adj_hrs, 2)
                    } else {
                      adj_rate = 0
                    }
                  }

                  if (item.subtype == 'PaintSetupTime' && item.adj_hrs == null && item.adj_rate !== null) {
                    adj_rate = item.adj_rate
                  }
                }
                  if (adj_rate !== null && adj_rate !== undefined && adj_rate !== '' && !isNaN(parseFloat(adj_rate))) {
                    a += this.pT(adj_rate)
                  } else if (item.original_total !== null && item.original_total !== undefined && item.original_total !== '' && !isNaN(parseFloat(item.original_total))) {
                    a += this.pT(item.original_total)
                  } else if (item.rs_rate && !isNaN(parseFloat(item.rs_rate))) {
                    a += this.pT(item.rs_rate)
                  } else if (!isNaN(parseFloat(item.rate))) {
                    a += this.pT(item.rate)
                  }
                }
                break
              case 'PDR':
                if (item.isSupplementDeletion) {
                  break
                }
                if (item.adj_price !== null && item.adj_price !== undefined && item.adj_price !== '') {
                  a += this.pT(item.adj_price)
                } else if (item.adj_qty !== null && item.adj_qty !== undefined && item.adj_qty !== '') {
                  a += this.pT(this.pT(item.adj_qty) * this.pT(item.price))
                } else {
                  a += this.pT(this.pT(item.price) * this.pT(item.qty))
                }
                break
              case 'Other':
                if (item.isSupplementDeletion) {
                  break
                }
                a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.rate)
                break
              case 'Sublet':
                if (item.isSupplementDeletion) {
                  break
                }
                a += item.adj_rate != null ? this.pT(item.adj_rate) : this.pT(item.total)
                break
            }
          }
        }
      }
      a=_.round(a, 2)
      this.estimate.amount = _.round(a, 2) + _.round((a * 0.1), 2)
      this.estimate.gstAmount = _.round((a * 0.1), 2)
      return a
    },
    calculatedAdjSubtotalPercent () {
      if (this.calculatedAdjSubtotal == 0 || this.calculatedSubtotal == 0) {
        return 0
      }
      if (this.calculatedAdjSubtotal > this.calculatedSubtotal) {
        let result = accounting.toFixed(-(1 - this.calculatedAdjSubtotal / this.calculatedSubtotal) * 100, 2)
        if (result > 0) {
          return '+' + result
        } else {
          return '+' + (-1 * result)
        }
      }
      let result = accounting.toFixed((1 - this.calculatedAdjSubtotal / this.calculatedSubtotal) * 100, 2)
      if (result > 0) {
        return '-' + result
      } else {
        return result
      }
    },
  },
  mounted () {
    this.loadCustomGroups()

    if (this.currentTab == 'PDR') {
      this.selectCard(this.currentTab)
    }

  },
  methods: {
    ...mapActions([
      'setButterflyMatrixOrder',
      'addToButterflyCustomMatrix',
      'addItemToJobs',
      'removeFromButterflyCustomMatrix',
      'removeItemFromJobs',
    ]),
    onClickUploadPart () {
      // Trigger the hidden file input
      const fileInput = this.$refs.fileUploadInput
      if (fileInput) {
        // Handle both single element and array of elements
        if (Array.isArray(fileInput)) {
          fileInput[0]?.click()
        } else {
          fileInput.click()
        }
      }
    },
    async onFileSelected (event) {
      const file = event.target.files[0]
      if (!file) return

      // Validate file type
      if (!file.type.startsWith('image/')) {
        toastr.error('Please select an image file')
        return
      }

      try {
        // Convert file to base64
        const base64Image = await this._convertFileToBase64(file)

        // Send to AI using the same event as camera
        this.$emit('upload-image', base64Image)

        // Reset input for next upload
        event.target.value = ''
      } catch (error) {
        console.error('Error processing image:', error)
        toastr.error('Failed to process image')
      }
    },
    _convertFileToBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          // Extract base64 data (remove data:image/...;base64, prefix if present)
          const base64 = reader.result
          resolve(base64)
        }
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file)
      })
    },
    async onClickCameraPart () {
      this.$emit('open-camera', 'part')
    },
    getEstimateId () {
      return this.estimate.id
    },
    onItemFocus (itemId, index) {
      // Track the index of the currently focused item
      this.lastFocusedItemIndex = index
      console.log('Item focused:', itemId, 'at index:', index)
    },
    onItemBlur (itemId, index) {
      // Clear any existing timeout
      if (this.blurResetTimeout) {
        clearTimeout(this.blurResetTimeout)
      }

      // Delay reset to allow button click to process first
      this.blurResetTimeout = setTimeout(() => {
        // Only reset if this is still the focused item (no new focus occurred)
        if (this.lastFocusedItemIndex === index) {
          this.lastFocusedItemIndex = null
          console.log('Item blurred (delayed):', itemId, 'at index:', index)
        } else {
          console.log('Item blurred but new focus detected, keeping index:', this.lastFocusedItemIndex)
        }
      }, 200) // 200ms delay allows click event to fire first
    },
    isAllGroupItemsAlreadyAdded (item) {
      return item?.items?.length == _.filter(item.items, (i) => {return this.isAlreadyAddedGroupItem(i)}).length
    },
    isAlreadyAddedGroupItem (item) {
      return _.some(this.estimateParts[this.selectedCard], (part) => {
        return _.trim(_.toUpper(item.name)) == _.trim(_.toUpper(part.name))
      })
    },
    isGroupIncludesName (group, part) {
      return _.some(group.items, (item) => {
        return _.trim(_.toUpper(item.name)) == _.trim(_.toUpper(part.name))
      })
    },
    isCanAddToSupp (part) {
      return this.isAuthorised && part && ((part.onReportRepairer && part.onReportRepairer.flag) || (part.adj_approve_status == 'reported'))
    },
    isOnReport (part) {
      return part && part.onReportRepairer && part.onReportRepairer.flag
    },
    isCanRemoveOnReport (part) {
      return part && part.onReportRepairer && part.onReportRepairer.canBeRemoved && part.onReportRepairer.flag
    },
    isCanOnReport (part) {
      return part && !(part.onReportRepairer && part.onReportRepairer.flag)
    },
    _isEmpty (v) {
      return _.isEmpty(v)
    },
    getSelectedSchemePart () {
      if (!_.isEmpty(this.selectedSchemeParts) && this.isCanShowSchemeParts) {
        return _.first(this.cardParts)
      }
      return ''
    },
    getHourForCategory (sp) {
      let prt_hours = 0
      if (!(['RR', 'Repair', 'Paint'].includes(this.selectedCard))) {
        return prt_hours
      }
      if (this.selectedCard == 'Paint') {
        if (this.isEstimateMethodologyCustom) {
          prt_hours = sp.hrs
        } else {
          //console.log(sp);
          if (this.rates.paint_material == 'S1' && sp.hasOwnProperty('S1')) {
            prt_hours = sp.S1
          } else if (this.rates.paint_material == 'S2' && sp.hasOwnProperty('S2')) {
            prt_hours = sp.S2
          } else if (this.rates.paint_material == 'M1' && sp.hasOwnProperty('M1')) {
            prt_hours = sp.M1
          } else if (this.rates.paint_material == 'M2' && sp.hasOwnProperty('M2')) {
            prt_hours = sp.M2
          } else if (this.rates.paint_material == 'M3' && sp.hasOwnProperty('M3')) {
            prt_hours = sp.M3
          } else if (this.rates.paint_material == 'M3PLUS' && sp.hasOwnProperty('M3PLUS')) {
            prt_hours = sp.M3PLUS
          } else {
            prt_hours = sp.hrs
          }
        }
      } else {
        prt_hours = sp.hrs
      }
      if (this.isRSEstimateMethodology && this.selectedCardPart != 'Custom') {
        prt_hours = this.calculateHoursForRS(prt_hours)
      }
      return prt_hours
    },
    isMobileOnly () {
      return isMobileOnly
    },
    calculateHoursForRS (hours) {
      if (['RR', 'Repair', 'Paint'].includes(this.selectedCard)) {
        if (this.selectedCardPart != 'Custom') {
          let percentage = 20
          if (this.vendorId == 147 || this.vendorId == 94  || this.vendorId == 99  || this.vendorId == 98  || this.vendorId == 38 || this.vendorId == 50 || this.vendorId == 13 || this.vendorId == 4 || this.vendorId == 44 || this.vendorId == 39 || this.vendorId == 42 || this.vendorId == 109) {
            if (this.selectedCard == 'RR') {
              percentage = Number(this.rates.rs_rr_percentage)
            } else if (this.selectedCard == 'Paint') {
              percentage = Number(this.rates.rs_paint_percentage)
            }
          }
          console.log('percentage=', percentage)
          hours = parseFloat(accounting.toFixed(hours * ((100 + percentage) / 100), 2))
        }
      }
      return hours
    },
    addManualPart (id) {
      let prtId = Math.random()
      let item = {
        id: prtId,
        'manualOrderId': null,
        'description': '',
        'number': null,
        'type': null,
        'qtyOrdered': null,
        'qtyReceived': null,
        'cost': null,
        'list': null,
        'invoiceNumber': null,
        'totalManual': null,
        'createdOn': null,
        'updatedOn': null
      }
      let orderInd = _.findIndex(this.manualOrders, (o) => {
        return Number(o.id) == Number(id)
      })

      if (orderInd !== -1) {
        this.manualOrders[orderInd].items.push(item)
      }

      this.$emit('autoSaveMessageUpdate', 'Saving...')

      Axios.post(`/fe/estimate/manual-orders/${id}/items/add`, {
        'description': '',
        'number': '',
        'type': '',
        'invoiceNumber': '',

      }).then((r) => {
        if (r.data._status && r.data.item) {
          this.$emit('autoSaveMessageUpdate', 'Saved')
          let ind = _.findIndex(this.manualOrders[orderInd].items, (itm) => {
            return Number(itm.id) == Number(prtId)
          })
          if (ind !== -1) {
            this.manualOrders[orderInd].items[ind].id = r.data.item.id
          }
        } else {
          this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
        }
      })
          .catch(() => {
            this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
          })

    },
    isArrowActive: function (evt, el) {
      if (evt.srcElement.scrollLeft > 1) {
        this.tabsArrowLeftVisible = true
      }
      if (evt.srcElement.scrollLeft == 0) {
        this.tabsArrowLeftVisible = false
      }
      if (evt.srcElement.scrollLeft + evt.srcElement.offsetWidth != evt.srcElement.scrollWidth) {
        this.tabsArrowRigthVisible = true
      }
      if (evt.srcElement.scrollLeft + evt.srcElement.offsetWidth == evt.srcElement.scrollWidth) {
        this.tabsArrowRigthVisible = false
      }
    },
    removePrt (v) {
      let orderInd = _.findIndex(this.manualOrders, (o) => {
        return Number(o.id) == Number(v.orderId)
      })
      if (orderInd !== -1) {
        let prtInd = _.findIndex(this.manualOrders[orderInd].items, (p) => {
          return Number(p.id) == Number(v.prtId)
        })
        if (prtInd !== -1) {
          this.manualOrders[orderInd].items.splice(prtInd, 1)
        }
      }
    },
    removeOrder (v) {
      let orderInd = _.findIndex(this.manualOrders, (o) => {
        return Number(o.id) == Number(v)
      })
      if (orderInd !== -1) {
        this.manualOrders.splice(orderInd, 1)
      }
    },
    switchOrdersVisibility () {
      if (!this.isShowOrders) {
        this.loadOrders()
      }
      this.isShowOrders = !this.isShowOrders
    },
    loadPSOrders () {
      Axios.post('/fe/estimate/partssearch/get-orders',
          {
            estimateId: this.estimateId
          })
          .then(response => {
            if (response.data._status) {
              if (!_.isEmpty(response.data.orders)) {
                this.orders = response.data.orders
              } else {
                this.orders = {}
              }
              if (!_.isEmpty(response.data.suppliers)) {
                this.orderSuppliers = response.data.suppliers
              } else {
                this.orderSuppliers = {}
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    loadManualOrders () {
      Axios.get(`/fe/estimate/${this.estimateId}/manual-orders`,)
          .then(response => {
            if (response.data._status) {
              if (!_.isEmpty(response.data.orders)) {
                this.manualOrders = response.data.orders
              } else {
                this.manualOrders = []
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
    loadOrders () {
      this.loadPSOrders()
      this.loadManualOrders()
    },
    _cloneDeep (v) {
      return _.cloneDeep(v)
    },
    viewPricing () {
      let url = appConfig.appPartsSearchURL + '/r/rfq/' + this.estimate?.partssearch?.rfqId;
      //empty line
      (async (url) => {
        const popup = window.open('', '_blank')
        if (popup) {
          popup.location.href = url
          setTimeout(() => {
            popup.focus()
          }, 1000)
        }
      })(url)
    },
    updateDrag (value) {
      this.isDisabledDraggable = !value
    },
    getTotal (field, card) {
      let r = 0
      let field2 = 'hrs'
      _.forEach(this.estimateParts[card], (p) => {
        if ((_.isString(p[field]) || _.isNumber(p[field])) && !_.isNaN(p[field])) {
          r += Number(p[field])
        } else if ((field == 'adj_hrs') && (_.isString(p[field2]) || _.isNumber(p[field2])) && !_.isNaN(p[field2])) {
          r += Number(p[field2])
        }
      })
      return numeral(r).format('0,0.00')
    },
    saveAuthDate () {
      this.$emit('saveItems', { authorityDate: this.estimate.authorityDate })
    },
    isNeedChangePosition (id, index) {
      setTimeout(() => {
        let element = document.getElementById(id)

        if (!element) {
          return false
        }
        let domRect = element.getBoundingClientRect()
        let spaceBelow = window.innerHeight - domRect.bottom
        console.log(spaceBelow, 'spaceBelow')
        this.$nextTick(() => {
          this.$set(this.estimateParts[this.selectedCard][index], 'isNeedChangePosition', !!(spaceBelow <= 86))
        })
      }, 500)
    },
    addGroupItem (item, ind = -1) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      console.log('addGroupItemInd=', ind)
      let selectedParts = this.estimateParts[this.selectedCard]
      let tmpId = 'tmp' + Math.random().toString(36).substring(2, 10)

      let newItem = {}

      if (this.selectedCard == 'RR') {
        newItem = {
          id: tmpId,
          name: item.name,
          rate: item.rate ? item.rate : null,
          rate2: item.rate2 ? item.rate2 : null,
          hrs: item.hours,
          total: item.total ? item.total : null,
          adj_hrs: item.adj_hrs ? item.adj_hrs : null,
          adj_rate: item.adj_rate ? item.adj_rate : null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
          total_manual: item.total_manual ? item.total_manual : null,
          isNotCreated: true,
        }
      } else if (this.selectedCard == 'Repair') {
        newItem = {
          hrs: item.hours,
          id: tmpId,
          name: item.name,
          rate: item.rate ? item.rate : null,
          rate2: item.rate2 ? item.rate2 : null,
          total: item.total ? item.total : null,
          adj_hrs: item.adj_hrs ? item.adj_hrs : null,
          adj_rate: item.adj_rate ? item.adj_rate : null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
          isNotCreated: true,
          total_manual: item.total_manual ? item.total_manual : null,
        }
      } else if (this.selectedCard == 'Paint') {
        newItem = {
          hrs: item.hours,
          id: tmpId,
          name: item.name,
          paint_type: this.rates.paint_material ? this.rates.paint_material : 'not_set',
          rate: item.rate ? item.rate : null,
          total: item.total ? item.total : null,
          adj_hrs: item.adj_hrs ? item.adj_hrs : null,
          adj_rate: item.adj_rate ? item.adj_rate : null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
          isNotCreated: true,
          total_manual: item.total_manual ? item.total_manual : null,
        }
      } else if (this.selectedCard == 'Part') {
        newItem = {
          part_num: item.part_num ? item.part_num : '',
          type: item.type ? item.type : 'New',
          mup: item.mup ? item.mup : null,
          qty: item.qty ? item.qty : 1,
          id: tmpId,
          name: item.name,
          rate: item.rate ? item.rate : null,
          total: item.total ? item.total : null,
          adj_rate: item.adj_rate ? item.adj_rate : null,
          adj_price: item.adj_price ? item.adj_price : null,
          adj_total: null,
          adj_mup: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
          isNotCreated: true,
        }
      } else if (this.selectedCard == 'Sublet') {
        newItem = {
          hrs: item.hours,
          id: tmpId,
          name: item.name,
          rate: item.rate ? item.rate : null,
          total: item.total ? item.total : null,
          adj_rate: item.adj_rate ? item.adj_rate : null,
          adj_price: item.adj_price ? item.adj_price : null,
          is_show_in_jobcard: true,
          comments: {},
          adj_approve_status: 'none',
          isNotCreated: true,
          mup: item.mup ? item.mup : null,
          repairer: item.repairer ? item.repairer : null
        }
      } else if (this.selectedCard == 'Other') {
        newItem = {
          hrs: item.hours,
          id: tmpId,
          name: item.name,
          rate: item.rate ? item.rate : null,
          total: item.total ? item.total : null,
          adj_rate: item.adj_rate ? item.adj_rate : null,
          adj_price: item.adj_price ? item.adj_price : null,
          adj_mup: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
          isNotCreated: true,
        }
      } else if (this.selectedCard === 'PDR') {
        newItem = {
          id: tmpId,
          type: item.type ? item.type : 'Item',
          name: item.name,
          material: item.material ? item.material : 'None',
          action: item.action ? item.action : 'None',
          qty: item.qty ? item.qty : 1,
          price: item.rate ? item.rate : null,
          comment: '',
          adj_qty: null,
          adj_price: null,
          is_show_in_jobcard: true,
          comments: {},
          isNotCreated: true,
        }
      }
      if (ind == -1) {
        selectedParts.push(newItem)
      } else {
        selectedParts.splice(ind, 0, newItem)
      }
      let estimateId = this.estimateId
      this.$emit('autoSaveMessageUpdate', 'Saving...')
      Axios({
        method: 'post',
        responseType: 'json',
        headers: { 'addPart': true },
        url: `/fe/estimate/${estimateId}`,
        validateStatus: function (status) {
          return status < 500
        },
        data: { part: newItem, type: this.selectedCard }
      })
          .then(response => {
            if (response.status === 200 && response.data.result.id) {
              this.$emit('autoSaveMessageUpdate', 'Saved')
              newItem.id = response.data.result.id
              newItem.isNotCreated = false
            } else {
              this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
              return false
            }
          })
          .catch(error => {
            this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
            return false
          })
    },
    changeGroupItemsOrder (event, group, items) {
      if (!items) {
        return
      }
      var sort = []
      this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
      items.forEach(function (el, index) {
        sort.push({ id: el.id, index: index + 1 })
        el.sort = index + 1
      })

      items = _.sortBy(items, ['sort', 'id'])
      Axios.post('/fe/parts/custom-group/order-items',
          {
            groupId: group.id,
            sort: sort,
          })
          .then(response => {
            if (response.data._status) {
              this.$emit('autoSaveMessageUpdate', 'Saved')
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(() => {
        NProgress.done()
      })
    },
    addMakeAndModelToGroupItem (data) {
      if (_.isEmpty(this.card.vehicle.make) && _.isEmpty(this.card.vehicle.model)) {
        return false
      }
      if (data.make === '') {
        data.make = this.card.vehicle.make
      }
      if (data.model === '') {
        data.model = this.card.vehicle.model
      }
      data.applyTo.nonscheduled = false
      data.applyTo.ntar = false
      data.applyTo.ltar = false
      data.applyTo.rs = false
      data.applyTo.zurich = false
      this.updateGroupName(data)
    },
    clearGroupItemMakeAndModel (data) {
      data.make = ''
      data.model = ''
      data.applyTo.nonscheduled = true
      data.applyTo.ntar = true
      data.applyTo.ltar = true
      data.applyTo.rs = true
      data.applyTo.zurich = true
      this.updateGroupName(data)
    },
    onChangeGroupCheckboxes (group) {
      console.log(group.applyTo, group)
      if (!group.applyTo.nonscheduled && !group.applyTo.ntar && !group.applyTo.ltar && !group.applyTo.rs && !group.applyTo.zurich) {
        if (group.make === '') {
          group.make = this.card.vehicle.make
        }
        if (group.model === '') {
          group.model = this.card.vehicle.model
        }
        this.isActiveOptionVehicleMakeOrModel = true
        this.isNotActiveOptionVehicleMakeOrModel = false
      } else if (group.applyTo.nonscheduled || group.applyTo.ntar || group.applyTo.ltar || group.applyTo.rs || group.applyTo.zurich) {
        group.make = ''
        group.model = ''
        this.isActiveOptionVehicleMakeOrModel = false
        this.isNotActiveOptionVehicleMakeOrModel = false
      }

      this.updateGroupName(group)
    },
    updateGroupName (group) {
      Axios.post('/fe/parts/custom-groups/update',
          {
            groupId: group.id,
            name: group.name,
            make: group.make,
            model: group.model,
            applyTo: group.applyTo,
          })
          .then(response => {
            if (response.data._status) {

            }
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
          })
    },
    updateGroupItemName (groupItem) {
      Axios.post('/fe/parts/custom-group/update-item',
          {
            itemId: groupItem.id,
            name: groupItem.name,
            hours: groupItem.hours,
            rate: groupItem.rate,
          })
          .then(response => {
            if (response.data._status) {

            }
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
          })
    },
    deleteCustomGroup (groupId, index) {
      Axios.post('/fe/parts/custom-groups/delete',
          {
            groupId: groupId
          })
          .then(response => {
            if (response.data._status) {
              toastr.success('The Group has been deleted')
              this.groups[this.selectedCard][this.selectedCardPart].splice(index, 1)
            }
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
          })
    },
    deleteItemOfCustomGroup (itemId, index1, index2) {
      Axios.post('/fe/parts/custom-group/delete-item',
          {
            itemId: itemId
          })
          .then(response => {
            if (response.data._status) {
              toastr.success('The Group Item has been deleted')
              this.groups[this.selectedCard][this.selectedCardPart][index1].items.splice(index2, 1)
            }
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
          })
    },
    addNewGroup: function (nameOfGroup) {
      if (!this.card.vehicle.make) {
        toastr.error('Make field must not be empty')
        return
      } else if (!this.card.vehicle.model) {
        toastr.error('Model field must not be empty')
        return
      }
      Axios.post('/fe/parts/custom-groups/add',
          {
            name: nameOfGroup,
            type: this.selectedCard,
            categoryName: this.selectedCardPart,
            make: this.card.vehicle.make,
            model: this.card.vehicle.model,
          })
          .then(response => {
            if (response.data._status) {
              this.loadCustomGroups()
            }
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
          })
      this.nameOfGroup = ''
      this.isShowInsertNameGRP = false
    },
    selectGroupItem (item) {
      this.$refs.rightClickMenuForGroup.close()
      if (this.isAlreadyAddedGroupItem(item)) {
        return
      }
      this.addGroupItem(item)
    },
    openGroupWhenAdded (idGroup) {
      let item = _.filter(this.groups[this.selectedCard][this.selectedCardPart], function (groupItem) {
        return groupItem.group.id === idGroup
      })
      let index = this.groups[this.selectedCard][this.selectedCardPart].indexOf(item[0])
      this.$refs.rightClickMenuForGroup.close()
      this.$set(this.groups[this.selectedCard][this.selectedCardPart][index].group, 'isShowItems', true)
    },
    onRightClickByGroup (e, data) {
      console.log('onRightClickByGroup', this.groups[this.selectedCard][this.selectedCardPart], data)
      let item = _.filter(this.groups[this.selectedCard][this.selectedCardPart], function (groupItem) {
        return groupItem.group === data.item
      })
      let type = data.type
      let index = this.groups[this.selectedCard][this.selectedCardPart].indexOf(item[0])
      if (type === 1) {
        this.$refs.rightClickMenuForGroup.close()
        this.$set(this.groups[this.selectedCard][this.selectedCardPart][index].group, 'isShowItems', true)
      } else if (type === 2) { // apply group items
        if (!item[0] || !item[0].items) {
          return
        }
        let vm = this
        _.forEach(item[0].items, function (subItem) {
          if (!vm.isAlreadyAddedGroupItem(subItem)) {
            vm.addGroupItem(subItem)
          }
        })
        this.$refs.rightClickMenuForGroup.close()
      } else if (type === 3) {
        this.$refs.rightClickMenuForGroup.close()
        this.$refs[data.item.name][0].focus()
      } else if (type === 4) {
        this.$refs.rightClickMenuForGroup.close()
        let groupId = this.groups[this.selectedCard][this.selectedCardPart][index].group.id
        this.deleteCustomGroup(groupId, index)
      } else if (type === 5) {
        this.$refs.rightClickMenuForGroup.close()
        this.$set(this.groups[this.selectedCard][this.selectedCardPart][index].group, 'isShowItems', false)
      }

    },
    onRightClickByGroupItem (e, data) {
      let type = data.type
      let item = _.filter(this.groups[this.selectedCard][this.selectedCardPart], function (groupItem) {
        return groupItem.items === data.items
      })
      let index1 = this.groups[this.selectedCard][this.selectedCardPart].indexOf(item[0])
      let subItem = _.filter(this.groups[this.selectedCard][this.selectedCardPart][index1].items, function (item) {
        return item === data.subItem
      })
      let index2 = this.groups[this.selectedCard][this.selectedCardPart][index1].items.indexOf(subItem[0])
      if (type === 1) {
        this.deleteItemOfCustomGroup(data.subItem.id, index1, index2)
      } else if (type === 2) {
        this.$refs[data.subItem.name][0].focus()
      }
    },
    pT (value) {
      return parseFloat(accounting.toFixed(parseFloat(value), 2))
    },
    onDragEstimateItemStart () {
      try {
        this.isMovedElement = false
        if (document && document.body && document.body.classList) {
          document.body.classList.add('no-select')
        }
      } catch (e) {}

    },
    onDragEstimateItemEnd () {
      try {
        this.isMovedElement = true
        if (document && document.body && document.body.classList) {
          document.body.classList.remove('no-select')
        }
        if (window && window.getSelection) {
          const sel = window.getSelection()
          if (sel && sel.removeAllRanges) {
            sel.removeAllRanges()
          }
        }
      } catch (e) {}

    },
    updateShowImportPdfParts (status) {
      this.$emit('updateShowImportPdfParts', this.estimateId, status)
    },
    setUpdateData: function (v) {
      this.$emit('beforeDebouncedUnsavedChanges')
      if (!this.isAutoSave) {
        return
      }

      this.$emit('saveItems', v)

      //ToDo need to add beforeDebouncedAutoSave emit
    },
    moveDraggebleElement (q, w) {
      console.log('moveDraggebleElement', q, w)
//                let el = q.dragged;
//console.log('evt.dragged',q.dragged);
//console.log('evt.draggedRect',q.draggedRect);
//console.log('evt.related',q.related);
//console.log('evt.relatedRect',q.relatedRect);
//console.log('evt.willInsertAfter',q.willInsertAfter);
//console.log('evt.clientY',w.clientY);
//console.log('evt',q);
//console.log('evt2',w);
//if (q.willInsertAfter) {
//    q.related.scrollIntoView({block: 'start'});
//}else{
//    q.related.scrollIntoView({block: 'end'});
//}
    },
    isOverridedMaterialTotal (index) {
      if (this.estimateParts['Materials'] && this.estimateParts['Materials'][index] && this.estimateParts['Materials'][index].isOverrided) {
        return true
      }
      return false
    },
    orderItemParts () {
      this.$emit('beforeDebouncedUnsavedChanges')
      const card = this.selectedCard
      const sort = []
      const parts = this.estimateParts?.[card]
      if (Array.isArray(parts)) {
        const hasPartWithoutId = parts.some((el) => el && (el.id === undefined || el.id === null))
        if (hasPartWithoutId) {
          return
        }
        parts.forEach(function (el, index) {
          if (!el || el.id === undefined || el.id === null) {
            return
          }
          sort.push({ id: el.id, index: index })
        })
      }
      let update = {}
      update.sort = []
      update.sort.push({ sort: sort, card: card })
      this.setUpdateData(update)

    },
    onItemMoveChange: function (event) {
      if (!event) return false

      // console.log('onItemMoveChange', event);
      if (!event.moved && !event.dragged) {
        return false
      }

      this.$nextTick(() => {
        this.orderItemParts()
      })
      return true
    },
    onSubCategoryMoveChange: function (event) {
      this.$emit('beforeDebouncedUnsavedChanges')
      var card = this.selectedCard
      var sort = []
      console.log('onSubCategoryMoveChange', event)
      return
      if (this.estimateParts[card]) {
        this.estimateParts[card].forEach(function (el, index) {
          sort.push({ id: el.id, index: index })
        })
      }
      let update = {}
      update.sort = []
      update.sort.push({ sort: sort, card: card })
      this.setUpdateData(update)

      return true
    },

    sortButterflySubcategories (val) {
      if (this.isEstimateMethodologyZurich) {
        return
      }
      console.log('sortButterflySubcategories', val)
      let sort = []
      let index = 0
      _.forEach(val, function (i) {
        index++
        sort.push({
          id: Number(i.id),
          cb: (i.cb && i.cb == 1) ? 1 : 0,
          sort: index,
        })
      })
      let data = {
        sort: sort,
        categoryId: this.getButterflyMainCategoryId,
        bodyId: this.getBodyId,
        type: this.selectedCard,
      }
      this.setButterflyMatrixOrder(data)
      Axios.post('/fe/parts/directory/order-subcategories', data)
    },
    sortZurichSubcategories (val) {
      let sort = []
      let index = 0
      _.forEach(val, function (i) {
        index++
        sort.push({
          id: Number(i.id),
          name: i.prt,
          cb: (i.cb && i.cb == 1) ? 1 : 0,
          sort: index,
        })
      })
      let data = {
        sort: sort,
        mainCategory: this.selectedCardPart,
        isZurich: true,
        type: this.selectedCard,
      }
      this.$emit('changeSubParts', {
        data: val,
        mainCategory: this.selectedCardPart,
        type: this.selectedCard,
      })
      Axios.post('/fe/parts/directory/order-subcategories-zurich', data).then((r) => {
        if (r.data._status) {
          this.$emit('loadTimesForItemPart')
        }
      })
    },
    autoUpdateItemsList: function (card, index) {
      console.log('autoUpdateItemsList', card, index)
      if (!this.isStatusActive || (this.isBlockByAuda && card !== 'Part')) {
        return
      }
      let update = {}
      update.parts = []
      let vm = this

      //if (card === 'Materials') {
      //    this.$set(this.estimateParts[card][index], 'makeAdjustment', true);
      //}

      //  console.log(card, index, vm.estimateParts[card][index])

      setTimeout(function () {
        let part = vm.estimateParts[card][index]
        update.parts.push({ part: part, type: card })
        console.log('Item Update!!!', update)
        vm.setUpdateData(update)

      }, 1000)
    },
    autoUpdateRemoveParts: function () {
      let update = {}
      update.removeParts = this.removeEstimateParts
      this.setUpdateData(update)

    },
    removeEstimatePart (card, index, isFromModal = false) {
      if (!this.isStatusActive) {
        return
      }
      if (isFromModal) {
        this.$refs.deleteConfirmModal.hide()
      }
      let part = this.estimateParts[card][index]
      console.log('removeEstimatePart', part)
      if (this.isBlockByAuda && part?.externalId !== 0) {
        return
      }
      if (!isFromModal && part?.id && (part?.adj_approve_status == 'reported' || part?.adj_approve_status == 'approved' || part?.adj_approve_status == 'denied' || part?.addedByAssessor)) {
        this.currentPartForRemoving = {
          card: card,
          index: index,
        }
        this.$refs.deleteConfirmModal.show()
        return
      }

      if (this.estimateParts[card][index].id != null) {
        this.removeEstimateParts[card].push(this.estimateParts[card][index].id)
      }
      var vm = this

      this.estimateParts[card].splice(index, 1)

      setTimeout(() => {
        vm.autoUpdateRemoveParts()
      }, 200)
    },
    togglePDRVisible (e) {
      if (!this.isStatusActive) {
        return
      }
      e.preventDefault()
      this.isVisibleToPDRTech = !this.isVisibleToPDRTech
      let update = {}
      update.isVisibleToPDRTech = this.isVisibleToPDRTech
      this.setUpdateData(update)

    },
    openMenuButterflyCustom: function (e, data) {
      //console.log('e', e);
      //console.log('data', data);
    },
    openMenuPDR: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'PDR'
      this.$refs.rightClickMenuForPDR.open(e, index)
    },
    onRightClickAddPart: function (card, newItem) {
      var estimateId = this.estimateId
      this.$emit('autoSaveMessageUpdate', 'Saving...')
      var vm = this
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          Axios({
            method: 'post',
            responseType: 'json',
            headers: { 'addPart': true },
            url: `/fe/estimate/${estimateId}`,
            validateStatus: function (status) {
              return status < 500
            },
            data: { part: newItem, type: card }
          })
              .then(response => {
                if (response.status === 200) {
                  if (response.data.result.id) {
                    vm.$emit('autoSaveMessageUpdate', 'Saved')
                    newItem.id = response.data.result.id
                    if (response.data.result.calculation) {
                      vm.$emit('updateCalculation', response.data.result.calculation, estimateId)
                    }
                    resolve(newItem)
                  } else {
                    vm.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
                  }
                } else {
                  vm.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
                  reject(false)
                }
              })
              .catch(error => {
                vm.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
                reject(false)
              })
        }, 50)
      })
    },
    addToCategoryGroup (item, data) {
      this.$refs[data.ref].close()
      var index = data.index
      var elem = this.estimateParts[this.selectedCard][index]
      console.log('addToCategoryGroup', elem, this.selectedCard)
      if (elem.name === '' || elem.name === null) {
        toastr.error('Name field must not be empty')
        return
      } else if ((elem.hrs === '' || elem.hrs === null) && !this.isEstimateMethodologyDollars && (this.selectedCard !== 'Part' && this.selectedCard !== 'Other' && this.selectedCard !== 'Sublet' && this.selectedCard !== 'PDR' && this.selectedCard !== 'Materials')) {
        toastr.error('Hours field must not be empty')
        return
      } else if ((elem.rate === '' || elem.rate === null) && !this.isEstimateMethodologyDollars && (this.selectedCard !== 'Part' && this.selectedCard !== 'PDR' && this.selectedCard !== 'Materials')) {
        toastr.error('Rate field must not be empty')
        return
      }

      let result = {
        groupId: data.group.id,
        name: elem.name,
        hours: elem.hrs ? elem.hrs : 1,
        rate: elem.rate ? elem.rate : 0,
      }
      if (this.selectedCard === 'RR') {
        result.adj_hrs = elem.adj_hrs
        result.adj_rate = elem.adj_rate
        result.rate2 = elem.rate2
        result.total_manual = elem.total_manual
      } else if (this.selectedCard === 'Repair') {
        result.adj_hrs = elem.adj_hrs
        result.adj_rate = elem.adj_rate
        result.rate2 = elem.rate2
        result.total_manual = elem.total_manual
      } else if (this.selectedCard === 'Paint') {
        result.adj_hrs = elem.adj_hrs
        result.adj_rate = elem.adj_rate
        result.rate2 = elem.rate2
        result.total_manual = elem.total_manual
        result.paint_type = elem.paint_type
      } else if (this.selectedCard === 'Sublet') {
        result.adj_rate = elem.adj_rate
        result.mup = elem.mup
        result.repairer = elem.repairer
      } else if (this.selectedCard === 'Other') {
        result.adj_rate = elem.adj_rate
      } else if (this.selectedCard === 'PDR') {
        result.type = elem.type
        result.material = elem.material
        result.action = elem.action
        result.action = elem.action
        result.qty = elem.qty
        result.adj_rate = elem.adj_rate
        result.price = elem.price
        result.total = elem.total
      } else if (this.selectedCard === 'Part') {
        result.type = elem.type
        result.part_num = elem.part_num
        result.mup = elem.mup
        result.qty = elem.qty
        result.cost = elem.cost
        result.adj_rate = elem.adj_rate
      }
      Axios.post('/fe/parts/custom-group/add-item', result)
          .then(response => {
            if (response.data._status) {
              let indexOfGroup = this.groups[this.selectedCard][this.selectedCardPart].indexOf(data.groupItem)
              this.groups[this.selectedCard][this.selectedCardPart][indexOfGroup].items.push(response.data.data)
              toastr.success('The item has been added to the group')
              this.openGroupWhenAdded(result.groupId)
            }
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
          })
    },
    onRightClickByRR (item, data) {
      var index = data.index
      var elem = this.estimateParts['RR'][index]
      //Insert Row
      if (data.type == 2) {
        var newItem = {
          hrs: 0,
          id: null,
          name: '',
          rate: this.rates.rr ? this.rates.rr : 0,
          rate2: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
        var vm = this
        this.onRightClickAddPart('RR', newItem)
            .then(resolve => {
              vm.estimateParts['RR'].splice(index + 1, 0, resolve)
              vm.orderItemParts()
            })

      } else if (data.type == 3) {
        this.removeEstimatePart('RR', index)
      } else if (data.type == 5) {
        let hrs = 0
        if (!this.isEstimateMethodologyCustom) {
          let elem_found = {}
          let paint_material = this.rates.paint_material
          let paints = this.cards['Paint']
          _.forEach(paints, function (items) {
            _.forEach(items, function (item) {
              if (item.prt == elem.name) {
                elem_found = item
              }
            })
          })
          if (elem_found && elem_found[paint_material] != '') {
            hrs = elem_found[paint_material]
          }
        }
        var newItem = {
          hrs: hrs,
          id: null,
          name: elem.name,
          paint_type: this.rates.paint_material ? this.rates.paint_material : 'not_set',
          rate: this.rates.paint ? this.rates.paint : 0,
          rate2: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
        var vm = this
        this.onRightClickAddPart('Paint', newItem)
            .then(resolve => {
              vm.estimateParts['Paint'].push(resolve)
            })
      } else if (data.type == 21) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'RR',
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addCustomDirectory(obj)
      } else if (data.type == 22 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'RR',
          categoryId: this.getButterflyMainCategoryId,
          cb: 1,
          bodyId: this.getBodyId,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addCustomDirectory(obj)
      } else if (data.type == 23 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'RR',
          cb: 1,
          mainCategory: data?.mainCategory,
          isZurich: true,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addZurichDirectory(obj)
      } else if (data.type == 31 && elem) {
        elem.row_highlight = data.color
        this.autoUpdateItemsList('RR', index)
      } else if (data.type == 32 && elem) {
        elem.row_highlight = null
        this.autoUpdateItemsList('RR', index)
      } else if (data.type == 34) {
        // console.log('R&R Weld Panel Allowance percent:', this.percentage)
        var newItem = {
          'id': null,
          'name': elem.name + ' - R&R Weld Panel Allowance',
          'rate': this.computedRRWeldPanelAllowance,
          'adj_rate': elem.adj_rate,
          'rate2': elem.rate2,
          'hrs': elem.hrs,
          'adj_hrs': elem.adjHrs,
          'total': elem.total,
          'total_manual': elem.total_manual,
          'row_highlight': elem.row_highlight,
          'is_show_in_jobcard': elem.is_show_in_jobcard,
          'comments': elem.comments,
        }

        var vm = this
        this.onRightClickAddPart('Other', newItem)
            .then(resolve => {
              vm.estimateParts['Other'].push(resolve)
              toastr.success('R&R Weld Panel Allowance has been added in the Other section')
              // vm.orderItemParts()
            })
      }

      this.$refs.rightClickMenuForRR.close()
    },
    loadCustomGroups () {
      let estimate_id = this.$route.params.estimate_id
      Axios.get(`/fe/parts/custom-groups/${estimate_id}`)
          .then(response => {
            if (response.data._status) {
              this.groups = response.data.data
            }
          })
          .catch(error => {
            console.log(error)
            NProgress.done()
          })
    },
    addEditOrRemoveInternalItemComment (estimateType, index, isCustom, actionType) {
      let elem = this.estimateParts[estimateType][index]
      let ref = ''
      if (isCustom) {
        ref = 'rightClickMenuFor' + estimateType + 'Custom'
      } else {
        ref = 'rightClickMenuFor' + estimateType
      }

      if (actionType === 'a') {
        if (this.currentManualItemComment.length > 50) {
          return
        } else {
          this.$set(elem.comments, 'manualComment', this.currentManualItemComment)
          this.$set(elem.comments, 'manualCommentAuthor', this.userInfo.full_name)
          this.autoUpdateItemsList(estimateType, index)
          this.currentManualItemComment = ''
          this.$refs[ref].close()
        }
      } else if (actionType === 'e') {
        if (elem.comments.manualComment.length > 50) {
          return
        }
        this.$set(elem.comments, 'manualCommentAuthor', this.userInfo.full_name)
        this.autoUpdateItemsList(estimateType, index)
        this.$refs[ref].close()
      } else if (actionType === 'r') {
        this.$set(elem.comments, 'manualComment', null)
        this.$set(elem.comments, 'manualCommentAuthor', null)
        this.autoUpdateItemsList(estimateType, index)
        this.$refs[ref].close()
      }
    },
    addEditOrRemoveEstimateItemComment (estimateType, index, isCustom, actionType) {
      let elem = this.estimateParts[estimateType][index]
      let ref = ''
      if (isCustom) {
        ref = 'rightClickMenuFor' + estimateType + 'Custom'
      } else {
        ref = 'rightClickMenuFor' + estimateType
      }

      if (actionType === 'a') {
        if (this.currentEstimateItemComment.length > 50) {
          return
        } else {
          this.$set(elem.comments, 'manualPdfComment', this.currentEstimateItemComment)
          this.$set(elem.comments, 'manualPdfCommentAuthor', this.userInfo.full_name)
          this.autoUpdateItemsList(estimateType, index)
          this.currentEstimateItemComment = ''
          this.$refs[ref].close()
        }
      } else if (actionType === 'e') {
        if (elem.comments.manualPdfComment.length > 50) {
          return
        }
        this.$set(elem.comments, 'manualPdfCommentAuthor', this.userInfo.full_name)
        this.autoUpdateItemsList(estimateType, index)
        if (_.isEmpty(elem.comments.manualPdfComment) && this.isOnReport(elem)) {
          this.$set(elem.comments, 'manualPdfComment', 'ON REPORT - Repairer')
        }
        this.$refs[ref].close()
      } else if (actionType === 'r') {
        this.$set(elem.comments, 'manualPdfComment', null)
        this.$set(elem.comments, 'manualPdfCommentAuthor', null)
        this.autoUpdateItemsList(estimateType, index)
        this.$refs[ref].close()
      }
    },
    showOrHideEstimateItemFromJobCard (estimateType, index, isCustom) {
      let elem = this.estimateParts[estimateType][index]
      let ref = ''
      if (isCustom) {
        ref = 'rightClickMenuFor' + estimateType + 'Custom'
      } else {
        ref = 'rightClickMenuFor' + estimateType
      }
      if (elem.is_show_in_jobcard) {
        elem.is_show_in_jobcard = false
        this.autoUpdateItemsList(estimateType, index)
        this.$refs[ref].close()
      } else {
        elem.is_show_in_jobcard = true
        this.autoUpdateItemsList(estimateType, index)
        this.$refs[ref].close()
      }
    },
    onRightClickByRepair (item, data) {
      let index = data.index
      let elem = this.estimateParts['Repair'][index]
      //Insert Row
      if (data.type == 2) {
        let newItem = {
          hrs: 0,
          id: null,
          name: '',
          rate: this.rates.repair ? this.rates.repair : 0,
          rate2: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
        let vm = this
        this.onRightClickAddPart('Repair', newItem)
            .then(resolve => {
              vm.estimateParts['Repair'].splice(index + 1, 0, resolve)
              vm.orderItemParts()
            })

      } else if (data.type == 3) {
        this.removeEstimatePart('Repair', index)
      } else if (data.type == 5) {
        let hrs = 0
        if (!this.isEstimateMethodologyCustom) {
          let elem_found = {}
          let paint_material = this.rates.paint_material
          let paints = this.cards['Paint']
          _.forEach(paints, function (items) {
            _.forEach(items, function (item) {
              if (item.prt == elem.name) {
                elem_found = item
              }
            })
          })
          if (elem_found && elem_found[paint_material] != '') {
            hrs = elem_found[paint_material]
          }
        }
        let newItem = {
          hrs: hrs,
          id: null,
          name: elem.name,
          paint_type: this.rates.paint_material ? this.rates.paint_material : 'not_set',
          rate: this.rates.paint ? this.rates.paint : 0,
          rate2: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
        let vm = this
        this.onRightClickAddPart('Paint', newItem)
            .then(resolve => {
              vm.estimateParts['Paint'].push(resolve)
              if (elem.hrs && elem.hrs >= 1) {
                newItem = {
                  hrs: hrs * 0.25,
                  id: null,
                  name: elem.name + ' - Allowance 25%',
                  paint_type: this.rates.paint_material ? this.rates.paint_material : 'not_set',
                  rate: this.rates.paint ? this.rates.paint : 0,
                  rate2: 0,
                  total: 0,
                  adj_hrs: null,
                  adj_rate: null,
                  is_show_in_jobcard: true,
                  comments: {},
                }
                //console.log('newItem',newItem)
                this.onRightClickAddPart('Paint', newItem)
                    .then(resolve => {
                      vm.estimateParts['Paint'].push(resolve)
                    })
              } else if (elem.hrs && elem.hrs >= 0.3) {
                newItem = {
                  hrs: hrs * 0.1,
                  id: null,
                  name: elem.name + ' - Allowance 10%',
                  paint_type: this.rates.paint_material ? this.rates.paint_material : 'not_set',
                  rate: this.rates.paint ? this.rates.paint : 0,
                  rate2: 0,
                  total: 0,
                  adj_hrs: null,
                  adj_rate: null,
                  is_show_in_jobcard: true,
                  comments: {},
                }
                //console.log('newItem',newItem)
                this.onRightClickAddPart('Paint', newItem)
                    .then(resolve => {
                      vm.estimateParts['Paint'].push(resolve)
                    })
              }
            })

        // console.log('elem',elem)
      } else if (data.type == 21) {
        // console.log('elem', elem);
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Repair',
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addCustomDirectory(obj)
      } else if (data.type == 22 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Repair',
          categoryId: this.getButterflyMainCategoryId,
          cb: 1,
          bodyId: this.getBodyId,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addCustomDirectory(obj)
      } else if (data.type == 23 && elem) {
        let obj = {
          mainCategory: data?.mainCategory,
          isZurich: true,
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Repair',
          cb: 1,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addZurichDirectory(obj)
      } else if (data.type == 31 && elem) {
        console.log('Repair', data)
        console.log('elem', elem)
        elem.row_highlight = data.color
        this.autoUpdateItemsList('Repair', index)
      } else if (data.type == 32 && elem) {
        elem.row_highlight = null
        this.autoUpdateItemsList('Repair', index)
      }
      this.$refs.rightClickMenuForRepair.close()
    },
    onRightClickByPaint (item, data) {
      var index = data.index
      var elem = this.estimateParts['Paint'][index]

      if (data.type == 10) {
        var name = elem.name + ' - Allowance 10%'
        var newItem = {
          hrs: elem.hrs * 0.1,
          id: null,
          name: name,
          paint_type: elem.paint_type,
          rate: elem.rate,
          total: elem.rate * elem.hrs * 0.1,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (data.type == 11) {
        var name = elem.name + ' - Allowance 25%'
        var newItem = {
          hrs: elem.hrs * 0.25,
          id: null,
          name: name,
          paint_type: elem.paint_type,
          rate: elem.rate,
          total: elem.rate * elem.hrs * 0.25,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (data.type == 12) {
        var newPaint = {
          hrs: elem.hrs * 0.7,
          id: elem.id,
          name: elem.name + ' - Blend',
          paint_type: elem.paint_type,
          rate: elem.rate,
          total: elem.rate * elem.hrs * 0.7,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.estimateParts['Paint'].splice(index, 1)
        var vm = this
        setTimeout(() => {
          vm.estimateParts['Paint'].splice(index, 0, newPaint)
        }, 100)
        let id = this.selectedCard + '-' + elem.id
        setTimeout(() => {
          vm.$refs[id][0].getFocus()
          vm.autoUpdateItemsList('Paint', index)
        }, 200)
      } else if (data.type == 2) {
        var newItem = {
          hrs: 0,
          id: null,
          name: '',
          paint_type: this.rates.paint_material ? this.rates.paint_material : 'not_set',
          rate: this.rates.paint,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }

      } else if (data.type == 3) {
        this.removeEstimatePart('Paint', index)
      } else if (data.type == 21) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          paint_type: elem.paint_type,
          total_manual: elem.total_manual,
          type: 'Paint',
        }
        this.addCustomDirectory(obj)
      } else if (data.type == 22 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          paint_type: elem.paint_type,
          type: 'Paint',
          categoryId: this.getButterflyMainCategoryId,
          cb: 1,
          bodyId: this.getBodyId,
        }
        this.addCustomDirectory(obj)
      } else if (data.type == 23 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Paint',
          cb: 1,
          mainCategory: data?.mainCategory,
          isZurich: true,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addZurichDirectory(obj)
      } else if (data.type == 31 && elem) {
        console.log('Paint', data)
        console.log('elem', elem)
        elem.row_highlight = data.color
        this.autoUpdateItemsList('Paint', index)
      } else if (data.type == 32 && elem) {
        elem.row_highlight = null
        this.autoUpdateItemsList('Paint', index)
      } else if (data.type == 33) {
        let name = elem.name + ' - Matt Allowance 10%'
        var newItem = {
          hrs: elem.hrs * 0.1,
          id: null,
          name: name,
          paint_type: elem.paint_type,
          rate: elem.rate,
          total: elem.rate * elem.hrs * 0.1,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (data.type == 34) {
        var name = elem.name + ' - M3+ Allowance 32%'
        var newItem = {
          hrs: elem.hrs * 0.32,
          id: null,
          name: name,
          paint_type: elem.paint_type,
          rate: elem.rate,
          total: elem.rate * elem.hrs * 0.32,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (data.type == 35) {
        var name = elem.name + ' - Single Panel Allowance'
        var newItem = {
          hrs: 1,
          id: null,
          name: name,
          paint_type: elem.paint_type,
          rate: elem.rate * 0.33,
          total: elem.rate * 0.33,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      }

      if (data.type === 2 || data.type === 10 || data.type === 11 || data.type === 33 || data.type === 34) {
        var vm = this
        this.onRightClickAddPart('Paint', newItem)
            .then(resolve => {
              vm.estimateParts['Paint'].splice(index + 1, 0, resolve)
              vm.orderItemParts()
            })
      }
      if (data.type === 35) {
        var vm = this
        this.onRightClickAddPart('Other', newItem)
            .then(resolve => {
              vm.estimateParts['Other'].push(resolve)
              toastr.success('Single Panel Allowance has been added in the Other section')
            })
      }

      this.$refs.rightClickMenuForPaint.close()
    },
    onRightClickByPart (item, data) {
      var index = data.index
      var elem = this.estimateParts['Part'][index]
      if (data.type == 2) {
        var newItem = {
          part_num: '',
          type: 'New',
          mup: this.rates.partmarkup ? this.rates.partmarkup : 0,
          qty: 1,
          id: null,
          name: '',
          rate: 0,
          total: 0,
          adj_price: null,
          adj_total: null,
          adj_rate: null,
          adj_mup: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
        var vm = this
        this.onRightClickAddPart('Part', newItem)
            .then(resolve => {
              vm.estimateParts['Part'].splice(index + 1, 0, resolve)
              vm.orderItemParts()
            })

      } else if (data.type == 23 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Part',
          cb: 1,
          mainCategory: data?.mainCategory,
          isZurich: true,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addZurichDirectory(obj)
      } else if (data.type == 3) {
        this.removeEstimatePart('Part', index)
      } else if (data.type == 31 && elem) {
        console.log('Part', data)
        console.log('elem', elem)
        elem.row_highlight = data.color
        this.autoUpdateItemsList('Part', index)
      } else if (data.type == 32 && elem) {
        elem.row_highlight = null
        this.autoUpdateItemsList('Part', index)
      }
      this.$refs.rightClickMenuForPart.close()
    },
    onReport (index, type) {
      const isArrayIndexes = Array.isArray(index)
      let elements = isArrayIndexes ? [] : [this.estimateParts[type][index]]
      let uid = Math.random().toString(36).substr(2, 9) + Date.now()
      let r = {}
      if (isArrayIndexes) {
        index.forEach((i) => {
          elements.push(
              this.estimateParts[type][i]
          )
        })
      }
      const arrayForApi = elements.map((elem) => {
        return {
          type: type,
          partId: elem.id,
        }
      })
      r[uid] = {
        'add': [
          ...arrayForApi
        ],
      }
      Axios.put('/fe/estimate/' + this.estimateId + '/on-report-repairer', r).then((response) => {
        // if (response.data._status && response.data?.done?.[0]?.part && response.data?.done?.length === 1) {
        //   this.$nextTick(() => {
        //     let newElem = response.data.done[0].part
        //     if (newElem.hasOwnProperty('onReportRepairer')) {
        //       this.$set(elem, 'onReportRepairer', newElem.onReportRepairer)
        //     }
        //     if (elem.hasOwnProperty('hrs') && newElem.hasOwnProperty('hrs')) {
        //       this.$set(elem, 'hrs', newElem.hrs)
        //     }
        //     if (elem.hasOwnProperty('price') && newElem.hasOwnProperty('price')) {
        //       this.$set(elem, 'price', newElem.price)
        //     }
        //     if (elem.hasOwnProperty('total') && newElem.hasOwnProperty('total')) {
        //       this.$set(elem, 'total', newElem.total)
        //     }
        //     if (elem.hasOwnProperty('total_manual') && newElem.hasOwnProperty('total_manual')) {
        //       this.$set(elem, 'total_manual', newElem.total_manual)
        //     }
        //     if (elem.hasOwnProperty('cost') && newElem.hasOwnProperty('cost')) {
        //       this.$set(elem, 'cost', newElem.cost)
        //     }
        //     if (elem.hasOwnProperty('rate') && newElem.hasOwnProperty('rate')) {
        //       this.$set(elem, 'rate', newElem.rate)
        //     }
        //     if (elem.hasOwnProperty('rate2') && newElem.hasOwnProperty('rate2')) {
        //       this.$set(elem, 'rate2', newElem.rate2)
        //     }
        //     if (elem.hasOwnProperty('qty') && newElem.hasOwnProperty('qty')) {
        //       this.$set(elem, 'qty', newElem.qty)
        //     }
        //     if (elem.hasOwnProperty('mup') && newElem.hasOwnProperty('mup')) {
        //       this.$set(elem, 'mup', newElem.mup)
        //     }
        //     if (newElem.hasOwnProperty('manual_pdf_comment')) {
        //       if (elem.comments) {
        //         this.$set(elem.comments, 'manualPdfComment', newElem.manual_pdf_comment)
        //       } else {
        //         this.$set(elem, 'comments', { manualPdfComment: newElem.manual_pdf_comment })
        //       }
        //     }
        //     if (newElem.hasOwnProperty('manual_pdf_comment_author')) {
        //       if (elem.comments) {
        //         this.$set(elem.comments, 'manualPdfCommentAuthor', newElem.manual_pdf_comment_author)
        //       } else {
        //         this.$set(elem, 'comments', { manualPdfCommentAuthor: newElem.manual_pdf_comment_author })
        //       }
        //     }
        //   })
        // }
        if (response.data._status && response.data?.done?.length != 0) {
          this.$nextTick(() => {
            response.data.done.forEach((item) => {
              let newElem = item.part
              const elem = this.estimateParts[type].find((elem) => {
                return elem.id == newElem.id
              })
              if (newElem.hasOwnProperty('onReportRepairer')) {
                this.$set(elem, 'onReportRepairer', newElem.onReportRepairer)
              }
              if (elem.hasOwnProperty('hrs') && newElem.hasOwnProperty('hrs')) {
                this.$set(elem, 'hrs', newElem.hrs)
              }
              if (elem.hasOwnProperty('price') && newElem.hasOwnProperty('price')) {
                this.$set(elem, 'price', newElem.price)
              }
              if (elem.hasOwnProperty('total') && newElem.hasOwnProperty('total')) {
                this.$set(elem, 'total', newElem.total)
              }
              if (elem.hasOwnProperty('total_manual') && newElem.hasOwnProperty('total_manual')) {
                this.$set(elem, 'total_manual', newElem.total_manual)
              }
              if (elem.hasOwnProperty('cost') && newElem.hasOwnProperty('cost')) {
                this.$set(elem, 'cost', newElem.cost)
              }
              if (elem.hasOwnProperty('rate') && newElem.hasOwnProperty('rate')) {
                this.$set(elem, 'rate', newElem.rate)
              }
              if (elem.hasOwnProperty('rate2') && newElem.hasOwnProperty('rate2')) {
                this.$set(elem, 'rate2', newElem.rate2)
              }
              if (elem.hasOwnProperty('qty') && newElem.hasOwnProperty('qty')) {
                this.$set(elem, 'qty', newElem.qty)
              }
              if (elem.hasOwnProperty('mup') && newElem.hasOwnProperty('mup')) {
                this.$set(elem, 'mup', newElem.mup)
              }
              if (newElem.hasOwnProperty('manual_pdf_comment')) {
                if (elem.comments) {
                  this.$set(elem.comments, 'manualPdfComment', newElem.manual_pdf_comment)
                } else {
                  this.$set(elem, 'comments', { manualPdfComment: newElem.manual_pdf_comment })
                }
              }
              if (newElem.hasOwnProperty('manual_pdf_comment_author')) {
                if (elem.comments) {
                  this.$set(elem.comments, 'manualPdfCommentAuthor', newElem.manual_pdf_comment_author)
                } else {
                  this.$set(elem, 'comments', { manualPdfCommentAuthor: newElem.manual_pdf_comment_author })
                }
              }
            })
          })
        }
      })
      if (!isArrayIndexes) {
        this.$refs['rightClickMenuFor' + type].close()
      }

    },
    onReportRemove (index, type) {
      let uid = Math.random().toString(36).substr(2, 9) + Date.now()
      let elem = this.estimateParts[type][index]
      let r = {}
      r[uid] = {
        'remove': [
          {
            type: type,
            partId: elem.id,
          }
        ],
      }
      Axios.put('/fe/estimate/' + this.estimateId + '/on-report-repairer', r).then((response) => {
        if (response.data._status && response.data?.done?.[0]?.part) {
          this.$nextTick(() => {
            this.$set(elem, 'onReportRepairer', {})
            let newElem = response.data.done[0].part
            if (elem.hasOwnProperty('hrs') && newElem.hasOwnProperty('hrs')) {
              this.$set(elem, 'hrs', newElem.hrs)
            }
            if (elem.hasOwnProperty('price') && newElem.hasOwnProperty('price')) {
              this.$set(elem, 'price', newElem.price)
            }
            if (elem.hasOwnProperty('total') && newElem.hasOwnProperty('total')) {
              this.$set(elem, 'total', newElem.total)
            }
            if (elem.hasOwnProperty('total_manual') && newElem.hasOwnProperty('total_manual')) {
              this.$set(elem, 'total_manual', newElem.total_manual)
            }
            if (elem.hasOwnProperty('cost') && newElem.hasOwnProperty('cost')) {
              this.$set(elem, 'cost', newElem.cost)
            }
            if (elem.hasOwnProperty('rate') && newElem.hasOwnProperty('rate')) {
              this.$set(elem, 'rate', newElem.rate)
            }
            if (elem.hasOwnProperty('rate2') && newElem.hasOwnProperty('rate2')) {
              this.$set(elem, 'rate2', newElem.rate2)
            }
            if (elem.hasOwnProperty('qty') && newElem.hasOwnProperty('qty')) {
              this.$set(elem, 'qty', newElem.qty)
            }
            if (elem.hasOwnProperty('mup') && newElem.hasOwnProperty('mup')) {
              this.$set(elem, 'mup', newElem.mup)
            }
            if (newElem.hasOwnProperty('manual_pdf_comment')) {
              if (elem.comments) {
                this.$set(elem.comments, 'manualPdfComment', newElem.manual_pdf_comment)
              } else {
                this.$set(elem, 'comments', { manualPdfComment: newElem.manual_pdf_comment })
              }
            }
            if (newElem.hasOwnProperty('manual_pdf_comment_author')) {
              if (elem.comments) {
                this.$set(elem.comments, 'manualPdfCommentAuthor', newElem.manual_pdf_comment_author)
              } else {
                this.$set(elem, 'comments', { manualPdfCommentAuthor: newElem.manual_pdf_comment_author })
              }
            }
          })
        }
      })
      this.$refs['rightClickMenuFor' + type].close()
    },
    addToSupplement (index, type) {
      let elem = this.estimateParts[type][index]
      this.$emit('addToSupplement', { type, elem })
      this.$refs['rightClickMenuFor' + type].close()
    },
    onRightClickByMaterials (item, { type, index }) {
      //add paint setup
      if (type === 1) {
        this.estimate.isShowPaintSetupCalculation = true
        let update = {}
        update.isShowPaintSetupCalculation = true
        this.setUpdateData(update)

      }
      //add environment levy
      else if (type === 2) {
        this.estimate.isShowEnvironmentLevyCalculation = true
        let update = {}
        update.isShowEnvironmentLevyCalculation = true
        this.setUpdateData(update)

      }
      //delete paint setup
      else if (type === 3) {
        this.estimate.isShowPaintSetupCalculation = false
        let update = {}
        update.isShowPaintSetupCalculation = false
        this.setUpdateData(update)

      }
      //delete environment
      else if (type === 4) {
        this.estimate.isShowEnvironmentLevyCalculation = false
        let update = {}
        update.isShowEnvironmentLevyCalculation = false
        this.setUpdateData(update)

      }
      this.$refs.rightClickMenuForMaterials.close()
    },
    onRightClickByOther (item, data) {
      var index = data.index
      var elem = this.estimateParts['Other'][index]
      console.log(elem)
      if (data.type == 2) {
        var newItem = {
          hrs: 0,
          id: null,
          name: '',
          rate: 0,
          total: 0,
          adj_rate: null,
          adj_price: null,
          adj_mup: null,
          is_show_in_jobcard: true,
          adj_approve_status: 'none',
          comments: {},
        }
        var vm = this
        this.onRightClickAddPart('Other', newItem)
            .then(resolve => {
              vm.estimateParts['Other'].splice(index + 1, 0, resolve)
              vm.orderItemParts()
            })
      } else if (data.type == 3) {
        this.removeEstimatePart('Other', index)
      } else if (data.type == 21) {
        let obj = {
          name: elem.name,
          total: elem.rate,
          type: 'Other',
        }
        this.addCustomDirectory(obj)
      } else if (data.type == 31 && elem) {
        console.log('Other', data)
        console.log('elem', elem)
        elem.row_highlight = data.color
        this.autoUpdateItemsList('Other', index)
      } else if (data.type == 32 && elem) {
        elem.row_highlight = null
        this.autoUpdateItemsList('Other', index)
      } else if (data.type == 23 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Other',
          cb: 1,
          mainCategory: data?.mainCategory,
          isZurich: true,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addZurichDirectory(obj)
      }
      this.$refs.rightClickMenuForOther.close()
    },
    onRightClickBySublet (item, data) {
      var index = data.index
      var elem = this.estimateParts['Sublet'][index]
      if (data.type == 2) {
        var newItem = {
          hrs: 0,
          id: null,
          name: '',
          rate: 0,
          total: 0,
          adj_rate: null,
          adj_price: null,
          is_show_in_jobcard: true,
          comments: {},
          adj_approve_status: 'none',
        }
        var vm = this
        this.onRightClickAddPart('Sublet', newItem)
            .then(resolve => {
              vm.estimateParts['Sublet'].splice(index + 1, 0, resolve)
              vm.orderItemParts()
            })

      } else if (data.type == 3) {
        this.removeEstimatePart('Sublet', index)
      } else if (data.type == 31 && elem) {
        console.log('Sublet', data)
        console.log('elem', elem)
        elem.row_highlight = data.color
        this.autoUpdateItemsList('Sublet', index)
      } else if (data.type == 32 && elem) {
        elem.row_highlight = null
        this.autoUpdateItemsList('Sublet', index)
      } else if (data.type == 23 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Sublet',
          cb: 1,
          mainCategory: data?.mainCategory,
          isZurich: true,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addZurichDirectory(obj)
      }
      this.$refs.rightClickMenuForSublet.close()
    },
    onRightClickByMaterialsZurich (item, data) {
      var index = data.index
      var elem = this.estimateParts['Materials'][index]

      if (data.type == 23 && elem) {
        let obj = {
          name: elem.name,
          rate: elem.rate,
          hrs: elem.hrs,
          total_manual: elem.total_manual,
          type: 'Materials',
          cb: 1,
          mainCategory: data?.mainCategory,
          isZurich: true,
          is_show_in_jobcard: true,
          comments: {},
        }
        this.addZurichDirectory(obj)
      }
      this.$refs.rightClickMenuForMaterialsZurich.close()
    },
    deleteCustomDirectory (data) {
      NProgress.start()
      let url = this.isEstimateMethodologyZurich ? '/fe/parts/directory/delete-zurich' : '/fe/parts/directory/delete-custom'
      Axios.post(url, data)
          .then(response => {
            if (response.data._status) {
              if (this.isEstimateMethodologyZurich) {
                let arr = _.cloneDeep(this.cardSubParts)
                let ind = _.findIndex(arr, (itm) => {
                  return itm.id == data.partId
                })
                if (ind != -1) {
                  arr.splice(ind, 1)
                  this.$emit('changeSubParts', {
                    data: arr,
                    mainCategory: this.selectedCardPart,
                    type: this.selectedCard,
                  })
                }
              } else {
                if (data.cb) {
                  this.removeFromButterflyCustomMatrix(data)
                  this.backdoorButterflyCustomMatrix += 1
                  toastr.success('This Part Item has been removed from Category List')
                } else {
                  //this.$store.dispatch('loadJobs');
                  this.$emit('loadTimesForItemPart')
                  //this.loadTimesForItemPart();
                  toastr.success('This Part Item has been removed from Custom List')
                }
                this.removeItemFromJobs(data)
              }
            }
          })
          .catch(error => {
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })

    },
    onRightClickByRemoveButterflyCustom (item, data) {
    },
    onRightClickByRRCustom (item, data) {
      if (data.type == 3) {
        let obj = data.data
        obj.partId = obj.id
        obj.type = 'RR'
        obj.mainCategory = this.selectedCardPart
        this.deleteCustomDirectory(obj)
      }
      this.$refs.rightClickMenuForRRCustom.close()
    },
    onRightClickByRepairCustom (item, data) {
      if (data.type == 3) {
        let obj = data.data
        obj.partId = obj.id
        obj.type = 'Repair'
        obj.mainCategory = this.selectedCardPart
        this.deleteCustomDirectory(obj)
      }
      this.$refs.rightClickMenuForRepairCustom.close()
    },
    onRightClickByPaintCustom (item, data) {
      if (data.type == 3) {
        let obj = data.data
        obj.partId = obj.id
        obj.type = 'Paint'
        obj.mainCategory = this.selectedCardPart
        this.deleteCustomDirectory(obj)
      }
      this.$refs.rightClickMenuForPaintCustom.close()
    },
    onRightClickByOtherCustom (item, data) {
      if (data.type == 3) {
        let obj = data.data
        obj.partId = obj.id
        obj.type = 'Other'
        obj.mainCategory = this.selectedCardPart
        this.deleteCustomDirectory(obj)
      }
      this.$refs.rightClickMenuForOtherCustom.close()
    },
    onRightClickByPartCustom (item, data) {
      if (data.type == 3) {
        let obj = data.data
        obj.partId = obj.id
        obj.type = 'Part'
        obj.mainCategory = this.selectedCardPart
        this.deleteCustomDirectory(obj)
      }
      this.$refs.rightClickMenuForPartCustom.close()
    },
    onRightClickByMaterialsCustom (item, data) {
      if (data.type == 3) {
        let obj = data.data
        obj.partId = obj.id
        obj.type = 'Materials'
        obj.mainCategory = this.selectedCardPart
        this.deleteCustomDirectory(obj)
      }
      this.$refs.rightClickMenuForMaterialsCustom.close()
    },
    onRightClickBySubletCustom (item, data) {
      if (data.type == 3) {
        let obj = data.data
        obj.partId = obj.id
        obj.type = 'Sublet'
        obj.mainCategory = this.selectedCardPart
        this.deleteCustomDirectory(obj)
      }
      this.$refs.rightClickMenuForSubletCustom.close()
    },
    onRightClickRemoveLevy: function (item, data) {
      this.rates.material_use_levy = 'N'
    },
    onRightClickByPDR: function (e, data) {
      e.preventDefault()

      // console.log('select PDR context menu option', data);
      // console.log('this.$refs[\'pdrTextarea\'].value.trim()', this.$refs['pdrTextarea'].value.trim());

      switch (data.type) {
          // click on 'add comment' menu
        case 1: {
          this.$refs['pdrTextarea'].focus()
          break
        }
          // remove
        case 3: {
          //this.estimateParts[this.selectedCard][data.index].comment = '';
          this.$set(this.estimateParts[this.selectedCard][data.index], 'comment', '')
          this.$refs[`PDR${data.index}`][0].d_comment = ''
          this.$refs[`PDR${data.index}`][0].$forceUpdate()
          // close context-menu
          this.$refs['rightClickMenuForPDR'].close()
          this.autoUpdateItemsList(this.selectedCard, data.index)
          break
        }
          // enter key on comment
        case 4: {
          // this.estimateParts[this.selectedCard][data.index].comment = this.$refs['pdrTextarea'].value.trim();
          this.$set(this.estimateParts[this.selectedCard][data.index], 'comment', this.$refs['pdrTextarea'].value.trim())
          this.$refs[`PDR${data.index}`][0].d_comment = this.$refs['pdrTextarea'].value.trim()
          this.$refs[`PDR${data.index}`][0].$forceUpdate()
          // close context-menu
          this.$refs['rightClickMenuForPDR'].close()
          this.autoUpdateItemsList(this.selectedCard, data.index)
          break
        }
          // esc key
        case 5: {
          // close context-menu
          this.$refs['rightClickMenuForPDR'].close()
          break
        }
      }
    },
    addZurichDirectory (data) {
      NProgress.start()
      data.name = _.toUpper(data.name)
      return Axios.post('/fe/parts/directory/add-zurich', data)
          .then(response => {
            if (response.data._status && response.data.newZurich) {
              toastr.success(`This ${data.type} Part Item has been added into Category List`)

              let arr = _.cloneDeep(this.cardSubParts)
              arr.unshift(response.data.newZurich[this.selectedCard][this.selectedCardPart][data.name])
              this.$emit('changeSubParts', {
                data: arr,
                mainCategory: this.selectedCardPart,
                type: this.selectedCard,
              })

              this.$emit('loadTimesForItemPart')
            }
          })
          .catch(error => {
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    addCustomDirectory (data) {
      NProgress.start()
      data.name = _.toUpper(data.name)
      return Axios.post('/fe/parts/directory/add-custom', data)
          .then(response => {
            if (response.data._status) {
              if (data.cb) {
                if (data.type === 'Other') {
                  toastr.success('This Other Part Item has been added into Category List')
                } else if (data.type === 'RR') {
                  data.id = response.data.newCustomRR.id
                  data.prt = data.name
                  this.addToButterflyCustomMatrix(data).then(() => {
                    this.sortButterflySubcategories(this.butterflyCardSubPartsCombined)
                  })
                  toastr.success('This RR Part Item has been added into Category List')
                } else if (data.type === 'Repair') {
                  data.id = response.data.newCustomRepair.id
                  data.prt = data.name
                  this.addToButterflyCustomMatrix(data).then(() => {
                    this.sortButterflySubcategories(this.butterflyCardSubPartsCombined)
                  })
                  toastr.success('This Repair Part Item has been added into Category List')
                } else if (data.type === 'Paint') {
                  data.id = response.data.newCustomPaint.id
                  data.prt = data.name
                  this.addToButterflyCustomMatrix(data).then(() => {
                    this.sortButterflySubcategories(this.butterflyCardSubPartsCombined)
                  })
                  toastr.success('This Paint Part Item has been added into Category List')
                }
              } else {
                if (data.type === 'Other') {
                  toastr.success('This Other Part Item has been added into Custom List')
                } else if (data.type === 'RR') {
                  toastr.success('This RR Part Item has been added into Custom List')
                } else if (data.type === 'Repair') {
                  toastr.success('This Repair Part Item has been added into Custom List')
                } else if (data.type === 'Paint') {
                  toastr.success('This Paint Part Item has been added into Custom List')
                }
              }
              //this.loadCustomDirectory(data.type);
              //this.$store.dispatch('loadJobs');
              this.$emit('loadTimesForItemPart')
              //this.loadTimesForItemPart();
              // toastr.success('This Other Part Item has been added into Custom List');
              if (this.isEstimateMethodologyCustom) {
                this.addItemToJobs({ item: data, response: response.data })
              }
            }
          })
          .catch(error => {
            toastr.error(error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    onRightClickHide: function () {
      //  this.materialVissibility = 'H';
    },
    closeMenuGroup () {
      this.selectedCardSubPartForContext.part = {}
    },
    closeMenuGroupItem () {
      this.selectedCardSubPartItemForContext = {}
    },
    openMenuGroup: function (e, item) {
      this.selectedCardSubPartForContext.part = item
      this.$refs.rightClickMenuForGroupItem.close()
      this.$refs.rightClickMenuForGroup.open(e, item)
    },
    openMenuGroupItem: function (e, item, subItem) {
      this.selectedCardSubPartItemForContext = subItem
      this.$refs.rightClickMenuForGroup.close()
      this.$refs.rightClickMenuForGroupItem.open(e, { item: item, subItem: subItem })
    },
    closeContext () {
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      estimateItem[0].$el.style.cssText = 'background-color: transparent'
      this.selectedEstimateItem.type = ''
      this.selectedEstimateItem.part = {}
      if (this.currentManualItemComment) {
        this.currentManualItemComment = ''
      }
      if (this.currentEstimateItemComment) {
        this.currentEstimateItemComment = ''
      }
    },
    openContext () {
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      estimateItem[0].$el.style.cssText = 'background-color: #eff2ff'
    },

    openMenuForFiles: function (item, index, event) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      event.preventDefault()
      this.$refs.rightClickMenuForFiles.open(event, item)
    },
    openMenuRR: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'RR'
      this.$refs.rightClickMenuForRR.open(e, { index: index, part: part })
      if (part && part.comments && !part.comments.manualPdfComment) {
        this.isNeedChangePosition('add-comment-rr', index)
      } else if (part && part.comments && part.comments.manualPdfComment) {
        this.isNeedChangePosition('edit-comment-rr', index)
      }
    },
    openMenuRepair: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'Repair'
      this.$refs.rightClickMenuForRepair.open(e, { index: index, part: part })
      if (part && part.comments && !part.comments.manualPdfComment) {
        this.isNeedChangePosition('add-comment-repairer', index)
      } else if (part && part.comments && part.comments.manualPdfComment) {
        this.isNeedChangePosition('edit-comment-repairer', index)
      }
    },
    openMenuPaint: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'Paint'
      this.$refs.rightClickMenuForPaint.open(e, { index: index, part: part })
      if (part && part.comments && !part.comments.manualPdfComment) {
        this.isNeedChangePosition('add-comment-paint', index)
      } else if (part && part.comments && part.comments.manualPdfComment) {
        this.isNeedChangePosition('edit-comment-paint', index)
      }
    },
    openMenuForRemoveLevy: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      this.contextOpenEvent = e
      this.$refs.rightClickMenuForRemoveLevy.open(e, index)
    },
    openMenuMaterials: function (e, index, part) {
      if (!this.isStatusActive || this.isAuthorised || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'Materials'
      let isCheckedForAddPaintSetupOption = this.isShowEnvironmentLevyCalculation && this.estimateParts['Materials'][index].subtype === 'EnvironmentLevy'
      let isCheckedForAddEnvironmentLevyOption = this.isShowPaintSetupCalculation && this.estimateParts['Materials'][index].subtype === 'PaintSetupTime'
      let isCheckedForDeleteLineItemOption = !this.isShowEnvironmentLevyCalculation || !this.isShowPaintSetupCalculation

      if ((isCheckedForAddPaintSetupOption || isCheckedForAddEnvironmentLevyOption || isCheckedForDeleteLineItemOption) && part.type && part.type === 'calculation') {
        this.$refs.rightClickMenuForMaterials.open(e, index)
        if (this.estimateParts['Materials'][index] && this.estimateParts['Materials'][index].comments && !this.estimateParts['Materials'][index].comments.manualComment) {
          this.isNeedChangePosition('add-comment-material', index)
        } else if ((this.estimateParts['Materials'][index] && this.estimateParts['Materials'][index].comments && this.estimateParts['Materials'][index].comments.manualComment)) {
          this.isNeedChangePosition('edit-comment-material', index)
        }
      } else {
        if (this.isEstimateMethodologyZurich && part.type == 'manual') {
          this.$refs.rightClickMenuForMaterialsZurich.open(e, { index: index, part: part })
        } else {
          this.$refs.rightClickMenuForMaterials.close()
        }
      }

    },
    openMenuPart: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'Part'
      this.contextOpenEvent = e
      this.$refs.rightClickMenuForPart.open(e, { index: index, part: part })
      if (part && part.comments && !part.comments.manualPdfComment) {
        this.isNeedChangePosition('add-comment-part', index)
      } else if (part && part.comments && part.comments.manualPdfComment) {
        this.isNeedChangePosition('edit-comment-part', index)
      }
    },
    openMenuSublet: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'Sublet'
      this.contextOpenEvent = e
      this.$refs.rightClickMenuForSublet.open(e, { index: index, part: part })
      if (part && part.comments && !part.comments.manualPdfComment) {
        this.isNeedChangePosition('add-comment-sublet', index)
      } else if (part && part.comments && part.comments.manualPdfComment) {
        this.isNeedChangePosition('edit-comment-sublet', index)
      }
    },
    openMenuOther: function (e, index, part) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      let estimateItem = this.$refs[this.selectedEstimateItem.type + '-' + this.selectedEstimateItem.part.id]
      if (estimateItem?.[0]) {
        estimateItem[0].$el.style.cssText = 'background-color: transparent'
      }
      this.selectedEstimateItem.part = part
      this.selectedEstimateItem.type = 'Other'
      this.contextOpenEvent = e
      this.$refs.rightClickMenuForOther.open(e, { index: index, part: part })
      if (part && part.comments && !part.comments.manualPdfComment) {
        this.isNeedChangePosition('add-comment-other', index)
      } else if (part && part.comments && part.comments.manualPdfComment) {
        this.isNeedChangePosition('edit-comment-other', index)
      }
    },
    openMenuCustom: function (e, data) {
      if (!this.isStatusActive || this.isBlockByAuda) {
        return
      }
      // console.log('e', e);
      if (this.selectedCard == 'Other' && (this.selectedCardPart == 'Custom' || (this.isEstimateMethodologyZurich && data.c == 1))) {
        this.$refs.rightClickMenuForOtherCustom.open(e, data)
      } else if (this.selectedCard == 'Paint' && (this.selectedCardPart == 'Custom' || data.cb == 1 || (this.isEstimateMethodologyZurich && data.c == 1))) {
        this.$refs.rightClickMenuForPaintCustom.open(e, data)
      } else if (this.selectedCard == 'Repair' && (this.selectedCardPart == 'Custom' || data.cb == 1 || (this.isEstimateMethodologyZurich && data.c == 1))) {
        this.$refs.rightClickMenuForRepairCustom.open(e, data)
      } else if (this.selectedCard == 'RR' && (this.selectedCardPart == 'Custom' || data.cb == 1 || (this.isEstimateMethodologyZurich && data.c == 1))) {
        this.$refs.rightClickMenuForRRCustom.open(e, data)
      } else if (this.selectedCard == 'Sublet' && this.isEstimateMethodologyZurich && data.c == 1) {
        this.$refs.rightClickMenuForSubletCustom.open(e, data)
      } else if (this.selectedCard == 'Part' && this.isEstimateMethodologyZurich && data.c == 1) {
        this.$refs.rightClickMenuForPartCustom.open(e, data)
      } else if (this.selectedCard == 'Materials' && this.isEstimateMethodologyZurich && data.c == 1) {
        this.$refs.rightClickMenuForMaterialsCustom.open(e, data)
      }
    },
    selectCard: function (card) {
      //   console.log(card)
      this.selectedCard = card
      this.$emit('selectedCard', card)
      if (this.isEstimateMethodologyZurich) {
        if (this.getSelectedSchemePart()) {
          this.selectedCardPart = this.getSelectedSchemePart()
        } else {
          this.selectedCardPart = 'FRONT BAR'
        }
      } else {
        if (this.getSelectedSchemePart()) {
          this.selectedCardPart = this.getSelectedSchemePart()
        } else {
          this.selectedCardPart = _.find(this.cardParts, (v) => {
            return v !== 'Custom'
          })
        }
      }
      if (this.selectedCard == 'PDR') {
        this.selectedCardPart = 'PDR'
      }
    },
    selectCardPart: function (part) {
      //console.log(part)
      this.selectedCardPart = part
      if (this.selectedCard === 'RR') {
        this.isShowInsertNameGRP = false
      }
    },
    async addCardPart (card) {
      this.selectedCardPart = card
      let items = this.butterflyCardSubPartsCombined
      for (const item of items) {
        await this.selectCardSubPart(item)
      }
    },
    onKeyPress: function (event) {
      if (!this.isStatusActive) {
        return
      }
      this.$emit('beforeDebouncedUnsavedChanges')
    },
    onRightLeftKeyPress: function (index, partId, fieldName) {
      let id = this.selectedCard + '-' + partId
      this.$nextTick(() => {
        this.$refs[id][0].getFocus(fieldName)
      })
    },
    onRightKeyPress: function (index, partId, fieldName) {
      console.log('onRightKeyPress', index, partId, fieldName)
      this.onRightLeftKeyPress(index, partId, fieldName)
    },
    onLeftKeyPress: function (index, partId, fieldName) {
      this.onRightLeftKeyPress(index, partId, fieldName)
    },
    onUpKeyPress: function (partId, fieldName) {
      let maxParts = this.selectedCardPartsCount

      let part = _.find(this.estimateParts[this.selectedCard], (p) => {
        return p.id === partId
      })

      let index = this.estimateParts[this.selectedCard].indexOf(part)

      index -= 1

      if (index < 0) {
        index = maxParts - 1
      }

      let id = this.selectedCard + '-' + this.estimateParts[this.selectedCard][index].id
      this.$nextTick(() => {
        this.$refs[id][0].getFocus(fieldName, true)
      })

    },
    onDownKeyPress: function (partId, fieldName) {
      let maxParts = this.selectedCardPartsCount

      let part = _.find(this.estimateParts[this.selectedCard], (p) => {
        return p.id === partId
      })

      let index = this.estimateParts[this.selectedCard].indexOf(part)

      index += 1

      if (index >= maxParts) {
        index = 0
      }

      let id = this.selectedCard + '-' + this.estimateParts[this.selectedCard][index].id
      this.$nextTick(() => {
        this.$refs[id][0].getFocus(fieldName, true)
      })
    },
    onEnterKeyPress: function (partId) {
      const part = _.find(this.estimateParts[this.selectedCard], (p) => p.id === partId)
      const currentIndex = this.estimateParts[this.selectedCard].indexOf(part)
      if (currentIndex === -1) {
        return
      }
      const sp = {
        type: this.selectedCard === 'PDR' ? 'Panel' : '',
        isNewItem: true,
        isGroupItem: true
      }
      this.selectCardSubPart(sp, currentIndex + 1)
    },
    addNewPanelPDR () {
      const newPanel = {
        id: null,
        type: 'Panel',
        name: '',
        material: { key: 'none', label: 'None' },
        action: { key: 'none', label: 'None' },
        qty: 1,
        price: 0,
        total: 0,
        comment: ''
      }
      this.estimateParts['PDR'].push(newPanel)
    },
    async asyncSelectCardSubPart (sp) {
      return this.selectCardSubPart(sp)
    },
    async selectCardSubPart (sp, indexSp = -1) {
      if (!this.isStatusActive || this.isAuthorised) {
        return
      }

      //if (this.selectedCard === 'Materials') {
      //    if (sp === '') {
      //        //  this.rates.material_use_levy = 'V';
      //    }
      //    return;
      //}

      console.log('selectCardSubPart', sp)
      // CAPTURE the focused index immediately, before any async operations
      const capturedFocusedIndex = this.lastFocusedItemIndex

      // Clear blur timeout to prevent it from resetting during this operation
      if (this.blurResetTimeout) {
        clearTimeout(this.blurResetTimeout)
        this.blurResetTimeout = null
      }

      if (sp.type === 'Group') {
        this.isShowInsertNameGRP = true
        return
      }

      this.selectedCardSubPart = sp.prt
      let tmp = 0
      let id = ''

      let selectedParts = this.estimateParts[this.selectedCard]
      /* Disabled based on task #242
                if (selectedParts) {
                    for (let i = 0; i < selectedParts.length; i++) {
                        if (sp.prt === selectedParts[i].name) {
                            id = this.selectedCard + i;
                            setTimeout(() => {
                                this.$refs[id][0].getFocus();
                            }, 100);
                            return;
                        }
                    }
                }
                 */

      var default_rate = 0
      var default_paint_type = 'not_set'

      if (!this.isEstimateMethodologyDollars) {
        if (this.selectedCard === 'RR') {
          default_rate = this.rates.rr
        } else if (this.selectedCard === 'Paint') {
          default_rate = this.rates.paint
          default_paint_type = this.rates.paint_material

        } else if (this.selectedCard === 'Repair') {
          default_rate = this.rates.repair
        }
      }

      if (this.selectedCard == 'Part') {
        var newItem = {
          id: null,
          adj_price: null,
          adj_rate: null,
          adj_mup: null,
          name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
          part_num: '',
          type: 'New',
          mup: 0,
          qty: 1,
          rate: 0,
          rate2: 0,
          total: 0,
          is_show_in_jobcard: true,
          comments: {},
          ai_load: sp.aiSearch,
          completed: false
        }

      } else if (this.selectedCard == 'Paint') {
        //console.log('sp');
        // console.log(sp);
        if (this.isEstimateMethodologyCustom) {
          var t_hours = sp.hrs
        } else {
          //console.log(sp);
          if (this.rates.paint_material == 'S1' && sp.hasOwnProperty('S1')) {
            var t_hours = sp.S1
          } else if (this.rates.paint_material == 'S2' && sp.hasOwnProperty('S2')) {
            var t_hours = sp.S2
          } else if (this.rates.paint_material == 'M1' && sp.hasOwnProperty('M1')) {
            var t_hours = sp.M1
          } else if (this.rates.paint_material == 'M2' && sp.hasOwnProperty('M2')) {
            var t_hours = sp.M2
          } else if (this.rates.paint_material == 'M3' && sp.hasOwnProperty('M3')) {
            var t_hours = sp.M3
          } else if (this.rates.paint_material == 'M3PLUS' && sp.hasOwnProperty('M3PLUS')) {
            var t_hours = sp.M3PLUS
          } else {
            var t_hours = sp.hrs
          }
        }
        if (sp.hasOwnProperty('total_manual') && sp.total_manual != null) {
          var newItem = {
            id: null,
            storage_item_id: sp.id,
            name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
            paint_type: sp.paint_type,
            hrs: sp.hrs,
            rate: default_rate,
            adj_changed_rate: default_rate,
            rate2: 0,
            total: 0,
            total_manual: sp.total_manual,
            is_show_in_jobcard: true,
            comments: {},
            adj_price: null,
            adj_rate: null,
            adj_hrs: null,

          }
        } else {
          var newItem = {
            id: null,
            storage_item_id: sp.id,
            name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
            paint_type: this.rates.paint_material,
            hrs: t_hours,
            rate: default_rate,
            adj_changed_rate: default_rate,
            rate2: 0,
            total: 0,
            total_manual: sp.total_manual,
            is_show_in_jobcard: true,
            comments: {},
            adj_price: null,
            adj_rate: null,
            adj_hrs: null,
          }
        }
        //console.log ('newItem',newItem)
      } else if (this.selectedCard == 'Sublet') {
        var newItem = {
          id: null,
          name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
          repairer: sp.repairer ? sp.repairer : '',
          hrs: 0,
          rate: sp.rate ? sp.rate : 0,
          total: sp.total ? sp.total : 0,
          mup: sp.mup ? sp.mup : 0,
          adj_price: null,
          adj_rate: null,
          adj_mup: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (this.selectedCard == 'Materials') {
        var newItem = {
          id: null,
          name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
          type: 'manual',
          hrs: 0,
          rate: 0,
          total: 0,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (this.selectedCard === 'PDR') {
        var newItem = {
          id: null,
          type: sp.type ? sp.type : 'Item',
          name: sp.name ?? '',
          material: 'None',
          action: 'None',
          qty: 1,
          price: 0,
          total: 0,
          comment: '',
          adj_price: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (this.selectedCard === 'Other' && this.selectedCardPart === 'Custom') {
        var newItem = {
          id: null,
          name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
          rate: sp.total !== null ? sp.total : sp.total_rs,
          rate2: 0,
          hrs: sp.hrs,
          total: 0,
          total_manual: sp.total_manual,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (this.selectedCard === 'Other' && this.selectedCardPart === 'Custom') {
        var newItem = {
          id: null,
          name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
          rate: sp.total || sp.rate,
          rate2: 0,
          hrs: sp.hrs,
          total: 0,
          total_manual: sp.total || sp.rate,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else if (this.selectedCard === 'RR' && sp.hasOwnProperty('createdOn')) {
        var newItem = {
          id: null,
          name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
          rate: default_rate,
          rate2: 0,
          hrs: sp.hours,
          total: 0,
          total_manual: sp.total,
          adj_hrs: null,
          adj_rate: null,
          is_show_in_jobcard: true,
          comments: {},
        }
      } else {
        //Всё остальное
        var newItem = {}
        //console.log('SP!', sp);
        if (sp.hasOwnProperty('total_manual') && sp.total_manual != null) {
          newItem = {
            id: null,
            name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
            rate: sp.rate || default_rate,
            rate2: 0,
            hrs: sp.hrs,
            total: 0,
            total_manual: sp.total_manual,
            adj_hrs: null,
            adj_rate: null,
            is_show_in_jobcard: true,
            comments: {},
          }
        } else {
          newItem = {
            id: null,
            name: sp.prt ? sp.prt : (sp.name ? sp.name : ''),
            rate: sp.total || default_rate,
            rate2: 0,
            hrs: sp.hrs,
            total: 0,
            total_manual: sp.total_manual,
            adj_hrs: null,
            adj_rate: null,
            is_show_in_jobcard: true,
            comments: {},
          }
        }
        if ((this.selectedCard === 'RR') || (this.selectedCard === 'Paint') || (this.selectedCard === 'Repair')) {
          newItem.rate = default_rate
          newItem.adj_changed_rate = default_rate
        }
      }
      //console.log('ps',parseFloat(newItem.hrs * 0.2).toFixed(2))
      //console.log('ps1',newItem.hrs)
      //console.log('ps2',this.isRSEstimateMethodology)
      //console.log('ps3',this.selectedCard)
      if (this.isRSEstimateMethodology) {
        //console.log('if1');
        newItem.hrs = this.calculateHoursForRS(newItem.hrs)
      }
      let estimateId = this.estimateId
      this.$emit('autoSaveMessageUpdate', 'Saving...')
      return await Axios({
        method: 'post',
        responseType: 'json',
        headers: { 'addPart': true },
        url: `/fe/estimate/${estimateId}`,
        validateStatus: function (status) {
          return status < 500
        },
        data: { part: newItem, type: this.selectedCard }
      })
          .then(response => {
            if (response.status === 200) {
              if (response.data.result.id) {
                this.$emit('autoSaveMessageUpdate', 'Saved')
                newItem.id = response.data.result.id
                if (sp.isAddToEnd) {
                  // Check if we have a focused item to insert below
                  if (capturedFocusedIndex !== null && capturedFocusedIndex >= 0) {
                    const insertIndex = capturedFocusedIndex + 1
                    this.estimateParts[this.selectedCard].splice(insertIndex, 0, newItem)
                    id = this.selectedCard + '-' + (newItem.id)
                    console.log('Inserted item below focused element at index:', insertIndex)
                  } else {
                    // No focused item, add to end
                    this.estimateParts[this.selectedCard].push(newItem)
                    id = this.selectedCard + '-' + (newItem.id)
                  }
                  this.orderItemParts()
                } else if (sp.isNewItem) {
                  if (sp.aiSearch) {

                  }
                  if (indexSp !== -1) {
                    if (sp.isGroupItem) {
                      this.estimateParts[this.selectedCard].splice(indexSp, 0, newItem)
                    } else {
                      this.estimateParts[this.selectedCard].splice(indexSp, 1, newItem)
                    }
                    id = this.selectedCard + '-' + (this.estimateParts[this.selectedCard][indexSp].id)
                  } else {
                    this.estimateParts[this.selectedCard].unshift(newItem)
                    id = this.selectedCard + '-' + (this.estimateParts[this.selectedCard][0].id)

                  }
                  this.orderItemParts()
                } else {
                  if (indexSp !== -1) {
                    if (sp.isGroupItem) {
                      this.estimateParts[this.selectedCard].splice(indexSp, 0, newItem)
                    } else {
                      this.estimateParts[this.selectedCard].splice(indexSp, 1, newItem)
                    }
                    id = this.selectedCard + '-' + (this.estimateParts[this.selectedCard][indexSp].id)
                    this.orderItemParts()
                  } else {
                    this.estimateParts[this.selectedCard].push(newItem)
                    id = this.selectedCard + '-' + (this.estimateParts[this.selectedCard][this.selectedCardPartsCount - 1].id)
                  }
                }

                if (response.data.result.calculation) {
                  this.$emit('updateCalculation', response.data.result.calculation, estimateId)
                }
                if (!sp?.aiSearch) {
                  setTimeout(() => {
                    this.$refs[id][0].getFocus()
                  }, 100)
                }

                return newItem
              } else {
                this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
              }
            } else {
              this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
              return false
            }
          })
          .catch(error => {
            this.$emit('autoSaveMessageUpdate', 'Unsaved Changes')
            return false
          })
    },
    addPartsIntoEstimate (parts) {
      console.log('addPartsIntoEstimate', parts)
      const partsIds = parts.map(part => part.id)
      this.estimateParts['Part'].push(...parts)
      let indexForOnReport = []
      this.estimateParts['Part'].forEach((part, index) => {
        if (partsIds.includes(part.id) && part.checkedReport) {
          indexForOnReport.push(index)
        }
      })
      this.onReport(indexForOnReport, 'Part')
    },

  },
  watch: {
    forcedSelectCard (val) {
      if (!val) return
      this.selectCard(val)
    },
    selectedCard: {
      handler (newValue) {
        if (newValue == 'Part') {
          this.updateShowImportPdfParts(true)
        } else {
          this.updateShowImportPdfParts(false)
        }
      },
      immediate: true,
    },
    ordersUpdater: {
      handler () {
        this.loadPSOrders()
      },
      immediate: true,
    },
    selectedSchemeParts: {
      handler (v) {
        if (!this.isCanShowSchemeParts) {
          return
        }
        if (!_.isEmpty(v)) {
          let name = _.find(_.reverse(v), (p) => {
            return _.includes(this.cardParts, p)
          })
          if (name) {
            this.selectedCardPart = name
          } else {
            this.selectedCardPart = _.first(this.cardParts)
          }
        } else {
          this.selectedCardPart = ''
        }
      },
      immediate: true,
      deep: true
    },
    manualOrdersUpdater: {
      handler () {
        this.loadManualOrders()
      },
      immediate: true,
    },
  },
  components: {
    DamageAssessment,
    draggable,
    EstimateItem,
    NumberFormatter,
    VueContext,
    RsRipple,
    datePicker,
    TheOrders,
    progressBar
  }

}
</script>

<style>
.container-add-part {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 10px 0;
}

.container-add-part .new-btn {
  height: 31px;
  border: 1px solid #5E79FF;
  color: #5E79FF;
  border-radius: 3px;
  font-size: 13px;
  font-weight: bold;
  background: none;
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px;
}

.new-item {
  font-weight: 700;
  padding: 20px;
}

.V3 .estimates-edit .empty-draggable {
  min-height: 350px !important;
}

.V3 .estimates-edit .disabled-draggable-groups:hover,
.V3 .estimates-edit .disabled-draggable-groups:hover input,
.V3 .estimates-edit .disabled-draggable-groups:hover span,
.V3 .estimates-edit .disabled-draggable-groups:hover div,
.V3 .estimates-edit .disabled-draggable-groups:hover i {
  cursor: not-allowed !important;
}

.V3 .estimates-edit .ignore-item:hover,
.V3 .estimates-edit .ignore-item:hover input,
.V3 .estimates-edit .ignore-item:hover span,
.V3 .estimates-edit .ignore-item:hover div,
.V3 .estimates-edit .ignore-item:hover i {
  cursor: not-allowed !important;
}

.V3 .estimates-edit .mr-15px {
  margin-right: 15px !important;
}

.V3 .estimates-edit .tabs-component-tab.with-ps-logo {
  padding-right: 2px !important;
}

.estimates-edit .estimate-items .disabled-draggable .qtit:hover {
  cursor: default;
}

.estimates-edit .estimate-items .disabled-draggable .selected-row {
  border: none !important;
  box-shadow: none !important;
  border-radius: 0px !important;
}

.no-select, .no-select * {
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}
</style>

<style scoped>
.mobile-custom-menu {
  position: relative;
  z-index: 9999;
  left: 115px;
  width: 200px;
}

.mobile-custom-menu-item {
  font-size: 12px;
  margin: 3px 0;
  border-radius: 3px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  padding: 3px 10px;
}

.mobile-custom-menu-item:active {
  background-color: rgba(28, 31, 57, 0.1);
}

.nav-chevron-block div {
  display: none !important;
}

.nav-chevron-block div.active {
  display: block !important;
}

.nav-chevron-block {
  position: sticky;
  top: 142px;
  z-index: 1001;
}

.nav-chevron-block .bx {
  font-size: 25px;
}

.nav-chevron-block div {
  padding: 11px 5px;
  display: inline;
  background-color: white;
}

.nav-chevron-block div:first-child {
  position: absolute;
  padding-right: 10px;
  top: 0px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 35%, rgba(0, 212, 255, 0) 100%);
}

.nav-chevron-block div:last-child {
  padding-left: 10px;
  position: absolute;
  top: 0px;
  right: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 65%, rgba(255, 255, 255, 1) 100%);
}

.tab-header-orders.active {
  background: linear-gradient(135deg, rgb(114, 103, 231) 0%, rgb(98, 89, 239) 49.12%, rgb(78, 69, 238) 100%);
  color: #f8f8f8;
}

.tab-header-orders {
  border: 1px solid rgb(94, 121, 255);
  color: rgb(94, 121, 255);
  font-weight: bold;
}

.estimate-items-name-part {
  max-width: 254px;
}

@media (min-width: 1920px) {
  .estimate-items-name-part {
    max-width: 100%;
  }
}

.btn-part-pricing {
  height: 30px;
  line-height: 0;
  margin-left: 50px;
  padding-right: 30px;
  position: relative;
  animation: partBlinked 1.5s linear infinite alternate;
}

.btn-part-pricing:hover {
  animation: none;
}

.btn-part-pricing-ps-logo {
  height: 15px;
  width: 15px;
  position: absolute;
  right: 10px;
  top: 5px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../../../mjml/img/PS_Extension__128x128_pixels.svg");
}

.part-ps-logo {
  height: 15px;
  width: 15px;
  position: absolute;
  top: 13px;
  left: 50px;
  background-repeat: no-repeat;
  background-size: cover;
  animation: partBlinked 1.5s linear infinite alternate;
  background-image: url("../../../../mjml/img/PS_Extension__128x128_pixels.svg");
}

@keyframes partBlinked {
  from {
    opacity: 1; /* Непрозрачный текст */
  }
  to {
    opacity: 0.3; /* Прозрачный текст */
  }
}

.date-picker-max-width-100px >>> .form-control {
  max-width: 100px;
}

.h-66px {
  height: 66px !important;
}

.autorise-estimate-table {
  /*margin-bottom: 50px;*/
  max-height: 65vh;
  overflow-y: auto;
  scrollbar-width: thin;
}

.part-table-min-width {
  min-width: 1080px;
  padding-bottom: 145px !important;
}

.pdr-table-min-width {
  min-width: 1010px;
  padding-bottom: 75px !important;
}

.paint-table-min-width {
  min-width: 920px;
  padding-bottom: 140px !important;
}

.others-table-min-width {
  min-width: 870px;
}

.authorise-estimate-header {
  margin-bottom: 15px;
}

.authorise-estimate-header button {
  margin-right: 15px;
  padding: 7px 15px;
}

.authorise-estimate-title {
  font-weight: 700;
  font-size: 14px;
  margin: 5px auto;
}

.authorise-estimate-cancel {
  background-color: #fdfdfd;
  color: #5d78fd;
}

.authorise-estimate-cancel:hover {
  background-color: #fdfdfd;
}

.comment-fixed-position {
  top: -88px !important;
}

.gray-background {
  background-color: #f9f9f9 !important;
}

.selected-group {
  color: #000000 !important;
}

.border-top-groups {
  border-top: 1px solid rgba(0, 0, 0, 0.25);
}

.border-bottom-groups {
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
}

.new-estimate-group-item {
  padding: 1rem 0.5rem 1rem 1.5rem;
  border: none;
  max-width: 77%;
}

.estimate-group-item {
  border-top: 1px solid rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.estimate-group-item:hover {
  background-color: rgb(237, 239, 253) !important;
  cursor: pointer;
}

.estimate-group-item:hover .estimate-group-item-input {
  background-color: rgb(237, 239, 253) !important;
  cursor: pointer;
}

.estimate-group-item-input {
  width: 78%;
  padding: 8px 0.5rem 8px 1.5rem;
  border: none;
  color: #000000;
  font-weight: 700;
}

.estimate-group-subitem-input {
  padding-right: 10px;
  border: none;
  width: 100%;
  color: #000000;
  /*color: #777777;*/
}

.estimate-group-sub-item {
  border-left: 1px solid rgba(0, 0, 0, 0.25);
  /*margin-left: 10%;*/
  list-style: none;
  padding: 8px 0.5rem 8px 1rem;
  cursor: pointer;
}

.drag-group-items {
  margin-left: 10%;
}

.estimate-group-sub-item:hover {
  background-color: #F9F9F9;
  cursor: pointer;
}

.estimate-group-sub-item:hover .estimate-group-subitem-input {
  background-color: #F9F9F9;
  cursor: pointer;
}

.right-col {
  margin-top: 5px;
  margin-right: 8px;
}

@media (max-width: 1500px) {
  .right-col {
    margin-top: 15px;
  }
}

@media (max-width: 1300px) {
  .estimate-item-list-height {
    width: 100%;
  }
}

@media screen and (max-width: 1000px) and (orientation: landscape) {
  .V3 .nav-chevron-block {
    display: none;
  }
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.tab-content {
  padding: 10px 0;
}

.color-dark-grey {
  color: #3F3F3F !important
}

.fz16 {
  font-size: 16px !important
}

.w50 {
  width: 50%
}

.vat {
  vertical-align: top
}

.m0 {
  margin: 0 !important
}

.border-b {
  border-bottom: 1px solid silver !important
}

.border-t {
  border-top: 1px solid silver !important
}

.bg-white {
  background: #FFFFFF !important
}

.th-fz12 th {
  font-size: 12px !important
}

.invoice {
  width: 820px;
  margin: 25px auto
}

.invoice-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.invoice .main-table {
  margin: 0 0 20px;
  width: 100%;
  border-collapse: collapse
}

.invoice .main-table tr.empty-row td, .invoice .main-table tr.empty-row th {
  height: 20px
}

.invoice .main-table .vehicle-details {
  width: 100%
}

.invoice .parts-required {
  margin-bottom: 0
}

.invoice .parts-required td:nth-child(1), .invoice .parts-required th:nth-child(1) {
  width: 355px
}

.invoice .parts-required td:last-child, .invoice .parts-required th:last-child {
  width: 70px
}

.invoice .estimate-repairs td:first-child, .invoice .estimate-repairs th:first-child {
  width: 550px
}

.invoice .estimate-repairs td:nth-child(2), .invoice .estimate-repairs th:nth-child(2) {
  width: 55px
}

.invoice .estimate-repairs td:last-child, .invoice .estimate-repairs th:last-child {
  width: 70px
}

.invoice .estimate-other td:first-child, .invoice .estimate-other th:first-child {
  width: 550px
}

.invoice .estimate-other td:nth-child(2), .invoice .estimate-other th:nth-child(2) {
  width: 55px
}

.invoice .estimate-other td:last-child, .invoice .estimate-other th:last-child {
  width: 70px
}

.invoice .estimate-sublet td:first-child,
.invoice .estimate-sublet th:first-child,
.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-sublet td:last-child,
.invoice .estimate-sublet th:last-child {
  width: 70px
}

.invoice .estimate-parts td:first-child, .invoice .estimate-parts th:first-child {
  width: 400px
}

.invoice .estimate-parts td:nth-child(2), .invoice .estimate-parts th:nth-child(2) {
  width: 150px
}

.invoice .estimate-parts td:nth-child(3), .invoice .estimate-parts th:nth-child(3) {
  width: 55px
}

.invoice .estimate-parts td:last-child, .invoice .estimate-parts th:last-child {
  width: 70px
}

.invoice .estimate-pdr th:first-child {
  width: 605px
}

.invoice .estimate-pdr th:nth-child(2),
.invoice .estimate-pdr th:nth-child(3) {
  width: 9rem;
}

.invoice .estimate-pdr th:nth-child(5),
.invoice .estimate-pdr th:last-child {
  width: 86px;
}

.invoice .parts-total td:last-child {
  width: 70px;
  padding-left: 15px
}

.invoice .tax-subtotal-hrs td:first-child {
  width: 560px
}

footer {
  clear: both
}

.footer-table {
  width: 100%;
  border-top: 1px solid silver;
  border-bottom: 1px solid silver
}

.footer-table td, .footer-table th {
  text-align: left
}

.footer-table th {
  padding: 16px 8px 10px;
  font-size: 12px
}

.footer-table td {
  padding: 0 8px 16px;
  font-size: 11px;
  color: #595959
}

#parts-details {
  margin-top: -11px;
}

#parts-details .btn-outline-primary:hover {
  background-color: #E0EAF6;
  color: #0275D8;
}

#parts-details .btn-outline-primary.active:hover {
  background-color: #3E70C9;
}

.timeline {
  padding-left: 15px;
}

.V3 .estimates-edit .dropzoneContainer {
  margin: 5px 15px;
  width: auto;
  border: 1px dashed rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  background: white !important;
  min-width: 125px;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message span.file-icon:before {
  content: '\E800';
  font-weight: 800;
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .dropify-wrapper .dropify-message .drop-down-text {
  font-family: "Nunito Sans";
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
}

.btnNotBorder {
  border-color: #FAFAFA !important;
}

.btnNotBorder:hover {
  background-color: #FAFAFA !important;
  color: #142742 !important;
}

.btnNotBorder .fa-sort-down {
  left: unset !important;
  margin: 0 !important;
  top: 5px !important;
  font-size: 14px !important;
  width: 20px !important;
  height: auto !important;
}

.dropdownLinks-container {
  flex-direction: column;
  position: absolute;
  border: none;
  background-color: #FAFAFA;
  right: 20px;
  top: 28px;
  height: auto;
  padding: 0;
  margin: 0;
}

.dropdownLinks-links {
  position: relative;
  background: white;
  border: 1px solid #B8B8B8;
}

.dropdownLinks-links:after,
.dropdownLinks-links:before {
  bottom: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.dropdownLinks-links:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #FFFFFF;
  border-width: 5px;
  right: 12px;
  background-clip: padding-box;
}

.dropdownLinks-links:before {
  border-color: rgba(184, 184, 184, 0);
  border-bottom-color: #B8B8B8;
  border-width: 6px;
  right: 11px;
  background-clip: padding-box;
}

.activtyPopupIcon {
  position: unset !important;
  margin: 0 !important;
  font-size: 10px !important;
}

.box-block-grey {
  background: #F1F1F1;
}

.select-parts-check-all {
  font-weight: 500;
  margin-top: 8px;
}

.select-parts-check-all input {
  transform: translateX(calc(50% + 2px));
}

.select-parts-check-all label {
  transform: translateX(8px);
}

#SelectImages4 {
  background: #F1F1F1;
  margin-top: -15px;
  margin-bottom: 30px;
}

.vertical-top {
  vertical-align: top;
}

.vertical-middle {
  vertical-align: middle;
}

.autosave {
  color: #142742;
  font-size: 13px;
  margin-left: 100px;
}

.vue-form-wizard.xs {
  padding-bottom: 0px !important;
  overflow: auto;
}

.wizard-nav {
  overflow: hidden;
}

.vue-form-wizard .wizard-nav-pills a, .vue-form-wizard .wizard-nav-pills li {
  max-width: 89px;
}

.vue-form-wizard .wizard-nav-pills {
  flex-wrap: nowrap;
}

.vue-form-wizard.xs .wizard-icon-circle {
  width: 30px !important;
  height: 30px !important;
}

#activity .wizard-progress-with-circle {
  background-color: rgba(27, 30, 56, 0.12);
  border-radius: 5px;
  /* to keep border radius */
  overflow: hidden;
}

#activity .wizard-icon-circle {
  border: 2px solid #DCDCDC;
}

#activity .active .wizard-icon-circle {
  background: #142742;
}

#activity .wizard-icon-circle ~ .stepTitle {
  color: #B9B9B9;
}

#activity .vue-form-wizard .wizard-tab-content {
  min-height: 1px;
  padding-bottom: 0;
  border-top: 1px solid transparent;
  margin-top: 0px;
  padding: 5px;
}


.wizard-icon.ti-check {
  font-weight: bold;
}

.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  height: 2px !important;
  top: 19px !important;
}

.vue-form-wizard.xs .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 12px !important;
  color: #5E79FF;
}

.wizard-navigation {
  overflow-x: auto;
}

#activity .wizard-navigation {
  float: left;
  margin-top: 18px;
  margin-left: 0;
}

.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 50%;
}

#activity .vue-form-wizard .wizard-header {
  padding: 15px 30px;
  padding-bottom: 0px;
}

#activity .wizard-icon-circle ~ .stepTitle {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 38px;
}

.card-block {
  position: relative;
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 10px;
}

@media screen and (max-width: 991px) {
  .tabs-absolute-right {
    position: relative;
    top: 0px;
    right: 0;
    z-index: 99;
    float: left;
  }
}

.styled-tabs {
  width: 302px;
  border: 1px solid #142742;
  border-radius: 3px;
}

.styled-tabs .nav-link {
  width: 150px;
  text-align: center;
  border: none;
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  padding: 0.3em 0;
}

.styled-tabs .nav-item .active {
  background: #142742;
  color: #FFFFFF;
}

.styled-tabs .nav-item .active:focus {
  background: #142742;
  color: #FFFFFF;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(-10px);
  opacity: 0;
}

table.main-total-table td.right {
  text-align: right;
}

.estimate_amount {
  border: 1px solid rgba(0, 0, 0, .125);
}

.header_estim_amount h4 {
  width: 60%;
  margin-bottom: 0px;
}

.header_estim_amount h4.amountValue {
  width: 40%;
  margin-bottom: 0px;
}

.header_estim_amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, .125);
}

.body_estim_amount {
  padding: 0 10px;
}

.body_estim_amount > ul > li > span:first-child {
  width: 60%;
}

.body_estim_amount > ul > li > span:last-child {
  width: 40%;
}

.body_estim_amount > ul > li {
  display: flex;
  padding: 5px 0;
  justify-content: space-between;
  align-items: center;
}

.body_estim_amount > ul {
  margin-bottom: 0;
  padding: 0;
}

.filterAssigned:before {
  top: -19px;
  border-color: transparent transparent transparent #BDBDBD;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after {
  top: -18px;
  border-color: transparent transparent transparent #FFFFFF;
  border-width: 9px;
  left: 30px;
}

.filterAssigned:after, .filterAssigned:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  transform: rotate(-90deg);
}

.saveAsTemplateList li {
  border-bottom: none !important;
}

.addTemplateList li {
  border-bottom: none !important;
}

.tabs-component ul > li .loaderAssignTo {
  position: absolute;
  max-width: 30px;
  top: 5px;
  right: -36px;
}

.tabs-component ul > li {
  position: relative;
}

.searchInput {
  width: calc(100% - 20px);
}

.filterAssigned > input {
  border: 1px solid rgba(27, 30, 56, .25);
  padding: 2px 7px;
  /*added*/
  margin: 0px 7px;
  width: 90% !important;
  border-radius: 5px;
}

.filterAssigned > ul > li {
  padding: 5px 10px;
  cursor: pointer;
  font-weight: bold !important;

}

.filterAssigned > ul > li:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
  border-bottom: 1px solid transparent;
  font-weight: bold !important;
}

.li-in-save-as-template:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
  color: #5E79FF !important;
}

.filterAssigned > ul {
  padding: 0;
  height: auto;
  max-height: 300px;
  overflow: auto;
  margin-top: 4px;
}

.filterAssigned {
  position: absolute;
  left: 0;
  z-index: 9999;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 5px 0px;
  transition: 0.4s;
  top: 100%;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  width: auto;
  min-width: 190px;
  max-width: 300px;
}

.context-level {
  width: 100% !important;
  left: calc(100% + 1px) !important;
}

.openFilterAssigned {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}

.V3 .tab-pane {
  background: white;
}

.V3 .container-fluid .row .col-md-3 {
  padding: 0px !important;
}

.V3 .container-fluid .row .col-md-9 {
  padding: 0px !important;
}

.V3 .template-tabs.mt-2 .nav-tabs.nav-tabs-2:first {
  margin-bottom: 0px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.V3 ul.nav.nav-4 {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  margin-right: 10px;
  scrollbar-width: thin;
}

.V3 ul.nav.nav-4 li {
  position: relative;
}

.V3 ul.nav.nav-4 .nav-item.active {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active a:focus {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active .nav-link {
  color: #5E79FF;
}

.V3 ul.nav.nav-4 .nav-item.active::after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 100%;
  width: 5px;
  border-radius: 0 5px 5px 0;
  background-color: #5E79FF;;
}

.V3 ul.nav.nav-4 .nav-item .nav-link {
  font-weight: 700;
  color: black;
  padding-top: 8px;
  padding-bottom: 8px;
}

.V3 ul.nav.nav-4 .nav-item .nav-link:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 .tab-pane .col-md-5 .col-md-6 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.V3 .new-estimate-item {
  color: #5E79FF !important;
  font-weight: 700;
}

.V3 .new-estimate-item i {
  color: #5E79FF !important;
  font-weight: 700;
}

.V3 .nav-4 .nav-link {
  color: black;
  padding-top: 8px;
  padding-bottom: 8px;
}

.V3 .nav-4 .ripple-container .nav-link:hover {
  background-color: transparent;
}

.V3 .nav-4 .ripple-container:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 .nav-4 .nav-link .float-xs-right i.fa-angle-right{
  margin-right:-1.5rem;
}

.V3 .search-input {
  background: url('data:image/svg+xml;base64,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') no-repeat center right;
  background-position: right 7px center;
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 6px 6px 1px 1px;
  font-weight: 700 !important;
  color: #696969;
}

.V3 .search-input::placeholder {
  font-weight: 700 !important;
  color: black;
}

.V3 .search-input:focus {
  width: 100% !important;
}

@media screen and (max-width: 767px) {
  .V3 .active.ml-2 {
    margin-left: 0 !important;
  }

  .nav-tabs {
    display: flex;
    align-items: flex-start;
  }

  .nav-tabs li a {
    white-space: nowrap;
  }

  .V3 .tabs-component::after {
    height: 5px;
    padding-right: 0;
    display: block;
    background-color: white;
  }

  .V3 .tabs-component .tab-header {
    padding-bottom: 0;
  }

  .tabs-component {
    overflow-x: scroll;
    overflow-y: hidden;
    border-bottom: 5px solid #e3e4e7 !important;
  }

  .tab-header-orders {
    margin: 10px 10px 0;
  }
}

.V3 .left-side {
  background: #DFEBF8;
  padding-bottom: 110px;
}

.V3 .left-side hr {
  width: 100%;
  border-bottom: 2px solid #C0D8EF;
  margin: 20px 0;
}

.V3 .left-side h3 {
  color: #142742;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.V3 .p-20 {
  padding: 20px;
}

.V3 .mt-3 {
  margin-top: 2.3rem !important;
}

.V3 .btn.btn-primary.mt-1.mb-1 {
  margin-bottom: 0.5rem;
}

.V3 .filed-md {
  display: block;
  width: 100%;
  background: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #DDDDDD;
  padding: 15px;
}

.V3 .filed-md::placeholder {
  color: #818A91;
  font-size: 14px;
  font-weight: 600;
}

.V3 .search-field {
  padding-left: 45px;
}

.V3 .search-label {
  position: absolute;
}

.V3 .search-label i {
  position: relative;
  display: block;
  font-size: 20px;
  color: #818A91;
  transform: translate(15px, 17px);
}

.V3 .left-side-nav {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.V3 .left-side-nav li {
  display: flex;
  justify-content: space-between;
  color: #142742;
  font-size: 14px;
  padding: 13px 20px;
  -webkit-transition: 0.2s linear;
  -moz-transition: 0.2s linear;
  -o-transition: 0.2s linear;
  transition: 0.2s linear;
}

.V3 .left-side-nav li:hover {
  background: #EFF5FA;
  color: #0672C3;
}

.V3 .left-side-nav li.active {
  background: #EFF5FA;
}

.V3 .left-side-nav button {
  cursor: pointer;
  width: 20px;
  padding: 0;
  margin-left: 5px;
}

.V3 .left-side-nav i {
  font-size: 20px;
  margin-left: 10px;
}

.V3 .left-side-nav .ti-write {
  color: #142742;
}

.V3 .left-side-nav .ti-trash {
  color: #D0021B;
}

.V3 .nav-tabs.nav-tabs-2 {
  /* border: none;*/
  /*   height: 50px; */
}

.V3 .estimate-items th {
  height: 48px;
  background-color: rgba(27, 30, 56, 0.1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: bold;
  line-height: 18px;
}

.V3 .estimates-edit .browse-btn {
  height: 38px;
  width: 126px;
  border-radius: 3px;
  background-color: #5E79FF;
  color: white;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit .cancel-btn {
  box-sizing: border-box;
  height: 39px;
  width: 127px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-images .bx {
  font-size: 37px;
  color: #5E79FF;
}

.V3 .estimates-edit .text-or {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-weight: 700;
  opacity: 0.25;
  font-size: 13px;
}

.V3 .estimates-edit .tab-content {
  padding-left: 0;
}

.V3 .estimates-edit .pin-checkmark {
  background-color: #FFFFFF;
}

.V3 .estimates-edit #upload-files .dnd-or {
  opacity: 0.25;
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files .dnd-title {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 13px;
  font-weight: bold;
}

.V3 .estimates-edit #upload-files i {
  font-size: 37px;
  color: #5E79FF
}

.tabs-absolute-right {
  display: inline-flex;
  margin-right: 30px;
}

.V3 .estimates-edit-page .col-form-label {
  padding: 8px 0;
}

.V3 .estimates-edit-page .pin-image {
  align-items: center;
  position: relative;
  color: #34495E;
  height: 27px;
  font-weight: 600;
  font-size: 13px;
  padding-top: 8px;
  padding-left: 35px;
  margin-bottom: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

/* Hide the browser's default checkbox */
.V3 .estimates-edit-page .pin-image input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create the checkmark/indicator (hidden when not checked) */
.V3 .estimates-edit-page .pin-checkmark i {
  margin: auto;
  width: 16px;
  display: none;
  font-size: 26px;
  color: white;
  margin-left: -2px;
  margin-top: -2px;
}

/* Show the checkmark when checked */
.V3 .estimates-edit-page .pin-image input:checked ~ .pin-checkmark i {
  display: block;
}

.V3 .estimates-edit-page .card-block {
  padding: 13px;
  overflow: auto;
}

.V3 .estimates-edit-page .shop-bold {
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
}

.V3 .estimates-edit-page .shop-bold .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .shop-light {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.V3 .estimates-edit-page .shop-light .col-sm-7 {
  padding-left: 0;
}

.V3 .estimates-edit-page .progress {
  border-top: 1px solid rgba(27, 30, 56, 0.25);
  padding-top: 15px;
}

.V3 .estimates-edit-page .progress h2 {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
}

.V3 .estimates-edit-page .progress .full-activity {
  color: #5E79FF;
  font-size: 13px;
  font-weight: 600;
}

.tabs-absolute-right-notes-btn {
  margin-right: 160px;
}

.button.button.button--light {
  position: relative;
  cursor: pointer;
  border: 0px;
}

.button.button.button--light:active {
  top: 1px;
}

.pdr-menu {
}

.pdr-menu__item {
  position: relative;
}

.pdr-menu__button {
  cursor: pointer;
  border: 0px;
  padding: 0px;
  background: transparent;
}

.pdr-menu__comment {
  position: absolute;
  display: none;
  border-radius: 5px;
  overflow: hidden;
  right: -65%;
  top: 10px;
  background-color: #FFFFFF;

  /* copied from vue-context */
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

}

.pdr-menu__item.has-comment:hover .pdr-menu__comment,
.pdr-menu__item.has-comment:focus .pdr-menu__comment,
.pdr-menu__item.has-comment:active .pdr-menu__comment {
  display: flex;
}

.pdr-menu__comment textarea {
  min-height: 100px;
  width: 174px;
  border: 0px;
  padding: 10px;
}

.pdr-visible-icon {
  position: relative;
}

.disabled.pdr-visible-icon:after {
  display: none;
}

.pdr-visible-icon:after {
  content: '/';
  display: grid;
  place-items: center;
  position: absolute;
  top: -5px;
  left: -1px;
  font-weight: 900;
  font-size: 28px;
  transform: rotate(300deg);
  width: 24px;
  height: 24px;
  overflow: hidden;
  text-shadow: -1px -2px #DDDDDD;
}

.V3 .estimates-edit-page.is-mobile .form-control {
  padding-right: 20px !important;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link {
  padding: .5rem .35rem;
}

.V3 .estimates-edit-page.is-mobile .nav-4 .nav-link i {
  margin-right: .35rem;
}

@media screen and (min-width: 768px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 410px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 991px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 370px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1024px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 430px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1300px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 340px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1515px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 390px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1580px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 360px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

@media screen and (min-width: 1820px) {
  .V3 .vh-height-65 {
    height: calc(100vh - 330px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

@media (max-width: 991px) {
  .col-lg-8 {
    float: right;
    width: 66.666667%;
  }
}

.error-text {
  color: red !important;
}

.white-text {
  color: white !important;
}

.nav-title {
  padding: 10px 15px 0 15px;
}

.invoice .main-table tbody td, .invoice .main-table tfoot td {
  padding: 5px 10px;
}

@media screen and (max-width: 767px) {
  .nav-title {
    padding: 0 10px 0 15px;
  }
}

@media screen and (max-width: 767px) {
  .reset-padd {
    padding-right: 0px;
  }

  .add-padd-mobile {
    padding-right: 15px;
    padding-left: 15px;
  }

  .padd-left-15 {
    padding-left: 15px !important;
  }

  .checkbox-group {
    flex-direction: column;
  }
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-p {
  padding-bottom: 10px;
  padding-right: 10px;
}

.close-edit-cursor {
  cursor: not-allowed;
}

@media (min-width: 1400px) {
  .numeric-qty {
    min-width: 2.5rem !important;
  }
}

@media screen and (max-width: 991px) {
  .invoice-header {
    flex-direction: column;
  }

  .table-fixed {
    table-layout: fixed;
  }

  .vat {
    display: block;
  }

  .owner-details tr {
    padding-left: 5px;
  }

  .invoice {
    width: 540px;
  }

  .main-flex {
    display: flex;
    flex-direction: column;
  }

  .mobile-disabled {
    display: none;
  }

  .invoice .main-table .vehicle-details td,
  .invoice .main-table .main-inner td {
    padding: 5px 0;
  }
}

@media screen and (max-width: 767px) {
  .invoice-header {
    flex-direction: column;
  }

  .invoice .main-total-table {
    float: left;
  }
}

@media screen and (max-width: 576px) {
  .invoice {
    width: 95%;
  }

  .invoice .main-table thead th {
    padding: 8px 5px;
  }

  .invoice .main-table tbody td, .invoice .main-table tfoot td {
    padding: 5px 0;
  }

  .block-position-wrap {
    flex-wrap: wrap;
    padding-left: 15px;
    justify-content: flex-end;
  }

  .V3 .estimates-edit-page .col-form-label {
    padding-left: 0 !important;
    text-align: left !important;
    min-width: 48px !important;
  }

  .V3 .estimates-edit-page.is-mobile .form-control {
    padding: 0.5rem 5px !important;
  }
}

.V3 .card-header {
  min-height: 48px;
  height: auto;
  align-items: center;
  transform: none;
}


.V3 .card-header {
  padding: 5px 15px !important;
}

.additional-menu-icon {
  position: absolute;
  right: 10px;
  top: 13px;
}

.trash-icon {
  cursor: pointer;
}

.estimate-item-comment {
  position: absolute;
  border-radius: 5px;
  overflow: hidden;
  width: 148px !important;
  height: 121px !important;
  left: 177px !important;
  background-color: #FFFFFF;
  border: 1px solid #BDBDBD;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%), 0 1px 5px 0 rgb(0 0 0 / 12%);
}

.estimate-item-comment textarea {
  height: 119px;
  width: 146px;
  border: none;
  padding: 0.75rem;
  resize: none;
}

.comment-limit-text {
  position: absolute;
  bottom: -5px;
  left: 6px;
  color: #A2ABAE;
}

.save-comment-icon {
  position: absolute;
  bottom: 7px;
  left: 124px;
  font-size: 27px;
  color: #73716C;
}

.save-comment-icon:hover {
  color: #5E79FF;
}

@media screen and (max-width: 1670px) {
  .additional-padding-btn {
    padding-bottom: 10px;
  }
}

.tooltip {
  top: 32px !important;
}

.estimate-items-title {
  height: 48px;
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
}

.estimate-items-title-content {
  padding: 0.75rem;
  width: 70px;
  flex-grow: 0;
}

#estimate-item-list .estimate-items .has-line {
  margin-bottom: 34px;
}

#estimate-item-list .estimate-items .has-line-x2 {
  margin-bottom: 75px;
}

#estimate-item-list .estimate-items .comment-block {
  position: absolute;
  left: 0px;
  width: 100%;
  margin-top: 55px;
  padding-left: 0px;
}

#estimate-item-list .estimate-items .comment-block .comment-text {
  height: 32px;
  padding-left: 20px;
  padding-top: 4px;
  color: #FE9600;
}

#estimate-item-list .estimate-items .comment-block .comment-text span,
#estimate-item-list .estimate-items .comment-block .estimate-comment-text span {
  font-weight: bold;
}

#estimate-item-list .estimate-items .comment-block .estimate-comment-text {
  height: 32px;
  padding-left: 20px;
  padding-top: 4px;
  color: #3CD6B2;
}

#estimate-item-list .estimate-items {
  padding-bottom: 30px !important;
}
</style>
